import { G as GlobalCssClass, F as FormElementType, S as SystemValidationStatus, T as TextFieldType, P as PaddingSize, L as LoggerLevels, D as DisplayMode, e as PopperAlign, a as FieldErrorType } from './enums-de7de3ea.js';
import { r as registerInstance, h, a as Host, c as createEvent, g as getElement } from './index-b0bf42a1.js';

/* istanbul ignore file */


// normalize-selector-rev-02.js
/*
  author: kyle simpson (@getify)
  original source: https://gist.github.com/getify/9679380

  modified for tests by david kaye (@dfkaye)
  21 march 2014

  rev-02 incorporate kyle's changes 3/2/42014
*/

function normalizeSelector(sel) {
  // save unmatched text, if any
  function saveUnmatched() {
    if (unmatched) {
      // whitespace needed after combinator?
      if (tokens.length > 0 && /^[~+>]$/.test(tokens[tokens.length - 1])) {
        tokens.push(" ");
      }

      // save unmatched text
      tokens.push(unmatched);
    }
  }

  var tokens = [],
    match,
    unmatched,
    regex,
    state = [0],
    next_match_idx = 0,
    prev_match_idx,
    not_escaped_pattern = /(?:[^\\]|(?:^|[^\\])(?:\\\\)+)$/,
    whitespace_pattern = /^\s+$/,
    state_patterns = [
      /\s+|\/\*|["'>~+[(]/g, // general
      /\s+|\/\*|["'[\]()]/g, // [..] set
      /\s+|\/\*|["'[\]()]/g, // (..) set
      null, // string literal (placeholder)
      /\*\//g, // comment
    ];
  sel = sel.trim();

  // eslint-disable-next-line no-constant-condition
  while (true) {
    unmatched = "";

    regex = state_patterns[state[state.length - 1]];

    regex.lastIndex = next_match_idx;
    match = regex.exec(sel);

    // matched text to process?
    if (match) {
      prev_match_idx = next_match_idx;
      next_match_idx = regex.lastIndex;

      // collect the previous string chunk not matched before this token
      if (prev_match_idx < next_match_idx - match[0].length) {
        unmatched = sel.substring(
          prev_match_idx,
          next_match_idx - match[0].length
        );
      }

      // general, [ ] pair, ( ) pair?
      if (state[state.length - 1] < 3) {
        saveUnmatched();

        // starting a [ ] pair?
        if (match[0] === "[") {
          state.push(1);
        }
        // starting a ( ) pair?
        else if (match[0] === "(") {
          state.push(2);
        }
        // starting a string literal?
        else if (/^["']$/.test(match[0])) {
          state.push(3);
          state_patterns[3] = new RegExp(match[0], "g");
        }
        // starting a comment?
        else if (match[0] === "/*") {
          state.push(4);
        }
        // ending a [ ] or ( ) pair?
        else if (/^[\])]$/.test(match[0]) && state.length > 0) {
          state.pop();
        }
        // handling whitespace or a combinator?
        else if (/^(?:\s+|[~+>])$/.test(match[0])) {
          // need to insert whitespace before?
          if (
            tokens.length > 0 &&
            !whitespace_pattern.test(tokens[tokens.length - 1]) &&
            state[state.length - 1] === 0
          ) {
            // add normalized whitespace
            tokens.push(" ");
          }

          // case-insensitive attribute selector CSS L4
          if (
            state[state.length - 1] === 1 &&
            tokens.length === 5 &&
            tokens[2].charAt(tokens[2].length - 1) === "="
          ) {
            tokens[4] = " " + tokens[4];
          }

          // whitespace token we can skip?
          if (whitespace_pattern.test(match[0])) {
            continue;
          }
        }

        // save matched text
        tokens.push(match[0]);
      }
      // otherwise, string literal or comment
      else {
        // save unmatched text
        tokens[tokens.length - 1] += unmatched;

        // unescaped terminator to string literal or comment?
        if (not_escaped_pattern.test(tokens[tokens.length - 1])) {
          // comment terminator?
          if (state[state.length - 1] === 4) {
            // ok to drop comment?
            if (
              tokens.length < 2 ||
              whitespace_pattern.test(tokens[tokens.length - 2])
            ) {
              tokens.pop();
            }
            // otherwise, turn comment into whitespace
            else {
              tokens[tokens.length - 1] = " ";
            }

            // handled already
            match[0] = "";
          }

          state.pop();
        }

        // append matched text to existing token
        tokens[tokens.length - 1] += match[0];
      }
    }
    // otherwise, end of processing (no more matches)
    else {
      unmatched = sel.substr(next_match_idx);
      saveUnmatched();

      break;
    }
  }

  return tokens.join("").trim();
}

/**
 * @author Georgegriff@ (George Griffiths)
 * License Apache-2.0
 */

/**
* Finds first matching elements on the page that may be in a shadow root using a complex selector of n-depth
*
* Don't have to specify all shadow roots to button, tree is travered to find the correct element
*
* Example querySelectorAllDeep('downloads-item:nth-child(4) #remove');
*
* Example should work on chrome://downloads outputting the remove button inside of a download card component
*
* Example find first active download link element querySelectorDeep('#downloads-list .is-active a[href^="https://"]');
*
* Another example querySelectorAllDeep('#downloads-list div#title-area + a');
e.g.
*/
function querySelectorAllDeep(selector, root = document, allElements = null) {
    return _querySelectorDeep(selector, true, root, allElements);
}

function querySelectorDeep(selector, root = document, allElements = null) {
    return _querySelectorDeep(selector, false, root, allElements);
}

function _querySelectorDeep(selector, findMany, root, allElements = null) {
    selector = normalizeSelector(selector);
    let lightElement = root.querySelector(selector);

    if (document.head.createShadowRoot || document.head.attachShadow) {
        // no need to do any special if selector matches something specific in light-dom
        if (!findMany && lightElement) {
            return lightElement;
        }

        // split on commas because those are a logical divide in the operation
        const selectionsToMake = splitByCharacterUnlessQuoted(selector, ',');

        return selectionsToMake.reduce((acc, minimalSelector) => {
            // if not finding many just reduce the first match
            if (!findMany && acc) {
                return acc;
            }
            // do best to support complex selectors and split the query
            const splitSelector = splitByCharacterUnlessQuoted(minimalSelector
                    //remove white space at start of selector
                    .replace(/^\s+/g, '')
                    .replace(/\s*([>+~]+)\s*/g, '$1'), ' ')
                    // filter out entry white selectors
                    .filter((entry) => !!entry)
                    // convert "a > b" to ["a", "b"]
                    .map((entry) => splitByCharacterUnlessQuoted(entry, '>'));

            const possibleElementsIndex = splitSelector.length - 1;
            const lastSplitPart = splitSelector[possibleElementsIndex][splitSelector[possibleElementsIndex].length - 1];
            const possibleElements = collectAllElementsDeep(lastSplitPart, root, allElements);
            const findElements = findMatchingElement(splitSelector, possibleElementsIndex, root);
            if (findMany) {
                acc = acc.concat(possibleElements.filter(findElements));
                return acc;
            } else {
                acc = possibleElements.find(findElements);
                return acc || null;
            }
        }, findMany ? [] : null);


    } else {
        if (!findMany) {
            return lightElement;
        } else {
            return root.querySelectorAll(selector);
        }
    }

}

function findMatchingElement(splitSelector, possibleElementsIndex, root) {
    return (element) => {
        let position = possibleElementsIndex;
        let parent = element;
        let foundElement = false;
        while (parent && !isDocumentNode(parent)) {
            let foundMatch = true;
            if (splitSelector[position].length === 1) {
                foundMatch = parent.matches(splitSelector[position]);
            } else {
                // selector is in the format "a > b"
                // make sure a few parents match in order
                const reversedParts = ([]).concat(splitSelector[position]).reverse();
                let newParent = parent;
                for (const part of reversedParts) {
                    if (!newParent || !newParent.matches(part)) {
                        foundMatch = false;
                        break;
                    }
                    newParent = findParentOrHost(newParent, root);
                }
            }

            if (foundMatch && position === 0) {
                foundElement = true;
                break;
            }
            if (foundMatch) {
                position--;
            }
            parent = findParentOrHost(parent, root);
        }
        return foundElement;
    };

}

function splitByCharacterUnlessQuoted(selector, character) {
    return selector.match(/\\?.|^$/g).reduce((p, c) => {
        if (c === '"' && !p.sQuote) {
            p.quote ^= 1;
            p.a[p.a.length - 1] += c;
        } else if (c === '\'' && !p.quote) {
            p.sQuote ^= 1;
            p.a[p.a.length - 1] += c;

        } else if (!p.quote && !p.sQuote && c === character) {
            p.a.push('');
        } else {
            p.a[p.a.length - 1] += c;
        }
        return p;
    }, { a: [''] }).a;
}

/**
 * Checks if the node is a document node or not.
 * @param {Node} node
 * @returns {node is Document | DocumentFragment}
 */
function isDocumentNode(node) {
    return node.nodeType === Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === Node.DOCUMENT_NODE;
}

function findParentOrHost(element, root) {
    const parentNode = element.parentNode;
    return (parentNode && parentNode.host && parentNode.nodeType === 11) ? parentNode.host : parentNode === root ? null : parentNode;
}

/**
 * Finds all elements on the page, inclusive of those within shadow roots.
 * @param {string=} selector Simple selector to filter the elements by. e.g. 'a', 'div.main'
 * @return {!Array<string>} List of anchor hrefs.
 * @author ebidel@ (Eric Bidelman)
 * License Apache-2.0
 */
function collectAllElementsDeep(selector = null, root, cachedElements = null) {
    let allElements = [];

    if (cachedElements) {
        allElements = cachedElements;
    } else {
        const findAllElements = function(nodes) {
            for (let i = 0; i < nodes.length; i++) {
                const el = nodes[i];
                allElements.push(el);
                // If the element has a shadow root, dig deeper.
                if (el.shadowRoot) {
                    findAllElements(el.shadowRoot.querySelectorAll('*'));
                }
            }
        };
        if(root.shadowRoot) {
            findAllElements(root.shadowRoot.querySelectorAll('*'));
        }
        findAllElements(root.querySelectorAll('*'));
    }

    return selector ? allElements.filter(el => el.matches(selector)) : allElements;	}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, basedir, module) {
	return module = {
		path: basedir,
		exports: {},
		require: function (path, base) {
			return commonjsRequire();
		}
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var fuzzysort = createCommonjsModule(function (module) {
((root, UMD) => {
  if(module.exports) module.exports = UMD();
  else root['fuzzysort'] = UMD();
})(commonjsGlobal, _ => {

  var single = (search, target) => {                                                                                                                                                                                                                        if(search=='farzher')return {target:"farzher was here (^-^*)/",score:0,_indexes:[0]}
    if(!search || !target) return NULL

    var preparedSearch = getPreparedSearch(search);
    if(!isObj(target)) target = getPrepared(target);

    var searchBitflags = preparedSearch.bitflags;
    if((searchBitflags & target._bitflags) !== searchBitflags) return NULL

    return algorithm(preparedSearch, target)
  };


  var go = (search, targets, options) => {                                                                                                                                                                                                                  if(search=='farzher')return [{target:"farzher was here (^-^*)/",score:0,_indexes:[0],obj:targets?targets[0]:NULL}]
    if(!search) return options&&options.all ? all(search, targets, options) : noResults

    var preparedSearch = getPreparedSearch(search);
    var searchBitflags = preparedSearch.bitflags;

    var threshold = options&&options.threshold || INT_MIN;
    var limit     = options&&options['limit']  || INT_MAX; // for some reason only limit breaks when minified

    var resultsLen = 0; var limitedCount = 0;
    var targetsLen = targets.length;

    // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

    // options.key
    if(options && options.key) {
      var key = options.key;
      for(var i = 0; i < targetsLen; ++i) { var obj = targets[i];
        var target = getValue(obj, key);
        if(!target) continue
        if(!isObj(target)) target = getPrepared(target);

        if((searchBitflags & target._bitflags) !== searchBitflags) continue
        var result = algorithm(preparedSearch, target);
        if(result === NULL) continue
        if(result.score < threshold) continue

        // have to clone result so duplicate targets from different obj can each reference the correct obj
        result = {target:result.target, _targetLower:'', _targetLowerCodes:NULL, _nextBeginningIndexes:NULL, _bitflags:0, score:result.score, _indexes:result._indexes, obj:obj}; // hidden

        if(resultsLen < limit) { q.add(result); ++resultsLen; }
        else {
          ++limitedCount;
          if(result.score > q.peek().score) q.replaceTop(result);
        }
      }

    // options.keys
    } else if(options && options.keys) {
      var scoreFn = options['scoreFn'] || defaultScoreFn;
      var keys = options.keys;
      var keysLen = keys.length;
      for(var i = 0; i < targetsLen; ++i) { var obj = targets[i];
        var objResults = new Array(keysLen);
        for (var keyI = 0; keyI < keysLen; ++keyI) {
          var key = keys[keyI];
          var target = getValue(obj, key);
          if(!target) { objResults[keyI] = NULL; continue }
          if(!isObj(target)) target = getPrepared(target);

          if((searchBitflags & target._bitflags) !== searchBitflags) objResults[keyI] = NULL;
          else objResults[keyI] = algorithm(preparedSearch, target);
        }
        objResults.obj = obj; // before scoreFn so scoreFn can use it
        var score = scoreFn(objResults);
        if(score === NULL) continue
        if(score < threshold) continue
        objResults.score = score;
        if(resultsLen < limit) { q.add(objResults); ++resultsLen; }
        else {
          ++limitedCount;
          if(score > q.peek().score) q.replaceTop(objResults);
        }
      }

    // no keys
    } else {
      for(var i = 0; i < targetsLen; ++i) { var target = targets[i];
        if(!target) continue
        if(!isObj(target)) target = getPrepared(target);

        if((searchBitflags & target._bitflags) !== searchBitflags) continue
        var result = algorithm(preparedSearch, target);
        if(result === NULL) continue
        if(result.score < threshold) continue
        if(resultsLen < limit) { q.add(result); ++resultsLen; }
        else {
          ++limitedCount;
          if(result.score > q.peek().score) q.replaceTop(result);
        }
      }
    }

    if(resultsLen === 0) return noResults
    var results = new Array(resultsLen);
    for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll();
    results.total = resultsLen + limitedCount;
    return results
  };


  var highlight = (result, hOpen, hClose) => {
    if(typeof hOpen === 'function') return highlightCallback(result, hOpen)
    if(result === NULL) return NULL
    if(hOpen === undefined) hOpen = '<b>';
    if(hClose === undefined) hClose = '</b>';
    var highlighted = '';
    var matchesIndex = 0;
    var opened = false;
    var target = result.target;
    var targetLen = target.length;
    var indexes = result._indexes;
    indexes = indexes.slice(0, indexes.len).sort((a,b)=>a-b);
    for(var i = 0; i < targetLen; ++i) { var char = target[i];
      if(indexes[matchesIndex] === i) {
        ++matchesIndex;
        if(!opened) { opened = true;
          highlighted += hOpen;
        }

        if(matchesIndex === indexes.length) {
          highlighted += char + hClose + target.substr(i+1);
          break
        }
      } else {
        if(opened) { opened = false;
          highlighted += hClose;
        }
      }
      highlighted += char;
    }

    return highlighted
  };
  var highlightCallback = (result, cb) => {
    if(result === NULL) return NULL
    var target = result.target;
    var targetLen = target.length;
    var indexes = result._indexes;
    indexes = indexes.slice(0, indexes.len).sort((a,b)=>a-b);
    var highlighted = '';
    var matchI = 0;
    var indexesI = 0;
    var opened = false;
    var result = [];
    for(var i = 0; i < targetLen; ++i) { var char = target[i];
      if(indexes[indexesI] === i) {
        ++indexesI;
        if(!opened) { opened = true;
          result.push(highlighted); highlighted = '';
        }

        if(indexesI === indexes.length) {
          highlighted += char;
          result.push(cb(highlighted, matchI++)); highlighted = '';
          result.push(target.substr(i+1));
          break
        }
      } else {
        if(opened) { opened = false;
          result.push(cb(highlighted, matchI++)); highlighted = '';
        }
      }
      highlighted += char;
    }
    return result
  };


  var indexes = result => result._indexes.slice(0, result._indexes.len).sort((a,b)=>a-b);


  var prepare = (target) => {
    if(typeof target !== 'string') target = '';
    var info = prepareLowerInfo(target);
    return {'target':target, _targetLower:info._lower, _targetLowerCodes:info.lowerCodes, _nextBeginningIndexes:NULL, _bitflags:info.bitflags, 'score':NULL, _indexes:[0], 'obj':NULL} // hidden
  };


  // Below this point is only internal code
  // Below this point is only internal code
  // Below this point is only internal code
  // Below this point is only internal code


  var prepareSearch = (search) => {
    if(typeof search !== 'string') search = '';
    search = search.trim();
    var info = prepareLowerInfo(search);

    var spaceSearches = [];
    if(info.containsSpace) {
      var searches = search.split(/\s+/);
      searches = [...new Set(searches)]; // distinct
      for(var i=0; i<searches.length; i++) {
        if(searches[i] === '') continue
        var _info = prepareLowerInfo(searches[i]);
        spaceSearches.push({lowerCodes:_info.lowerCodes, _lower:searches[i].toLowerCase(), containsSpace:false});
      }
    }

    return {lowerCodes: info.lowerCodes, bitflags: info.bitflags, containsSpace: info.containsSpace, _lower: info._lower, spaceSearches: spaceSearches}
  };



  var getPrepared = (target) => {
    if(target.length > 999) return prepare(target) // don't cache huge targets
    var targetPrepared = preparedCache.get(target);
    if(targetPrepared !== undefined) return targetPrepared
    targetPrepared = prepare(target);
    preparedCache.set(target, targetPrepared);
    return targetPrepared
  };
  var getPreparedSearch = (search) => {
    if(search.length > 999) return prepareSearch(search) // don't cache huge searches
    var searchPrepared = preparedSearchCache.get(search);
    if(searchPrepared !== undefined) return searchPrepared
    searchPrepared = prepareSearch(search);
    preparedSearchCache.set(search, searchPrepared);
    return searchPrepared
  };


  var all = (search, targets, options) => {
    var results = []; results.total = targets.length;

    var limit = options && options.limit || INT_MAX;

    if(options && options.key) {
      for(var i=0;i<targets.length;i++) { var obj = targets[i];
        var target = getValue(obj, options.key);
        if(!target) continue
        if(!isObj(target)) target = getPrepared(target);
        target.score = INT_MIN;
        target._indexes.len = 0;
        var result = target;
        result = {target:result.target, _targetLower:'', _targetLowerCodes:NULL, _nextBeginningIndexes:NULL, _bitflags:0, score:target.score, _indexes:NULL, obj:obj}; // hidden
        results.push(result); if(results.length >= limit) return results
      }
    } else if(options && options.keys) {
      for(var i=0;i<targets.length;i++) { var obj = targets[i];
        var objResults = new Array(options.keys.length);
        for (var keyI = options.keys.length - 1; keyI >= 0; --keyI) {
          var target = getValue(obj, options.keys[keyI]);
          if(!target) { objResults[keyI] = NULL; continue }
          if(!isObj(target)) target = getPrepared(target);
          target.score = INT_MIN;
          target._indexes.len = 0;
          objResults[keyI] = target;
        }
        objResults.obj = obj;
        objResults.score = INT_MIN;
        results.push(objResults); if(results.length >= limit) return results
      }
    } else {
      for(var i=0;i<targets.length;i++) { var target = targets[i];
        if(!target) continue
        if(!isObj(target)) target = getPrepared(target);
        target.score = INT_MIN;
        target._indexes.len = 0;
        results.push(target); if(results.length >= limit) return results
      }
    }

    return results
  };


  var algorithm = (preparedSearch, prepared, allowSpaces=false) => {
    if(allowSpaces===false && preparedSearch.containsSpace) return algorithmSpaces(preparedSearch, prepared)

    var searchLower = preparedSearch._lower;
    var searchLowerCodes = preparedSearch.lowerCodes;
    var searchLowerCode = searchLowerCodes[0];
    var targetLowerCodes = prepared._targetLowerCodes;
    var searchLen = searchLowerCodes.length;
    var targetLen = targetLowerCodes.length;
    var searchI = 0; // where we at
    var targetI = 0; // where you at
    var matchesSimpleLen = 0;

    // very basic fuzzy match; to remove non-matching targets ASAP!
    // walk through target. find sequential matches.
    // if all chars aren't found then exit
    for(;;) {
      var isMatch = searchLowerCode === targetLowerCodes[targetI];
      if(isMatch) {
        matchesSimple[matchesSimpleLen++] = targetI;
        ++searchI; if(searchI === searchLen) break
        searchLowerCode = searchLowerCodes[searchI];
      }
      ++targetI; if(targetI >= targetLen) return NULL // Failed to find searchI
    }

    var searchI = 0;
    var successStrict = false;
    var matchesStrictLen = 0;

    var nextBeginningIndexes = prepared._nextBeginningIndexes;
    if(nextBeginningIndexes === NULL) nextBeginningIndexes = prepared._nextBeginningIndexes = prepareNextBeginningIndexes(prepared.target);
    targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1];

    // Our target string successfully matched all characters in sequence!
    // Let's try a more advanced and strict test to improve the score
    // only count it as a match if it's consecutive or a beginning character!
    var backtrackCount = 0;
    if(targetI !== targetLen) for(;;) {
      if(targetI >= targetLen) {
        // We failed to find a good spot for this search char, go back to the previous search char and force it forward
        if(searchI <= 0) break // We failed to push chars forward for a better match

        ++backtrackCount; if(backtrackCount > 200) break // exponential backtracking is taking too long, just give up and return a bad match

        --searchI;
        var lastMatch = matchesStrict[--matchesStrictLen];
        targetI = nextBeginningIndexes[lastMatch];

      } else {
        var isMatch = searchLowerCodes[searchI] === targetLowerCodes[targetI];
        if(isMatch) {
          matchesStrict[matchesStrictLen++] = targetI;
          ++searchI; if(searchI === searchLen) { successStrict = true; break }
          ++targetI;
        } else {
          targetI = nextBeginningIndexes[targetI];
        }
      }
    }

    // check if it's a substring match
    var substringIndex = prepared._targetLower.indexOf(searchLower, matchesSimple[0]); // perf: this is slow
    var isSubstring = ~substringIndex;
    if(isSubstring && !successStrict) { // rewrite the indexes from basic to the substring
      for(var i=0; i<matchesSimpleLen; ++i) matchesSimple[i] = substringIndex+i;
    }
    var isSubstringBeginning = false;
    if(isSubstring) {
      isSubstringBeginning = prepared._nextBeginningIndexes[substringIndex-1] === substringIndex;
    }

    { // tally up the score & keep track of matches for highlighting later
      if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen; }
      else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen; }

      var score = 0;

      var extraMatchGroupCount = 0;
      for(var i = 1; i < searchLen; ++i) {
        if(matchesBest[i] - matchesBest[i-1] !== 1) {score -= matchesBest[i]; ++extraMatchGroupCount;}
      }
      var unmatchedDistance = matchesBest[searchLen-1] - matchesBest[0] - (searchLen-1);

      score -= (12+unmatchedDistance) * extraMatchGroupCount; // penality for more groups

      if(matchesBest[0] !== 0) score -= matchesBest[0]*matchesBest[0]*.2; // penality for not starting near the beginning

      if(!successStrict) {
        score *= 1000;
      } else {
        // successStrict on a target with too many beginning indexes loses points for being a bad target
        var uniqueBeginningIndexes = 1;
        for(var i = nextBeginningIndexes[0]; i < targetLen; i=nextBeginningIndexes[i]) ++uniqueBeginningIndexes;

        if(uniqueBeginningIndexes > 24) score *= (uniqueBeginningIndexes-24)*10; // quite arbitrary numbers here ...
      }

      if(isSubstring)          score /= 1+searchLen*searchLen*1; // bonus for being a full substring
      if(isSubstringBeginning) score /= 1+searchLen*searchLen*1; // bonus for substring starting on a beginningIndex

      score -= targetLen - searchLen; // penality for longer targets
      prepared.score = score;

      for(var i = 0; i < matchesBestLen; ++i) prepared._indexes[i] = matchesBest[i];
      prepared._indexes.len = matchesBestLen;

      return prepared
    }
  };
  var algorithmSpaces = (preparedSearch, target) => {
    var seen_indexes = new Set();
    var score = 0;
    var result = NULL;

    var first_seen_index_last_search = 0;
    var searches = preparedSearch.spaceSearches;
    for(var i=0; i<searches.length; ++i) {
      var search = searches[i];

      result = algorithm(search, target);
      if(result === NULL) return NULL

      score += result.score;

      // dock points based on order otherwise "c man" returns Manifest.cpp instead of CheatManager.h
      if(result._indexes[0] < first_seen_index_last_search) {
        score -= first_seen_index_last_search - result._indexes[0];
      }
      first_seen_index_last_search = result._indexes[0];

      for(var j=0; j<result._indexes.len; ++j) seen_indexes.add(result._indexes[j]);
    }

    // allows a search with spaces that's an exact substring to score well
    var allowSpacesResult = algorithm(preparedSearch, target, /*allowSpaces=*/true);
    if(allowSpacesResult !== NULL && allowSpacesResult.score > score) {
      return allowSpacesResult
    }

    result.score = score;

    var i = 0;
    for (let index of seen_indexes) result._indexes[i++] = index;
    result._indexes.len = i;

    return result
  };


  var prepareLowerInfo = (str) => {
    var strLen = str.length;
    var lower = str.toLowerCase();
    var lowerCodes = []; // new Array(strLen)    sparse array is too slow
    var bitflags = 0;
    var containsSpace = false; // space isn't stored in bitflags because of how searching with a space works

    for(var i = 0; i < strLen; ++i) {
      var lowerCode = lowerCodes[i] = lower.charCodeAt(i);

      if(lowerCode === 32) {
        containsSpace = true;
        continue // it's important that we don't set any bitflags for space
      }

      var bit = lowerCode>=97&&lowerCode<=122 ? lowerCode-97 // alphabet
              : lowerCode>=48&&lowerCode<=57  ? 26           // numbers
                                                             // 3 bits available
              : lowerCode<=127                ? 30           // other ascii
              :                                 31;           // other utf8
      bitflags |= 1<<bit;
    }

    return {lowerCodes:lowerCodes, bitflags:bitflags, containsSpace:containsSpace, _lower:lower}
  };
  var prepareBeginningIndexes = (target) => {
    var targetLen = target.length;
    var beginningIndexes = []; var beginningIndexesLen = 0;
    var wasUpper = false;
    var wasAlphanum = false;
    for(var i = 0; i < targetLen; ++i) {
      var targetCode = target.charCodeAt(i);
      var isUpper = targetCode>=65&&targetCode<=90;
      var isAlphanum = isUpper || targetCode>=97&&targetCode<=122 || targetCode>=48&&targetCode<=57;
      var isBeginning = isUpper && !wasUpper || !wasAlphanum || !isAlphanum;
      wasUpper = isUpper;
      wasAlphanum = isAlphanum;
      if(isBeginning) beginningIndexes[beginningIndexesLen++] = i;
    }
    return beginningIndexes
  };
  var prepareNextBeginningIndexes = (target) => {
    var targetLen = target.length;
    var beginningIndexes = prepareBeginningIndexes(target);
    var nextBeginningIndexes = []; // new Array(targetLen)     sparse array is too slow
    var lastIsBeginning = beginningIndexes[0];
    var lastIsBeginningI = 0;
    for(var i = 0; i < targetLen; ++i) {
      if(lastIsBeginning > i) {
        nextBeginningIndexes[i] = lastIsBeginning;
      } else {
        lastIsBeginning = beginningIndexes[++lastIsBeginningI];
        nextBeginningIndexes[i] = lastIsBeginning===undefined ? targetLen : lastIsBeginning;
      }
    }
    return nextBeginningIndexes
  };


  var cleanup = () => { preparedCache.clear(); preparedSearchCache.clear(); matchesSimple = []; matchesStrict = []; };

  var preparedCache       = new Map();
  var preparedSearchCache = new Map();
  var matchesSimple = []; var matchesStrict = [];


  // for use with keys. just returns the maximum score
  var defaultScoreFn = (a) => {
    var max = INT_MIN;
    var len = a.length;
    for (var i = 0; i < len; ++i) {
      var result = a[i]; if(result === NULL) continue
      var score = result.score;
      if(score > max) max = score;
    }
    if(max === INT_MIN) return NULL
    return max
  };

  // prop = 'key'              2.5ms optimized for this case, seems to be about as fast as direct obj[prop]
  // prop = 'key1.key2'        10ms
  // prop = ['key1', 'key2']   27ms
  var getValue = (obj, prop) => {
    var tmp = obj[prop]; if(tmp !== undefined) return tmp
    var segs = prop;
    if(!Array.isArray(prop)) segs = prop.split('.');
    var len = segs.length;
    var i = -1;
    while (obj && (++i < len)) obj = obj[segs[i]];
    return obj
  };

  var isObj = (x) => { return typeof x === 'object' }; // faster as a function
  // var INT_MAX = 9007199254740991; var INT_MIN = -INT_MAX
  var INT_MAX = Infinity; var INT_MIN = -INT_MAX;
  var noResults = []; noResults.total = 0;
  var NULL = null;


  // Hacked version of https://github.com/lemire/FastPriorityQueue.js
  var fastpriorityqueue=r=>{var e=[],o=0,a={},v=r=>{for(var a=0,v=e[a],c=1;c<o;){var s=c+1;a=c,s<o&&e[s].score<e[c].score&&(a=s),e[a-1>>1]=e[a],c=1+(a<<1);}for(var f=a-1>>1;a>0&&v.score<e[f].score;f=(a=f)-1>>1)e[a]=e[f];e[a]=v;};return a.add=(r=>{var a=o;e[o++]=r;for(var v=a-1>>1;a>0&&r.score<e[v].score;v=(a=v)-1>>1)e[a]=e[v];e[a]=r;}),a.poll=(r=>{if(0!==o){var a=e[0];return e[0]=e[--o],v(),a}}),a.peek=(r=>{if(0!==o)return e[0]}),a.replaceTop=(r=>{e[0]=r,v();}),a};
  var q = fastpriorityqueue(); // reuse this


  // fuzzysort is written this way for minification. all names are mangeled unless quoted
  return {'single':single, 'go':go, 'highlight':highlight, 'prepare':prepare, 'indexes':indexes, 'cleanup':cleanup}
}); // UMD

// TODO: (feature) frecency
// TODO: (perf) use different sorting algo depending on the # of results?
// TODO: (perf) preparedCache is a memory leak
// TODO: (like sublime) backslash === forwardslash
// TODO: (perf) prepareSearch seems slow
});

var LabelCssClass;
(function (LabelCssClass) {
  LabelCssClass["Base"] = "iress-label";
  LabelCssClass["Label"] = "iress-label__label";
  LabelCssClass["LabelText"] = "iress-label__text";
  LabelCssClass["HiddenLabel"] = "iress-label--hidden";
  LabelCssClass["Required"] = "iress-label__required";
  LabelCssClass["Optional"] = "iress-label__optional";
})(LabelCssClass || (LabelCssClass = {}));

const labelCss = ".sc-iress-label-h{--iress-font-family:var(--iress-label-font-family,\n          var(--iress-a-form-font-family,\n              var(--iress-g-font-family,\n                  inherit\n      )));--iress-font-size:var(--iress-label-font-size, inherit);--iress-font-weight:var(--iress-label-font-weight, var(--iress-g-label-font-weight, bold));--iress-text-color:var(--iress-label-text-color,\n          var(--iress-a-label-text-color,\n              var(--iress-g-text-color,\n                  inherit\n  )));--iress-line-height:var(--iress-label-line-height,\n          var(--iress-a-form-line-height,\n              var(--iress-g-line-height,\n                  1.5\n  )));--iress-margin-bottom:0;--iress-meta-font-size:var(--iress-label-meta-font-size,\n          var(--iress-g-font-size-xxxs,\n              var(--iress-g-font-size-rem,\n                  0.875em\n  )));--iress-meta-font-style:var(--iress-label-meta-font-style, normal);--iress-meta-margin:var(--iress-label-meta-margin, var(--iress-g-spacing-xs));--iress-meta-padding-left:var(--iress-label-meta-padding-left, var(--iress-g-spacing-xs));--iress-optional-font-weight:var(--iress-label-optional-font-weight,\n          var(--iress-a-muted-font-weight,\n              var(--iress-g-font-weight, inherit\n      )));--iress-optional-text-color:var(--iress-label-optional-text-color, var(--iress-default-text-color--light));--iress-required-text-color:var(--iress-label-required-text-color,\n          var(--iress-a-danger-text-color,\n              var(--iress-g-danger-color,\n                  var(--iress-default-danger-color\n  ))));--iress-required-inset-top:calc(var(--iress-g-spacing-xs) * -1)}.sc-iress-label-h{display:block}.sc-iress-label-h .iress-label__label.sc-iress-label{font-family:var(--iress-font-family);font-size:var(--iress-font-size);font-weight:var(--iress-font-weight);color:var(--iress-text-color);display:block;margin-block-end:var(--iress-margin-bottom);line-height:var(--iress-line-height)}.sc-iress-label-h .iress-label__required.sc-iress-label,.sc-iress-label-h .iress-label__optional.sc-iress-label{font-style:var(--iress-meta-font-style);font-size:var(--iress-meta-font-size);display:inline-block}.sc-iress-label-h .iress-label__required.sc-iress-label{color:var(--iress-required-text-color);top:var(--iress-required-inset-top);position:relative;margin-inline-start:0;margin-inline-end:var(--iress-meta-margin)}.sc-iress-label-h .iress-label__optional.sc-iress-label{margin-inline-start:var(--iress-meta-margin);margin-inline-end:0;color:var(--iress-optional-text-color);font-weight:var(--iress-optional-font-weight)}";

const Label = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    /**
     * Id of input that the label is labelling
     */
    this.for = '';
    /**
     * Visually hides the label text, but still available to screen readers
     */
    this.hiddenLabel = false;
    /**
     * When set to true, the 'required asterisk (*)' is displayed next to the label text
     */
    this.required = false;
    /**
     * When set to true, the text '(optional)' is displayed next to the label text.
     * Will be ignored if `required` is `true`
     */
    this.optional = false;
    /**
     * Text that is read by a screen reader for a required field
     */
    this.optionalText = '(optional)';
    /**
     * When true, element in the `for` will be focused on (for CheckboxGroup and RadioGroup)
     */
    this.focusOn = false;
  }
  render() {
    return (h(Host, { class: {
        [LabelCssClass.Base]: true,
        [LabelCssClass.HiddenLabel]: this.hiddenLabel,
      } }, h("label", { class: LabelCssClass.Label, htmlFor: this.for, onClick: this.focusOn ? focusOnElement : null }, h("div", null, this.required && (h("span", { class: {
        [LabelCssClass.Required]: true,
        [GlobalCssClass.SROnly]: this.hiddenLabel === true,
      }, "aria-hidden": "true" }, "*")), h("span", { class: {
        [LabelCssClass.LabelText]: true,
        [GlobalCssClass.SROnly]: this.hiddenLabel === true,
      } }, this.labelText), !this.required && this.optional && (h("span", { class: {
        [LabelCssClass.Optional]: true,
        [GlobalCssClass.SROnly]: this.hiddenLabel === true,
      } }, this.optionalText)), h("slot", null)))));
  }
};
Label.style = labelCss;

var CheckboxGroupLayout;
(function (CheckboxGroupLayout) {
  CheckboxGroupLayout["Block"] = "block";
  CheckboxGroupLayout["Stack"] = "stack";
  CheckboxGroupLayout["Inline"] = "inline";
  CheckboxGroupLayout["InlineFlex"] = "inline-flex";
  CheckboxGroupLayout["InlineEqualWidth"] = "inline-equal-width";
})(CheckboxGroupLayout || (CheckboxGroupLayout = {}));
var CheckboxGroupCssClass;
(function (CheckboxGroupCssClass) {
  CheckboxGroupCssClass["Base"] = "iress-checkbox-group";
  CheckboxGroupCssClass["InlineBase"] = "iress-inline iress-checkbox-group--inline";
  CheckboxGroupCssClass["HiddenControl"] = "iress-checkbox-group--hidden-control";
})(CheckboxGroupCssClass || (CheckboxGroupCssClass = {}));

var CheckboxCssClass;
(function (CheckboxCssClass) {
  CheckboxCssClass["Base"] = "iress-checkbox";
  CheckboxCssClass["Checked"] = "iress-checkbox--checked";
  CheckboxCssClass["Indeterminate"] = "iress-checkbox--indeterminate";
  CheckboxCssClass["Label"] = "iress-checkbox__label";
  CheckboxCssClass["Input"] = "iress-checkbox__input";
  CheckboxCssClass["Focus"] = "iress-checkbox--focus";
  CheckboxCssClass["Hover"] = "iress-checkbox--hover";
  CheckboxCssClass["Mark"] = "iress-checkbox__mark";
  CheckboxCssClass["HiddenControl"] = "iress-checkbox--hidden-control";
  CheckboxCssClass["HiddenLabel"] = "iress-checkbox--hidden-label";
  CheckboxCssClass["Border"] = "iress-checkbox--border";
})(CheckboxCssClass || (CheckboxCssClass = {}));

const checkboxCss = ".sc-iress-checkbox-h{--iress-font-family:var(--iress-checkbox-font-family,\n          var(--iress-a-form-font-family,\n              var(--iress-g-font-family,\n                  inherit\n      )));--iress-font-size:var(--iress-checkbox-font-size, inherit);--iress-font-weight:var(--iress-checkbox-font-weight, var(--iress-g-font-weight, normal));--iress-text-color:var(--iress-checkbox-text-color,\n          var(--iress-a-label-text-color,\n              var(--iress-g-text-color,\n                  inherit\n  )));--iress-spacing-right:var(--iress-checkbox-spacing-right, var(--iress-g-spacing-xs));--iress-margin-bottom:var(--iress-checkbox-margin-bottom, var(--iress-g-spacing-sm));--iress-padding-x:var(--iress-checkbox-padding-x, 0);--iress-padding-y:var(--iress-checkbox-padding-y, 0);--iress-label-border-width:var(--iress-checkbox-label-border-width, 0);--iress-label-border-color:var(--iress-checkbox-label-border-color, transparent);--iress-label-background-color:var(--iress-checkbox-background-color, transparent);--iress-label-box-shadow:none;--iress-line-height:var(--iress-checkbox-line-height, var(--iress-checkbox-size, calc(1.25 * var(--iress-g-spacing-rem))));--iress-transition-hover-duration:var(--iress-checkbox-transition-hover-duration,\n          var(--iress-g-transition-hover-duration,\n              var(--iress-default-hover-transition-duration\n  )));--iress-transition-hover-type:var(--iress-checkbox-transition-hover-type,\n          var(--iress-g-transition-hover-type,\n              var(--iress-default-hover-transition-type\n  )))}.sc-iress-checkbox-h:focus-within,.iress-checkbox--focus.sc-iress-checkbox-h{--iress-label-box-shadow:var(--iress-checkbox-label-focus-indicator, none);--iress-mark-box-shadow:0 0 0 var(--iress-g-focus-width, 2px) var(--iress-focus-color);--iress-border-color:var(--iress-focus-color)}.iress-view-mode-standard.sc-iress-checkbox-h,.iress-view-mode-standard .sc-iress-checkbox-h,.iress-view-mode-compact.sc-iress-checkbox-h,.iress-view-mode-compact .sc-iress-checkbox-h{--iress-label-background-color:transparent;--iress-label-border-width:0;--iress-padding-x:0;--iress-padding-y:0}.iress-view-mode-standard.iress-checkbox--focus.sc-iress-checkbox-h,.iress-view-mode-standard .iress-checkbox--focus.sc-iress-checkbox-h,.iress-view-mode-standard.iress-checkbox.sc-iress-checkbox-h:focus-within,.iress-view-mode-standard .iress-checkbox.sc-iress-checkbox-h:focus-within,.iress-view-mode-compact.iress-checkbox--focus.sc-iress-checkbox-h,.iress-view-mode-compact .iress-checkbox--focus.sc-iress-checkbox-h,.iress-view-mode-compact.iress-checkbox.sc-iress-checkbox-h:focus-within,.iress-view-mode-compact .iress-checkbox.sc-iress-checkbox-h:focus-within{--iress-label-box-shadow:none;--iress-mark-box-shadow:0 0 0 var(--iress-g-focus-width, 2px) var(--iress-focus-color);--iress-border-color:var(--iress-focus-color)}.iress-view-mode-touch.iress-checkbox--focus.sc-iress-checkbox-h,.iress-view-mode-touch .iress-checkbox--focus.sc-iress-checkbox-h,.iress-view-mode-touch.iress-checkbox.sc-iress-checkbox-h:focus-within,.iress-view-mode-touch .iress-checkbox.sc-iress-checkbox-h:focus-within{--iress-label-box-shadow:var(--iress-checkbox-label-focus-indicator, none);--iress-focus-indicator:0 0 0 var(--iress-g-focus-width, 2px) var(--iress-focus-color);--iress-mark-box-shadow:var(--iress-box-shadow-size-none, var(--iress-focus-indicator));--iress-label-border-color:var(--iress-focus-color)}.iress-checkbox-group--hidden-control.iress-checkbox.sc-iress-checkbox-h,.iress-checkbox-group--hidden-control .iress-checkbox.sc-iress-checkbox-h{--iress-inline-spacing-x:var(--iress-checkbox-group-inline-spacing, var(--iress-g-spacing-md));--iress-margin-bottom:var(--iress-checkbox-margin-bottom, var(--iress-g-spacing-sm))}.iress-checkbox-group--hidden-control.iress-checkbox.sc-iress-checkbox-h:focus-within,.iress-checkbox-group--hidden-control .iress-checkbox.sc-iress-checkbox-h:focus-within{--iress-label-box-shadow:0 0 0 var(--iress-g-focus-width, 2px) var(--iress-focus-color)}.iress-checkbox-group--hidden-control.iress-checkbox.sc-iress-checkbox-h:focus-within .iress-checkbox__label.sc-iress-checkbox,.iress-checkbox-group--hidden-control .iress-checkbox.sc-iress-checkbox-h:focus-within .iress-checkbox__label.sc-iress-checkbox{--iress-label-border-color:var(--iress-focus-color)}.iress-checkbox-group--hidden-control.sc-iress-checkbox-h .iress-checkbox__label.sc-iress-checkbox,.iress-checkbox-group--hidden-control .sc-iress-checkbox-h .iress-checkbox__label.sc-iress-checkbox{--iress-label-border-width:var(--iress-g-border-width, 1px);--iress-label-border-color:var(--iress-checkbox-hidden-control-label-border-color,\n          var(--iress-g-form-border-color,\n              var(--iress-default-form-border-color\n      )));--iress-label-background-color:var(--iress-checkbox-hidden-control-label-background-color,\n          var(--iress-a-form-background-color,\n              var(--iress-g-background-color,\n                  var(--iress-default-background-color\n      ))))}@media (hover: hover){.iress-checkbox-group--hidden-control.sc-iress-checkbox-h .iress-checkbox__label.sc-iress-checkbox:hover,.iress-checkbox-group--hidden-control .sc-iress-checkbox-h .iress-checkbox__label.sc-iress-checkbox:hover{--iress-label-background-color:var(--iress-checkbox-hidden-control-label-hover-background-color,\n            var(--iress-a-form-hover-background-color,\n                var(--iress-g-hover-background-color,\n                    var(--iress-default-hover-background-color\n        ))));--iress-text-color:var(--iress-checkbox-hidden-control-label-hover-text-color,\n            var(--iress-a-form-hover-text-color,\n                var(--iress-g-hover-text-color,\n                    var(--iress-default-text-color--hover\n        ))))}}.iress-table.sc-iress-checkbox-h .iress-checkbox__label.sc-iress-checkbox,.iress-table .sc-iress-checkbox-h .iress-checkbox__label.sc-iress-checkbox{--iress-padding-x:0;--iress-padding-y:0;--iress-label-border-width:0;--iress-label-background-color:transparent;--iress-label-box-shadow:none}.iress-table.sc-iress-checkbox-h,.iress-table .sc-iress-checkbox-h{--iress-margin-bottom:0}.iress-table.sc-iress-checkbox-h .iress-checkbox__input.sc-iress-checkbox:focus+.iress-checkbox__label.sc-iress-checkbox,.iress-table .sc-iress-checkbox-h .iress-checkbox__input.sc-iress-checkbox:focus+.iress-checkbox__label.sc-iress-checkbox{--iress-label-box-shadow:none}.iress-table.sc-iress-checkbox-h .iress-checkbox__input.sc-iress-checkbox:focus+.iress-checkbox__label.sc-iress-checkbox .iress-checkbox__mark.sc-iress-checkbox,.iress-table .sc-iress-checkbox-h .iress-checkbox__input.sc-iress-checkbox:focus+.iress-checkbox__label.sc-iress-checkbox .iress-checkbox__mark.sc-iress-checkbox{--iress-box-shadow:0 0 0 var(--iress-g-focus-width, 2px) var(--iress-focus-color)}.sc-iress-checkbox-h{display:flex;position:relative;margin-block-end:var(--iress-margin-bottom);transition:all var(--iress-transition-hover-duration) var(--iress-transition-hover-type)}.sc-iress-checkbox-h .iress-checkbox__input.sc-iress-checkbox{border:0;clip:rect(0, 0, 0, 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.sc-iress-checkbox-h .iress-checkbox__label.sc-iress-checkbox{font-family:var(--iress-font-family);font-size:var(--iress-font-size);font-weight:var(--iress-font-weight);padding-block-end:var(--iress-padding-y);padding-block-start:var(--iress-padding-y);padding-inline-end:var(--iress-padding-x);padding-inline-start:var(--iress-padding-x);box-shadow:var(--iress-label-box-shadow);border:var(--iress-label-border-width) solid var(--iress-label-border-color);border-radius:var(--iress-border-radius);background-color:var(--iress-label-background-color);position:relative;line-height:var(--iress-line-height);min-height:var(--iress-size);margin:0;display:inline-flex;color:var(--iress-text-color)}.sc-iress-checkbox-h .iress-checkbox__mark.sc-iress-checkbox{margin-inline-end:var(--iress-spacing-right);flex-shrink:0}.iress-checkbox--hidden-label.sc-iress-checkbox-h{display:inline-block}.iress-checkbox--hidden-label.sc-iress-checkbox-h .iress-checkbox__label.sc-iress-checkbox>span.sc-iress-checkbox{border:0;clip:rect(0, 0, 0, 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.iress-checkbox--hidden-label.sc-iress-checkbox-h .iress-checkbox__mark.sc-iress-checkbox{margin-inline-end:0}.sc-iress-checkbox-h:last-of-type,.iress-checkbox-group.sc-iress-checkbox-h,.iress-checkbox-group .sc-iress-checkbox-h{margin-block-end:0}";

let checkboxIds = 0;
const Checkbox = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.iressBlur = createEvent(this, "iressBlur", 7);
    this.iressFocus = createEvent(this, "iressFocus", 7);
    this.iressChange = createEvent(this, "iressChange", 7);
    this.iressErrorChange = createEvent(this, "iressErrorChange", 7);
    this.hiddenControl = false;
    this.error = false;
    /**
     * If `true`, the checkbox is selected.
     */
    this.checked = false;
    /**
     * If `true`, the checkbox will visually appear as indeterminate.
     */
    this.indeterminate = false;
    /**
     * If `true`, the checkbox is a required field and will be validated as such.
     */
    this.required = false;
    /**
     * The value of the toggle does not mean if it's checked or not, use the `checked`
     * property for that.
     */
    this.value = 'on';
    this.setCheckedStateFromCheckboxGroupValue = () => {
      let checkedValues = this.cbGroup.value;
      if (typeof this.cbGroup.value === 'string' &&
        this.cbGroup.value !== '') {
        checkedValues = JSON.parse(this.cbGroup.value);
      }
      if (checkedValues.length > 0) {
        this.checked = checkedValues.includes(this.value);
      }
      else {
        this.checked = false;
      }
    };
    this.checkboxChanged = (newChecked) => {
      if (newChecked === undefined)
        newChecked = !this.checked;
      this.checked = newChecked;
      this.indeterminate = false;
      if (this.cbGroup === null) {
        this.iressChange.emit(this.getStatus());
      }
    };
    this.getStatus = () => ({
      value: this.checked ? this.value : '',
      element: this.nativeInput,
      name: this.name,
      type: FormElementType.Checkbox,
      required: this.required,
      error: this.error,
    });
    this.onFocus = () => {
      if (this.cbGroup === null)
        this.iressFocus.emit(this.getStatus());
    };
    this.onBlur = () => {
      if (this.cbGroup === null)
        this.iressBlur.emit(this.getStatus());
    };
  }
  updateFieldRequiredState(prev, current) {
    if (prev !== current && this.willRegister)
      this.registerEle();
  }
  componentWillLoad() {
    var _a;
    this.suffix = getSuffix(this.el, 'iress-checkbox');
    this.inputId = `iress-cb${this.suffix}-${checkboxIds++}`;
    this.cbGroup = this.el.closest('.iress-checkbox-group');
    this.fieldEl = this.el.closest('.iress-field');
    this.hasField = this.fieldEl !== null && this.fieldEl !== undefined;
    this.willRegister = this.hasField && this.cbGroup === null;
    if (this.cbGroup !== null) {
      this.name = this.cbGroup.name;
      this.hiddenControl = this.cbGroup.hiddenCheckbox;
      this.setCheckedStateFromCheckboxGroupValue();
    }
    else {
      this.name = (_a = this.name) !== null && _a !== void 0 ? _a : this.inputId;
    }
  }
  componentDidLoad() {
    if (this.willRegister) {
      this.registerEle();
    }
  }
  disconnectedCallback() {
    if (this.willRegister) {
      this.unregisterEle();
    }
  }
  /**
   * Gets the checkbox HTML input
   */
  getNativeElement() {
    return Promise.resolve(this.nativeInput);
  }
  /**
   * Validates the checkbox
   */
  async validate() {
    this.updateErrors(this.nativeInput.validationMessage || '');
  }
  /**
   * Resets the checkbox checked state
   */
  async reset() {
    this.error = false;
    this.checked = false;
  }
  /**
   * Sets the checkbox checked state
   */
  async check(checked) {
    this.checkboxChanged(checked);
  }
  async registerEle() {
    if (typeof this.fieldEl.registerInputElement === 'function')
      await this.fieldEl.registerInputElement(this.getStatus());
  }
  async unregisterEle() {
    if (typeof this.fieldEl.unregisterInputElement === 'function')
      await this.fieldEl.unregisterInputElement(this.getStatus());
  }
  updateErrors(valMsg) {
    if (this.error !== valMsg) {
      this.iressErrorChange.emit(this.getStatus());
    }
    this.error = valMsg;
  }
  render() {
    const CheckboxMark = `iress-checkbox-mark${this.suffix}`;
    return (h(Host, { class: {
        [CheckboxCssClass.Base]: true,
        [GlobalCssClass.FormElement]: true,
        [GlobalCssClass.FormElementInvalid]: (this.hasField && this.fieldEl.error !== '') ||
          (this.error !== false && this.required),
        [CheckboxCssClass.Checked]: this.checked,
        [CheckboxCssClass.Indeterminate]: this.indeterminate,
        [CheckboxCssClass.HiddenControl]: this.hiddenControl,
        [CheckboxCssClass.HiddenLabel]: this.hiddenLabel,
      } }, h("input", { type: FormElementType.Checkbox, value: this.value, name: this.name, id: this.inputId, checked: this.checked, class: CheckboxCssClass.Input, required: this.required, onChange: () => this.checkboxChanged(), onFocus: this.onFocus, onBlur: this.onBlur, ref: (nativeInput) => (this.nativeInput = nativeInput), "data-testid": nativeTestid(this.el, 'input') }), h("label", { htmlFor: this.inputId, class: CheckboxCssClass.Label }, h(CheckboxMark, { class: {
        [CheckboxCssClass.Mark]: true,
        [GlobalCssClass.Hidden]: this.hiddenControl,
      }, checked: this.checked, indeterminate: this.indeterminate }), h("span", null, h("slot", null)))));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "required": ["updateFieldRequiredState"]
  }; }
};
Checkbox.style = checkboxCss;

const checkboxGroupCss = ".sc-iress-checkbox-group-h{--iress-inline-spacing-x:var(--iress-checkbox-group-inline-spacing, var(--iress-g-spacing-md));--iress-inline-margin-bottom:var(--iress-checkbox-margin-bottom, var(--iress-g-spacing-sm))}.sc-iress-checkbox-group-h.iress-checkbox-group.sc-iress-checkbox-group-s>.sc-iress-checkbox-group{display:contents}.sc-iress-checkbox-group-h.iress-checkbox-group.sc-iress-checkbox-group-s>[data-wrapper-children]{flex-basis:100%}.iress-checkbox-group--block.sc-iress-checkbox-group-h,.iress-checkbox-group--stack.sc-iress-checkbox-group-h{display:flex;flex-wrap:wrap}.sc-iress-checkbox-group-h.iress-checkbox-group--stack.sc-iress-checkbox-group-s .iress-checkbox,.iress-checkbox-group--stack.sc-iress-checkbox-group-h .iress-checkbox.sc-iress-checkbox-group,.sc-iress-checkbox-group-h.iress-checkbox-group--block.sc-iress-checkbox-group-s .iress-checkbox,.iress-checkbox-group--block.sc-iress-checkbox-group-h .iress-checkbox.sc-iress-checkbox-group{flex-basis:100%;margin-block-start:var(--iress-margin-bottom)}.sc-iress-checkbox-group-h.iress-checkbox-group--stack.sc-iress-checkbox-group-s .iress-checkbox:first-child,.iress-checkbox-group--stack.sc-iress-checkbox-group-h .iress-checkbox.sc-iress-checkbox-group:first-child,.sc-iress-checkbox-group-h.iress-checkbox-group--block.sc-iress-checkbox-group-s .iress-checkbox:first-child,.iress-checkbox-group--block.sc-iress-checkbox-group-h .iress-checkbox.sc-iress-checkbox-group:first-child{margin-block-start:0}.sc-iress-checkbox-group-h.iress-checkbox-group--block.sc-iress-checkbox-group-s .iress-checkbox__label,.iress-checkbox-group--block.sc-iress-checkbox-group-h .iress-checkbox__label.sc-iress-checkbox-group{flex-basis:100%;display:flex}.iress-checkbox-group--inline.sc-iress-checkbox-group-h{margin-block-start:calc(-1 * var(--iress-inline-margin-bottom))}.iress-checkbox-group--inline.sc-iress-checkbox-group-h,.sc-iress-checkbox-group-h.iress-checkbox-group--inline.sc-iress-checkbox-group-s>[data-wrapper-children]{display:flex;flex-wrap:wrap;width:100%;flex-direction:row}.sc-iress-checkbox-group-h.iress-checkbox-group--inline.sc-iress-checkbox-group-s .iress-checkbox,.iress-checkbox-group--inline.sc-iress-checkbox-group-h .iress-checkbox.sc-iress-checkbox-group{margin-inline-end:var(--iress-inline-spacing-x);margin-block-start:var(--iress-inline-margin-bottom);flex-basis:auto;flex-grow:0}.sc-iress-checkbox-group-h.iress-checkbox-group--inline.sc-iress-checkbox-group-s .iress-checkbox:last-child,.iress-checkbox-group--inline.sc-iress-checkbox-group-h .iress-checkbox.sc-iress-checkbox-group:last-child{margin-inline-end:0}.sc-iress-checkbox-group-h.iress-view-mode-touch.iress-checkbox-group--inline-equal-width.sc-iress-checkbox-group-s .iress-checkbox,.iress-view-mode-touch .sc-iress-checkbox-group-h.iress-checkbox-group--inline-equal-width.sc-iress-checkbox-group-s .iress-checkbox,.iress-view-mode-touch.iress-checkbox-group--inline-equal-width.sc-iress-checkbox-group-h .iress-checkbox.sc-iress-checkbox-group,.iress-view-mode-touch .iress-checkbox-group--inline-equal-width.sc-iress-checkbox-group-h .iress-checkbox.sc-iress-checkbox-group{flex-basis:var(--iress-checkbox-group-inline-ew-flex-basis, auto);flex-grow:var(--iress-checkbox-group-inline-ew-flex-grow, 0)}.sc-iress-checkbox-group-h.iress-view-mode-touch.iress-checkbox-group--inline-equal-width.sc-iress-checkbox-group-s .iress-checkbox__label,.iress-view-mode-touch .sc-iress-checkbox-group-h.iress-checkbox-group--inline-equal-width.sc-iress-checkbox-group-s .iress-checkbox__label,.iress-view-mode-touch.iress-checkbox-group--inline-equal-width.sc-iress-checkbox-group-h .iress-checkbox__label.sc-iress-checkbox-group,.iress-view-mode-touch .iress-checkbox-group--inline-equal-width.sc-iress-checkbox-group-h .iress-checkbox__label.sc-iress-checkbox-group{width:var(--iress-checkbox-group-inline-ew-width, auto)}.sc-iress-checkbox-group-h.iress-view-mode-touch.iress-checkbox-group--inline-flex.sc-iress-checkbox-group-s .iress-checkbox,.iress-view-mode-touch .sc-iress-checkbox-group-h.iress-checkbox-group--inline-flex.sc-iress-checkbox-group-s .iress-checkbox,.iress-view-mode-touch.iress-checkbox-group--inline-flex.sc-iress-checkbox-group-h .iress-checkbox.sc-iress-checkbox-group,.iress-view-mode-touch .iress-checkbox-group--inline-flex.sc-iress-checkbox-group-h .iress-checkbox.sc-iress-checkbox-group{flex-grow:var(--iress-checkbox-group-inline-flex-flex-grow, 0)}.sc-iress-checkbox-group-h.iress-view-mode-touch.iress-checkbox-group--inline-flex.sc-iress-checkbox-group-s .iress-checkbox__label,.iress-view-mode-touch .sc-iress-checkbox-group-h.iress-checkbox-group--inline-flex.sc-iress-checkbox-group-s .iress-checkbox__label,.iress-view-mode-touch.iress-checkbox-group--inline-flex.sc-iress-checkbox-group-h .iress-checkbox__label.sc-iress-checkbox-group,.iress-view-mode-touch .iress-checkbox-group--inline-flex.sc-iress-checkbox-group-h .iress-checkbox__label.sc-iress-checkbox-group{width:var(--iress-checkbox-group-inline-flex-width, auto)}.sc-iress-checkbox-group-h.iress-checkbox-group--hidden-control.sc-iress-checkbox-group-s .iress-checkbox,.iress-checkbox-group--hidden-control.sc-iress-checkbox-group-h .iress-checkbox.sc-iress-checkbox-group{margin-inline-end:var(--iress-inline-spacing-x);margin-block-start:var(--iress-inline-margin-bottom);flex-basis:auto;flex-grow:0}.sc-iress-checkbox-group-h.iress-checkbox-group--hidden-control.sc-iress-checkbox-group-s .iress-checkbox__label,.iress-checkbox-group--hidden-control.sc-iress-checkbox-group-h .iress-checkbox__label.sc-iress-checkbox-group{padding:0;width:100%}.sc-iress-checkbox-group-h.iress-checkbox-group--hidden-control.sc-iress-checkbox-group-s .iress-checkbox__input:checked+.iress-checkbox__label,.iress-checkbox-group--hidden-control.sc-iress-checkbox-group-h .iress-checkbox__input.sc-iress-checkbox-group:checked+.iress-checkbox__label.sc-iress-checkbox-group{border:none;padding:var(--iress-label-border-width)}.sc-iress-checkbox-group-h.iress-checkbox-group--hidden-control.sc-iress-checkbox-group-s .iress-checkbox__input:checked+.iress-checkbox__label::after,.iress-checkbox-group--hidden-control.sc-iress-checkbox-group-h .iress-checkbox__input.sc-iress-checkbox-group:checked+.iress-checkbox__label.sc-iress-checkbox-group::after{--iress-border-width:var(--iress-label-border-width);--iress-border-color:var(--iress-label-border-color);content:\"\";position:absolute;inset:0;border-color:var(--iress-border-color);border-style:solid;border-width:calc(var(--iress-border-width) + 2px);border-radius:var(--iress-border-radius);pointer-events:none}.sc-iress-checkbox-group-h.iress-checkbox-group--hidden-control.iress-checkbox-group--block.sc-iress-checkbox-group-s .iress-checkbox,.iress-checkbox-group--hidden-control.iress-checkbox-group--block.sc-iress-checkbox-group-h .iress-checkbox.sc-iress-checkbox-group,.sc-iress-checkbox-group-h.iress-checkbox-group--hidden-control.iress-checkbox-group--stack.sc-iress-checkbox-group-s .iress-checkbox,.iress-checkbox-group--hidden-control.iress-checkbox-group--stack.sc-iress-checkbox-group-h .iress-checkbox.sc-iress-checkbox-group{flex-basis:100%}.sc-iress-checkbox-group-h.iress-checkbox-group--hidden-control.iress-checkbox-group--stack.sc-iress-checkbox-group-s .iress-checkbox__label,.iress-checkbox-group--hidden-control.iress-checkbox-group--stack.sc-iress-checkbox-group-h .iress-checkbox__label.sc-iress-checkbox-group{width:auto}.sc-iress-checkbox-group-h.iress-checkbox-group--hidden-control.iress-checkbox-group--inline.sc-iress-checkbox-group-s .iress-checkbox__label,.iress-checkbox-group--hidden-control.iress-checkbox-group--inline.sc-iress-checkbox-group-h .iress-checkbox__label.sc-iress-checkbox-group{display:block}.sc-iress-checkbox-group-h.iress-checkbox-group--hidden-control.iress-checkbox-group--inline-equal-width.sc-iress-checkbox-group-s .iress-checkbox,.iress-checkbox-group--hidden-control.iress-checkbox-group--inline-equal-width.sc-iress-checkbox-group-h .iress-checkbox.sc-iress-checkbox-group{flex-basis:0}.sc-iress-checkbox-group-h.iress-checkbox-group--hidden-control.iress-checkbox-group--inline-flex.sc-iress-checkbox-group-s .iress-checkbox,.iress-checkbox-group--hidden-control.iress-checkbox-group--inline-flex.sc-iress-checkbox-group-h .iress-checkbox.sc-iress-checkbox-group,.sc-iress-checkbox-group-h.iress-checkbox-group--hidden-control.iress-checkbox-group--inline-equal-width.sc-iress-checkbox-group-s .iress-checkbox,.iress-checkbox-group--hidden-control.iress-checkbox-group--inline-equal-width.sc-iress-checkbox-group-h .iress-checkbox.sc-iress-checkbox-group{flex-grow:1}.sc-iress-checkbox-group-h.iress-checkbox-group--hidden-control.iress-checkbox-group--inline-flex.sc-iress-checkbox-group-s .iress-checkbox__label,.iress-checkbox-group--hidden-control.iress-checkbox-group--inline-flex.sc-iress-checkbox-group-h .iress-checkbox__label.sc-iress-checkbox-group,.sc-iress-checkbox-group-h.iress-checkbox-group--hidden-control.iress-checkbox-group--inline-equal-width.sc-iress-checkbox-group-s .iress-checkbox__label,.iress-checkbox-group--hidden-control.iress-checkbox-group--inline-equal-width.sc-iress-checkbox-group-h .iress-checkbox__label.sc-iress-checkbox-group{width:100%}";

let checkboxGroupIds = 0;
const CheckboxGroup = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.iressChange = createEvent(this, "iressChange", 7);
    this.iressFocus = createEvent(this, "iressFocus", 7);
    this.iressBlur = createEvent(this, "iressBlur", 7);
    this.iressErrorChange = createEvent(this, "iressErrorChange", 7);
    this.hasFocus = false;
    /**
     * Flag for differentiating between when a user is clicking a checkbox and when values are being changed programmatically
     */
    this.userChange = false;
    this.error = '';
    /**
     * When true, marks the field as required
     */
    this.required = false;
    /**
     * Sets which of the block / inline layout options apply
     */
    this.layout = CheckboxGroupLayout.Stack;
    /**
     * Validity object of Checkbox group, mirrors validity object in HTML form elements
     */
    this.validity = {
      valid: true,
      valueMissing: false,
    };
    /**
     * Value of CheckboxGroup, array of values of checked checkboxes
     */
    this.value = [];
    /**
     * Validation message to be shown by `iress-field` when invalid
     */
    this.validationMessage = 'Please check at least one checkbox';
    /**
     * Hides the checkbox controls to allow the creation of custom checkboxes
     */
    this.hiddenCheckbox = false;
    this.getStatus = () => ({
      value: this.normalizeValue(this.value),
      element: this.el,
      name: this.name,
      type: FormElementType.CheckboxGroup,
      required: this.required,
      error: !this.validity.valid ? this.validationMessage : '',
    });
    this.normalizeValue = (val) => {
      if (typeof val === 'string' && val === '')
        return [];
      return typeof val === 'string' ? JSON.parse(val) : val;
    };
  }
  updateFieldRequiredState(prev, current) {
    if (prev !== current && this.hasField)
      this.registerEle();
  }
  componentWillLoad() {
    var _a;
    this.value = this.normalizeValue(this.value);
    this.setChildrenChecked();
    this.suffix = getSuffix(this.el, 'iress-checkbox-group');
    this.inputId = `iress-cb-group${this.suffix}-${checkboxGroupIds++}`;
    this.name = (_a = this.name) !== null && _a !== void 0 ? _a : this.inputId;
    this.fieldEl = this.el.closest(`iress-field${this.suffix}`);
    this.hasField = this.fieldEl !== null && this.fieldEl !== undefined;
  }
  componentDidLoad() {
    if (this.hasField)
      this.registerEle();
    this.updateValidity(true);
  }
  componentWillUpdate() {
    this.value = this.normalizeValue(this.value);
    if (JSON.stringify(this.value) !== JSON.stringify(this.originalValue)) {
      this.originalValue = this.value;
      this.setChildrenChecked();
      this.checkValidity(true);
      if (!this.userChange) {
        this.iressChange.emit(this.getStatus());
      }
    }
    // Reset the userChange flag
    this.userChange = false;
  }
  disconnectedCallback() {
    if (this.hasField)
      this.unregisterEle();
  }
  // eslint-disable-next-line
  handleChange({ target }) {
    const { tagName } = target;
    if (tagName === 'INPUT') {
      // This is a click event so we know this is being triggered by a user clicking a checkbox.
      // Update the userChange flag to`true` - this gets reset in the componentWillUpdate method
      this.userChange = true;
      this.updateValidity();
      this.iressChange.emit(this.getStatus());
    }
  }
  // eslint-disable-next-line
  focusHandler() {
    if (hasFocus(this.el) && !this.hasFocus) {
      if (this.el.querySelector('input[type="checkbox"]:focus') === null) {
        const firstChkbox = this.el.querySelector('input[type="checkbox"]:first-child');
        if (firstChkbox !== null)
          firstChkbox.focus();
      }
      else {
        this.iressFocus.emit(this.getStatus());
        this.hasFocus = true;
      }
    }
  }
  // eslint-disable-next-line
  blurHandler() {
    const validateDisabled = this.el.closest('[disabled-validation]');
    setTimeout(() => {
      if (hasFocus(this.el) === false) {
        if (validateDisabled === null)
          this.validate();
        this.iressBlur.emit(this.getStatus());
        this.hasFocus = false;
      }
    }, 20);
  }
  /**
   * Resets the checkbox group
   */
  async reset() {
    const checkedBoxes = Array.from(this.el.querySelectorAll('input[type=checkbox]:checked'));
    checkedBoxes.forEach((chk) => chk.removeAttribute('checked'));
    this.error = '';
    if (this.required) {
      this.validity = {
        valid: false,
        valueMissing: true,
      };
    }
  }
  /**
   * Checks the validity of the checkbox group
   */
  async checkValidity(valueUpdated = false) {
    if (!this.required)
      return true;
    const curValid = this.validity.valid;
    this.updateValidity(valueUpdated);
    const { valid } = this.validity;
    if (valid !== curValid) {
      this.iressErrorChange.emit(this.getStatus());
    }
    return valid;
  }
  /**
   * Validates the checkbox group
   */
  async validate() {
    const curError = this.error;
    this.updateValidity();
    this.error = this.validity.valid ? '' : this.validationMessage;
    if (this.error !== curError) {
      this.iressErrorChange.emit(this.getStatus());
    }
  }
  updateValidity(valueUpdated = false) {
    const checkedBoxes = Array.from(this.el.querySelectorAll('input[type=checkbox]:checked'));
    if (!valueUpdated)
      this.updateValue(checkedBoxes);
    if (this.required) {
      const valid = this.value.length > 0;
      if (this.validity.valid !== valid) {
        this.validity = {
          valid,
          valueMissing: !valid,
        };
      }
    }
  }
  async registerEle() {
    if (typeof this.fieldEl.registerInputElement === 'function')
      await this.fieldEl.registerInputElement(this.getStatus());
  }
  async unregisterEle() {
    if ((await typeof this.fieldEl.unregisterInputElement) === 'function')
      await this.fieldEl.unregisterInputElement(this.getStatus());
  }
  setChildrenChecked() {
    // Clear down existing checked state
    const allChkboxes = this.el.querySelectorAll(`.${CheckboxCssClass.Base}`);
    allChkboxes.forEach((ckb) => ckb.removeAttribute('checked'));
    // Set checked state based on value prop
    const value = this.normalizeValue(this.value);
    for (let i = 0; i < value.length; i++) {
      const chkbox = this.el.querySelector(`[value="${value[i]}"]`);
      chkbox === null || chkbox === void 0 ? void 0 : chkbox.setAttribute('checked', '');
    }
  }
  updateValue(checkedBoxes) {
    this.value = checkedBoxes.map((checkbox) => checkbox.getAttribute('value'));
  }
  render() {
    const addInlineBaseClasses = this.layout === CheckboxGroupLayout.Inline ||
      this.layout === CheckboxGroupLayout.InlineFlex ||
      this.layout === CheckboxGroupLayout.InlineEqualWidth;
    return (h(Host, { class: {
        [CheckboxGroupCssClass.Base]: true,
        [GlobalCssClass.FormElement]: true,
        [GlobalCssClass.FormElementInvalid]: (this.hasField && this.fieldEl.error !== '') ||
          this.error !== '',
        [CheckboxGroupCssClass.InlineBase]: addInlineBaseClasses,
        [`${CheckboxGroupCssClass.Base}--${this.layout}`]: this.layout !== CheckboxGroupLayout.Inline,
        [CheckboxGroupCssClass.HiddenControl]: this.hiddenCheckbox,
      }, "data-iress-required": this.required }, h("slot", null)));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "required": ["updateFieldRequiredState"]
  }; }
};
CheckboxGroup.style = checkboxGroupCss;

var RadioGroupLayout;
(function (RadioGroupLayout) {
  RadioGroupLayout["Block"] = "block";
  RadioGroupLayout["Stack"] = "stack";
  RadioGroupLayout["Inline"] = "inline";
  RadioGroupLayout["InlineFlex"] = "inline-flex";
  RadioGroupLayout["InlineEqualWidth"] = "inline-equal-width";
})(RadioGroupLayout || (RadioGroupLayout = {}));
var RadioGroupCssClass;
(function (RadioGroupCssClass) {
  RadioGroupCssClass["Base"] = "iress-radio-group";
  RadioGroupCssClass["InlineBase"] = "iress-inline iress-radio-group--inline";
  RadioGroupCssClass["HiddenControl"] = "iress-radio-group--hidden-control";
})(RadioGroupCssClass || (RadioGroupCssClass = {}));

var RadioCssClass;
(function (RadioCssClass) {
  RadioCssClass["Base"] = "iress-radio";
  RadioCssClass["Label"] = "iress-radio__label";
  RadioCssClass["Input"] = "iress-radio__input";
  RadioCssClass["Focus"] = "iress-radio--focus";
  RadioCssClass["Hover"] = "iress-radio--hover";
  RadioCssClass["Mark"] = "iress-radio__mark";
  RadioCssClass["Checked"] = "iress-radio--checked";
  RadioCssClass["Border"] = "iress-radio--border";
})(RadioCssClass || (RadioCssClass = {}));

const radioCss = ".sc-iress-radio-h{--iress-font-family:var(--iress-radio-font-family,\n          var(--iress-a-form-font-family,\n              var(--iress-g-font-family,\n                  inherit\n      )));--iress-font-size:var(--iress-radio-font-size, inherit);--iress-font-weight:var(--iress-radio-font-weight, var(--iress-g-font-weight, normal));--iress-mark-border-width:1px;--iress-size:var(--iress-radio-size, 20px);--iress-inner-size:var(--iress-radio-inner-size, 12px);--iress-text-color:var(--iress-radio-text-color,\n          var(--iress-a-label-text-color,\n              var(--iress-g-text-color,\n                  inherit\n  )));--iress-line-height:var(--iress-radio-line-height,\n          var(--iress-a-form-line-height,\n              var(--iress-g-line-height,\n                  var(--iress-size\n  ))));--iress-spacing-right:var(--iress-radio-spacing-right, var(--iress-default-spacing-xs));--iress-border-color:var(--iress-radio-border-color,\n          var(--iress-g-form-border-color,\n              var(--iress-default-form-border-color\n  )));--iress-margin-bottom:var(--iress-radio-margin-bottom, var(--iress-g-spacing-sm));--iress-padding-x:var(--iress-radio-padding-x, 0);--iress-padding-y:var(--iress-radio-padding-y, 0);--iress-label-border-width:var(--iress-radio-label-border-width, 0);--iress-label-background-color:var(--iress-radio-background-color, transparent);--iress-label-border-color:var(--iress-radio-label-border-color, transparent);--iress-mark-color:transparent;--iress-mark-background-color:var(--iress-radio-background-color,\n          var(--iress-a-form-background-color,\n              var(--iress-g-background-color,\n                  var(--iress-default-background-color\n  ))));--iress-mark-box-shadow:none;--iress-label-box-shadow:none;--iress-transition-hover-duration:var(--iress-radio-transition-hover-duration,\n          var(--iress-g-transition-hover-duration,\n              var(--iress-default-hover-transition-duration\n  )));--iress-transition-hover-type:var(--iress-radio-transition-hover-type,\n          var(--iress-g-transition-hover-type,\n              var(--iress-default-hover-transition-type\n  )))}.sc-iress-radio-h:focus-within,.iress-radio--focus.sc-iress-radio-h{--iress-label-box-shadow:var(--iress-radio-label-focus-indicator, none);--iress-mark-box-shadow:0 0 0 var(--iress-g-focus-width, 2px) var(--iress-focus-color);--iress-border-color:var(--iress-focus-color)}.sc-iress-radio-h .iress-radio__input.sc-iress-radio:checked+.iress-radio__label.sc-iress-radio{--iress-mark-color:var(--iress-radio-checked-inner-background-color,\n          var(--iress-a-active-background-color,\n              var(--iress-g-primary-color,\n                  var(--iress-default-active-color\n  ))));--iress-border-color:var(--iress-radio-checked-border-color,\n          var(--iress-a-active-border-color,\n              var(--iress-radio-border-color,\n                  var(--iress-g-form-border-color,\n                      var(--iress-default-form-border-color\n  )))))}.sc-iress-radio-h:focus-within .iress-radio__input.sc-iress-radio:checked+.iress-radio__label.sc-iress-radio,.iress-radio--focus.sc-iress-radio-h .iress-radio__input.sc-iress-radio:checked+.iress-radio__label.sc-iress-radio{--iress-border-color:var(--iress-focus-color)}@media (hover: hover){.sc-iress-radio-h .iress-radio__label.sc-iress-radio:hover{--iress-mark-color:var(--iress-radio-hover-inner-background-color,\n            var(--iress-a-form-hover-background-color,\n                var(--iress-g-hover-background-color,\n                    var(--iress-default-hover-background-color\n    ))))}.sc-iress-radio-h .iress-radio__input.sc-iress-radio:checked+.iress-radio__label.sc-iress-radio:hover{--iress-mark-color:var(--iress-radio-checked-hover-inner-background-color,\n            var(--iress-a-active-hover-background-color,\n                var(--iress-g-primary-hover-color,\n                    var(--iress-g-hover-background-color,\n                        var(--iress-default-hover-background-color))))\n    )}}.iress-view-mode-standard.sc-iress-radio-h,.iress-view-mode-standard .sc-iress-radio-h,.iress-view-mode-compact.sc-iress-radio-h,.iress-view-mode-compact .sc-iress-radio-h{--iress-label-background-color:transparent;--iress-label-border-width:0;--iress-padding-x:0;--iress-padding-y:0}.iress-view-mode-standard.sc-iress-radio-h,.iress-view-mode-standard .sc-iress-radio-h{--iress-size:var(--iress-radio-size, 18px);--iress-inner-size:var(--iress-radio-inner-size, 10px)}.iress-view-mode-compact.sc-iress-radio-h,.iress-view-mode-compact .sc-iress-radio-h{--iress-size:var(--iress-radio-size, 15px);--iress-inner-size:var(--iress-radio-inner-size, 9px)}.iress-view-mode-standard.sc-iress-radio-h .iress-radio-group.sc-iress-radio:not(.iress-radio-group--hidden-control).iress-radio--focus,.iress-view-mode-standard .iress-radio-group:not(.iress-radio-group--hidden-control) .iress-radio--focus.sc-iress-radio-h,.iress-view-mode-standard.sc-iress-radio-h .iress-radio-group.sc-iress-radio:not(.iress-radio-group--hidden-control).iress-radio:focus-within,.iress-view-mode-standard .iress-radio-group:not(.iress-radio-group--hidden-control) .iress-radio.sc-iress-radio-h:focus-within,.iress-view-mode-compact.sc-iress-radio-h .iress-radio-group.sc-iress-radio:not(.iress-radio-group--hidden-control).iress-radio--focus,.iress-view-mode-compact .iress-radio-group:not(.iress-radio-group--hidden-control) .iress-radio--focus.sc-iress-radio-h,.iress-view-mode-compact.sc-iress-radio-h .iress-radio-group.sc-iress-radio:not(.iress-radio-group--hidden-control).iress-radio:focus-within,.iress-view-mode-compact .iress-radio-group:not(.iress-radio-group--hidden-control) .iress-radio.sc-iress-radio-h:focus-within{--iress-label-box-shadow:none;--iress-mark-box-shadow:0 0 0 var(--iress-g-focus-width, 2px) var(--iress-focus-color)}.iress-view-mode-touch.iress-radio--focus.sc-iress-radio-h,.iress-view-mode-touch .iress-radio--focus.sc-iress-radio-h,.iress-view-mode-touch.iress-radio.sc-iress-radio-h:focus-within,.iress-view-mode-touch .iress-radio.sc-iress-radio-h:focus-within{--iress-label-box-shadow:var(--iress-radio-label-focus-indicator, none);--iress-focus-indicator:0 0 0 var(--iress-g-focus-width, 2px) var(--iress-focus-color);--iress-mark-box-shadow:var(--iress-box-shadow-size-none, var(--iress-focus-indicator));--iress-border-color:var(--iress-radio-border-color,\n          var(--iress-g-form-border-color,\n              var(--iress-default-form-border-color\n      )));--iress-label-border-color:var(--iress-focus-color)}.iress-view-mode-touch.iress-radio--focus.sc-iress-radio-h .iress-radio__input.sc-iress-radio:checked+.iress-radio__label.sc-iress-radio,.iress-view-mode-touch .iress-radio--focus.sc-iress-radio-h .iress-radio__input.sc-iress-radio:checked+.iress-radio__label.sc-iress-radio,.iress-view-mode-touch.iress-radio.sc-iress-radio-h:focus-within .iress-radio__input.sc-iress-radio:checked+.iress-radio__label.sc-iress-radio,.iress-view-mode-touch .iress-radio.sc-iress-radio-h:focus-within .iress-radio__input.sc-iress-radio:checked+.iress-radio__label.sc-iress-radio{--iress-border-color:var(--iress-radio-checked-border-color,\n          var(--iress-a-active-border-color,\n              var(--iress-radio-border-color,\n                  var(--iress-g-form-border-color,\n                      var(--iress-default-form-border-color\n      )))))}.iress-radio-group--hidden-control.iress-radio.sc-iress-radio-h,.iress-radio-group--hidden-control .iress-radio.sc-iress-radio-h{--iress-inline-spacing-x:var(--iress-radio-group-inline-spacing, var(--iress-g-spacing-md));--iress-margin-bottom:var(--iress-radio-margin-bottom, var(--iress-g-spacing-sm))}.iress-radio-group--hidden-control.iress-radio.sc-iress-radio-h:focus-within,.iress-radio-group--hidden-control .iress-radio.sc-iress-radio-h:focus-within{--iress-label-box-shadow:0 0 0 var(--iress-g-focus-width, 2px) var(--iress-focus-color)}.iress-radio-group--hidden-control.iress-radio.sc-iress-radio-h:focus-within .iress-radio__label.sc-iress-radio,.iress-radio-group--hidden-control .iress-radio.sc-iress-radio-h:focus-within .iress-radio__label.sc-iress-radio{--iress-label-border-color:var(--iress-focus-color)}.iress-radio-group--hidden-control.sc-iress-radio-h .iress-radio__label.sc-iress-radio,.iress-radio-group--hidden-control .sc-iress-radio-h .iress-radio__label.sc-iress-radio{--iress-label-border-width:var(--iress-g-border-width, 1px);--iress-label-border-color:var(--iress-radio-hidden-control-label-border-color,\n          var(--iress-g-form-border-color,\n              var(--iress-default-form-border-color\n  )));--iress-label-background-color:var(--iress-radio-hidden-control-label-background-color,\n          var(--iress-a-form-background-color,\n              var(--iress-g-background-color,\n                  var(--iress-default-background-color\n  ))))}.iress-radio-group--hidden-control.sc-iress-radio-h .iress-radio__input.sc-iress-radio:checked+.iress-radio__label.sc-iress-radio,.iress-radio-group--hidden-control .sc-iress-radio-h .iress-radio__input.sc-iress-radio:checked+.iress-radio__label.sc-iress-radio{--iress-label-border-color:var(--iress-radio-checked-border-color,\n          var(--iress-a-active-border-color,\n              var(--iress-g-primary-color,\n                  var(--iress-default-form-border-color\n  ))))}@media (hover: hover){.iress-radio-group--hidden-control.sc-iress-radio-h .iress-radio__label.sc-iress-radio:hover,.iress-radio-group--hidden-control .sc-iress-radio-h .iress-radio__label.sc-iress-radio:hover{--iress-label-background-color:var(--iress-radio-hidden-control-label-hover-background-color,\n            var(--iress-a-form-hover-background-color,\n                var(--iress-g-hover-background-color,\n                    var(--iress-default-hover-background-color\n    ))));--iress-text-color:var(--iress-radio-hidden-control-label-hover-text-color,\n            var(--iress-a-form-hover-text-color,\n                var(--iress-g-hover-text-color,\n                    var(--iress-default-text-color--hover\n    ))))}}.sc-iress-radio-h{margin-block-start:var(--iress-margin-bottom);display:flex;position:relative;padding:0;transition:all var(--iress-transition-hover-duration) var(--iress-transition-hover-type)}.sc-iress-radio-h .iress-radio__input.sc-iress-radio{border:0;clip:rect(0, 0, 0, 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.sc-iress-radio-h .iress-radio__label.sc-iress-radio{font-family:var(--iress-font-family);font-size:var(--iress-font-size);font-weight:var(--iress-font-weight);padding-block-end:var(--iress-padding-y);padding-block-start:var(--iress-padding-y);padding-inline-end:var(--iress-padding-x);padding-inline-start:var(--iress-padding-x);border:var(--iress-label-border-width) solid var(--iress-label-border-color);border-radius:var(--iress-border-radius);background-color:var(--iress-label-background-color);position:relative;box-shadow:var(--iress-label-box-shadow);line-height:var(--iress-line-height);min-height:var(--iress-size);margin:0;display:inline-flex;color:var(--iress-text-color)}.sc-iress-radio-h .iress-radio__label.sc-iress-radio .iress-radio__mark.sc-iress-radio{position:relative;border:var(--iress-mark-border-width) solid var(--iress-border-color);background-color:var(--iress-mark-background-color);display:inline-block;width:var(--iress-size);height:var(--iress-size);border-radius:50%;margin-inline-end:var(--iress-spacing-right);box-shadow:var(--iress-mark-box-shadow);flex-shrink:0}.sc-iress-radio-h .iress-radio__label.sc-iress-radio .iress-radio__mark.sc-iress-radio::before{content:\"\";position:absolute;display:inline-block;width:var(--iress-inner-size);height:var(--iress-inner-size);inset-block-start:calc((var(--iress-size) - var(--iress-inner-size)) / 2 - var(--iress-mark-border-width));inset-inline-start:calc((var(--iress-size) - var(--iress-inner-size)) / 2 - var(--iress-mark-border-width));border-radius:50%;background-color:var(--iress-mark-color);transition:all var(--iress-transition-hover-duration) var(--iress-transition-hover-type)}.iress-radio.sc-iress-radio-h .iress-radio__input.sc-iress-radio:checked+.iress-radio__label.sc-iress-radio .iress-radio__mark.sc-iress-radio::before{border:3px solid transparent}";

let radioIds = 0;
const Radio = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.hiddenControl = false;
    /**
     * The value which is submitted with the form data when this radio button is checked. To set this radio as checked by default, use the `checked`
     * property.
     */
    this.value = 'on';
    /**
     * If `true`, the radio is a required field and will be validated as such.
     */
    this.required = false;
    /**
     * Sets the checked state of the radio.
     */
    this.checked = false;
    this.onClick = () => {
      const radiosInGrp = querySelectorAllDeep(`[name="${this.name}"]`);
      for (let i = 0; i < radiosInGrp.length; i++) {
        radiosInGrp[i].removeAttribute('checked');
        radiosInGrp[i].classList.remove(`.${RadioCssClass.Checked}`);
      }
      this.checked = true;
    };
  }
  /**
   * Gets the HTML radio button element.
   */
  getNativeElement() {
    return Promise.resolve(this.nativeInput);
  }
  componentWillLoad() {
    this.suffix = getSuffix(this.el, 'iress-radio');
    this.inputId = `iress-radio${this.suffix}-${radioIds++}`;
    this.radioGroup = this.el.closest('.iress-radio-group');
    if (this.radioGroup !== null) {
      this.name = this.radioGroup.name;
      this.required = this.radioGroup.required;
      this.hiddenControl = this.radioGroup.hiddenRadio;
      if (this.radioGroup.value !== '') {
        this.checked = this.value === this.radioGroup.value;
      }
    }
  }
  render() {
    return (h(Host, { class: {
        [RadioCssClass.Base]: true,
        [GlobalCssClass.FormElement]: true,
      } }, h("input", { type: "radio", value: this.value, name: this.name, id: this.inputId, checked: this.checked, class: RadioCssClass.Input, required: this.required, ref: (nativeInput) => (this.nativeInput = nativeInput), "data-testid": nativeTestid(this.el, 'input') }), h("label", { htmlFor: this.inputId, class: RadioCssClass.Label, onClick: this.onClick }, h("span", { class: {
        [RadioCssClass.Mark]: true,
        [GlobalCssClass.Hidden]: this.hiddenControl,
      } }), h("slot", null))));
  }
  get el() { return getElement(this); }
};
Radio.style = radioCss;

const radioGroupCss = ".sc-iress-radio-group-h{--iress-inline-spacing-x:var(--iress-radio-group-inline-spacing, var(--iress-g-spacing-md));--iress-inline-margin-bottom:var(--iress-radio-margin-bottom, var(--iress-g-spacing-sm))}.sc-iress-radio-group-h.iress-radio-group.sc-iress-radio-group-s>.sc-iress-radio-group{display:contents}.sc-iress-radio-group-h.sc-iress-radio-group-s>[data-wrapper-children]{flex-basis:100%}.iress-radio-group--block.sc-iress-radio-group-h,.iress-radio-group--stack.sc-iress-radio-group-h{display:flex;flex-wrap:wrap}.sc-iress-radio-group-h.iress-radio-group--stack.sc-iress-radio-group-s .iress-radio,.iress-radio-group--stack.sc-iress-radio-group-h .iress-radio.sc-iress-radio-group,.sc-iress-radio-group-h.iress-radio-group--block.sc-iress-radio-group-s .iress-radio,.iress-radio-group--block.sc-iress-radio-group-h .iress-radio.sc-iress-radio-group{flex-basis:100%;margin-block-start:var(--iress-margin-bottom)}.sc-iress-radio-group-h.iress-radio-group--stack.sc-iress-radio-group-s .iress-radio:first-child,.iress-radio-group--stack.sc-iress-radio-group-h .iress-radio.sc-iress-radio-group:first-child,.sc-iress-radio-group-h.iress-radio-group--block.sc-iress-radio-group-s .iress-radio:first-child,.iress-radio-group--block.sc-iress-radio-group-h .iress-radio.sc-iress-radio-group:first-child{margin-block-start:0}.sc-iress-radio-group-h.iress-radio-group--block.sc-iress-radio-group-s .iress-radio__label,.iress-radio-group--block.sc-iress-radio-group-h .iress-radio__label.sc-iress-radio-group{flex-basis:100%;display:flex}.iress-radio-group--inline.sc-iress-radio-group-h{margin-block-start:calc(-1 * var(--iress-inline-margin-bottom))}.iress-radio-group--inline.sc-iress-radio-group-h,.sc-iress-radio-group-h.iress-radio-group--inline.sc-iress-radio-group-s>[data-wrapper-children]{display:flex;flex-wrap:wrap;width:100%;flex-direction:row}.sc-iress-radio-group-h.iress-radio-group--inline.sc-iress-radio-group-s .iress-radio,.iress-radio-group--inline.sc-iress-radio-group-h .iress-radio.sc-iress-radio-group{margin-inline-end:var(--iress-inline-spacing-x);margin-block-start:var(--iress-inline-margin-bottom);flex-basis:auto;flex-grow:0}.sc-iress-radio-group-h.iress-radio-group--inline.sc-iress-radio-group-s .iress-radio:last-child,.iress-radio-group--inline.sc-iress-radio-group-h .iress-radio.sc-iress-radio-group:last-child{margin-inline-end:0}.sc-iress-radio-group-h.iress-view-mode-touch.iress-radio-group--inline-equal-width.sc-iress-radio-group-s .iress-radio,.iress-view-mode-touch .sc-iress-radio-group-h.iress-radio-group--inline-equal-width.sc-iress-radio-group-s .iress-radio,.iress-view-mode-touch.iress-radio-group--inline-equal-width.sc-iress-radio-group-h .iress-radio.sc-iress-radio-group,.iress-view-mode-touch .iress-radio-group--inline-equal-width.sc-iress-radio-group-h .iress-radio.sc-iress-radio-group{flex-basis:var(--iress-radio-group-inline-ew-flex-basis, auto);flex-grow:var(--iress-radio-group-inline-ew-flex-grow, 0)}.sc-iress-radio-group-h.iress-view-mode-touch.iress-radio-group--inline-equal-width.sc-iress-radio-group-s .iress-radio__label,.iress-view-mode-touch .sc-iress-radio-group-h.iress-radio-group--inline-equal-width.sc-iress-radio-group-s .iress-radio__label,.iress-view-mode-touch.iress-radio-group--inline-equal-width.sc-iress-radio-group-h .iress-radio__label.sc-iress-radio-group,.iress-view-mode-touch .iress-radio-group--inline-equal-width.sc-iress-radio-group-h .iress-radio__label.sc-iress-radio-group{width:var(--iress-radio-group-inline-ew-width, auto)}.sc-iress-radio-group-h.iress-view-mode-touch.iress-radio-group--inline-flex.sc-iress-radio-group-s .iress-radio,.iress-view-mode-touch .sc-iress-radio-group-h.iress-radio-group--inline-flex.sc-iress-radio-group-s .iress-radio,.iress-view-mode-touch.iress-radio-group--inline-flex.sc-iress-radio-group-h .iress-radio.sc-iress-radio-group,.iress-view-mode-touch .iress-radio-group--inline-flex.sc-iress-radio-group-h .iress-radio.sc-iress-radio-group{flex-grow:var(--iress-radio-group-inline-flex-flex-grow, 0)}.sc-iress-radio-group-h.iress-view-mode-touch.iress-radio-group--inline-flex.sc-iress-radio-group-s .iress-radio__label,.iress-view-mode-touch .sc-iress-radio-group-h.iress-radio-group--inline-flex.sc-iress-radio-group-s .iress-radio__label,.iress-view-mode-touch.iress-radio-group--inline-flex.sc-iress-radio-group-h .iress-radio__label.sc-iress-radio-group,.iress-view-mode-touch .iress-radio-group--inline-flex.sc-iress-radio-group-h .iress-radio__label.sc-iress-radio-group{width:var(--iress-radio-group-inline-flex-width, auto)}.sc-iress-radio-group-h.iress-radio-group--hidden-control.sc-iress-radio-group-s .iress-radio,.iress-radio-group--hidden-control.sc-iress-radio-group-h .iress-radio.sc-iress-radio-group{margin-inline-end:var(--iress-inline-spacing-x);margin-block-start:var(--iress-inline-margin-bottom);flex-basis:auto;flex-grow:0}.sc-iress-radio-group-h.iress-radio-group--hidden-control.sc-iress-radio-group-s .iress-radio__label,.iress-radio-group--hidden-control.sc-iress-radio-group-h .iress-radio__label.sc-iress-radio-group{padding:0;width:100%}.sc-iress-radio-group-h.iress-radio-group--hidden-control.sc-iress-radio-group-s .iress-radio__input:checked+.iress-radio__label,.iress-radio-group--hidden-control.sc-iress-radio-group-h .iress-radio__input.sc-iress-radio-group:checked+.iress-radio__label.sc-iress-radio-group{border:none;padding:var(--iress-label-border-width)}.sc-iress-radio-group-h.iress-radio-group--hidden-control.sc-iress-radio-group-s .iress-radio__input:checked+.iress-radio__label::after,.iress-radio-group--hidden-control.sc-iress-radio-group-h .iress-radio__input.sc-iress-radio-group:checked+.iress-radio__label.sc-iress-radio-group::after{--iress-border-width:var(--iress-label-border-width);content:\"\";position:absolute;inset:0;border-color:var(--iress-border-color);border-style:solid;border-width:calc(var(--iress-border-width) + 2px);border-radius:var(--iress-border-radius);pointer-events:none}.sc-iress-radio-group-h.iress-radio-group--hidden-control.iress-radio-group--block.sc-iress-radio-group-s .iress-radio,.iress-radio-group--hidden-control.iress-radio-group--block.sc-iress-radio-group-h .iress-radio.sc-iress-radio-group,.sc-iress-radio-group-h.iress-radio-group--hidden-control.iress-radio-group--stack.sc-iress-radio-group-s .iress-radio,.iress-radio-group--hidden-control.iress-radio-group--stack.sc-iress-radio-group-h .iress-radio.sc-iress-radio-group{flex-basis:100%}.sc-iress-radio-group-h.iress-radio-group--hidden-control.iress-radio-group--stack.sc-iress-radio-group-s .iress-radio__label,.iress-radio-group--hidden-control.iress-radio-group--stack.sc-iress-radio-group-h .iress-radio__label.sc-iress-radio-group{width:auto}.sc-iress-radio-group-h.iress-radio-group--hidden-control.iress-radio-group--inline.sc-iress-radio-group-s .iress-radio__label,.iress-radio-group--hidden-control.iress-radio-group--inline.sc-iress-radio-group-h .iress-radio__label.sc-iress-radio-group{display:block}.sc-iress-radio-group-h.iress-radio-group--hidden-control.iress-radio-group--inline-equal-width.sc-iress-radio-group-s .iress-radio,.iress-radio-group--hidden-control.iress-radio-group--inline-equal-width.sc-iress-radio-group-h .iress-radio.sc-iress-radio-group{flex-basis:0}.sc-iress-radio-group-h.iress-radio-group--hidden-control.iress-radio-group--inline-flex.sc-iress-radio-group-s .iress-radio,.iress-radio-group--hidden-control.iress-radio-group--inline-flex.sc-iress-radio-group-h .iress-radio.sc-iress-radio-group,.sc-iress-radio-group-h.iress-radio-group--hidden-control.iress-radio-group--inline-equal-width.sc-iress-radio-group-s .iress-radio,.iress-radio-group--hidden-control.iress-radio-group--inline-equal-width.sc-iress-radio-group-h .iress-radio.sc-iress-radio-group{flex-grow:1}.sc-iress-radio-group-h.iress-radio-group--hidden-control.iress-radio-group--inline-flex.sc-iress-radio-group-s .iress-radio__label,.iress-radio-group--hidden-control.iress-radio-group--inline-flex.sc-iress-radio-group-h .iress-radio__label.sc-iress-radio-group,.sc-iress-radio-group-h.iress-radio-group--hidden-control.iress-radio-group--inline-equal-width.sc-iress-radio-group-s .iress-radio__label,.iress-radio-group--hidden-control.iress-radio-group--inline-equal-width.sc-iress-radio-group-h .iress-radio__label.sc-iress-radio-group{width:100%}";

let radioGroupIds = 0;
const RadioGroup = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.iressChange = createEvent(this, "iressChange", 7);
    this.iressFocus = createEvent(this, "iressFocus", 7);
    this.iressBlur = createEvent(this, "iressBlur", 7);
    this.iressErrorChange = createEvent(this, "iressErrorChange", 7);
    this.hasFocus = false;
    this.hasFocusFn = hasFocus;
    /**
     * Flag for differentiating between when a user is clicking a checkbox and when values are being changed programmatically
     */
    this.userChange = false;
    this.error = false;
    /**
     * When true, marks the field as required
     */
    this.required = false;
    /**
     * Sets which of the block / inline layout options apply
     */
    this.layout = RadioGroupLayout.Stack;
    /**
     * Value of radio group. If set initially then the radio with this value will be checked
     */
    this.value = '';
    /**
     * Validity object of radio group, mirrors validity object in HTML form elements
     */
    this.validity = {
      valid: true,
      valueMissing: false,
    };
    /**
     * Validation message to be shown by iress-field when invalid
     */
    this.validationMessage = 'Please select a value';
    /**
     * Hides the radio control to allow the creation of custom radio buttons
     */
    this.hiddenRadio = false;
    this.getStatus = () => ({
      value: this.value,
      element: this.el,
      name: this.name,
      type: FormElementType.RadioGroup,
      required: this.required,
      error: !this.validity.valid ? this.validationMessage : '',
    });
  }
  updateFieldRequiredState(prev, current) {
    if (prev !== current && this.hasField)
      this.registerRadioGroup();
  }
  componentWillLoad() {
    var _a;
    this.suffix = getSuffix(this.el, 'iress-radio-group');
    this.groupId = `iress-radio-group${this.suffix}-${radioGroupIds++}`;
    this.name = (_a = this.name) !== null && _a !== void 0 ? _a : this.groupId;
    this.fieldEl = this.el.closest(`iress-field${this.suffix}`);
    this.hasField = this.fieldEl !== null && this.fieldEl !== undefined;
  }
  componentDidLoad() {
    this.updateValidity(true);
    if (this.hasField)
      this.registerRadioGroup();
    this.originalValue = this.value;
  }
  componentWillUpdate() {
    if (this.value !== this.originalValue) {
      this.originalValue = this.value;
      this.setChildrenChecked();
      this.checkValidity(true);
      if (!this.userChange)
        this.iressChange.emit(this.getStatus());
    }
    this.userChange = false;
  }
  disconnectedCallback() {
    if (this.hasField)
      this.unregisterRadioGroup();
  }
  // eslint-disable-next-line
  handleChange({ target }) {
    const { tagName } = target;
    const { value } = target;
    if (tagName === 'INPUT' && value !== '') {
      // This is a click event so we know this is being triggered by a user clicking a checkbox.
      // Update the userChange flag to`true` - this gets reset in the `value` @Watch function.
      this.userChange = true;
      this.updateValue(value);
      this.iressChange.emit(this.getStatus());
    }
  }
  // eslint-disable-next-line
  focusHandler() {
    if (this.hasFocusFn(this.el) && !this.hasFocus) {
      if (this.el.querySelector('input[type="radio"]:focus') !== null) {
        const firstRadio = this.el.querySelector('input[type="radio"]:first-child');
        if (firstRadio !== null)
          firstRadio.focus();
      }
      else {
        this.iressFocus.emit(this.getStatus());
        this.hasFocus = true;
      }
    }
  }
  // eslint-disable-next-line
  blurHandler() {
    setTimeout(() => {
      if (!this.hasFocusFn(this.el)) {
        this.iressBlur.emit(this.getStatus());
      }
    }, 20);
  }
  /**
   * Checks the validity of the radio group.
   */
  async checkValidity(valueUpdated = false) {
    if (!this.required)
      return true;
    const curValid = this.validity.valid;
    this.updateValidity(valueUpdated);
    if (this.validity.valid !== curValid || valueUpdated) {
      this.iressErrorChange.emit(this.getStatus());
    }
    return this.validity.valid;
  }
  /**
   * Validates the radio group.
   */
  async validate() {
    this.checkValidity(true);
    this.error = this.fieldEl.error !== '' || this.validity.valid === false;
  }
  /**
   * Resets the radio group
   */
  async reset() {
    this.validity = this.required
      ? {
        valid: false,
        valueMissing: true,
      }
      : {
        valid: true,
        valueMissing: false,
      };
    this.error = false;
    this.el.querySelectorAll(`.${RadioCssClass.Base}`).forEach((rad) => {
      rad.removeAttribute('checked');
    });
  }
  updateValidity(valueUpdated = false) {
    const selectedRadio = this.el.querySelector('input[type=radio]:checked');
    const selectedValue = selectedRadio !== null ? selectedRadio.getAttribute('value') : '';
    if (!valueUpdated)
      this.updateValue(selectedValue);
    if (this.required) {
      const valid = selectedValue !== '';
      if (this.validity.valid !== valid) {
        this.validity = {
          valid,
          valueMissing: !valid,
        };
      }
    }
  }
  async registerRadioGroup() {
    if (typeof this.fieldEl.registerInputElement === 'function')
      await this.fieldEl.registerInputElement(this.getStatus());
  }
  async unregisterRadioGroup() {
    if (typeof this.fieldEl.unregisterInputElement === 'function')
      await this.fieldEl.unregisterInputElement(this.getStatus());
  }
  updateValue(value) {
    if (value !== this.value) {
      this.value = value;
    }
  }
  async setChildrenChecked() {
    // Clear down existing checked state
    const allRadios = this.el.querySelectorAll(`.${RadioCssClass.Base}`);
    allRadios.forEach((rad) => rad.removeAttribute('checked'));
    // Set checked state based on value prop
    const radio = this.el.querySelector(`iress-radio${this.suffix}[value="${this.value}"]`);
    radio === null || radio === void 0 ? void 0 : radio.setAttribute('checked', '');
  }
  render() {
    var _a;
    const addInlineBaseClasses = this.layout === RadioGroupLayout.Inline ||
      this.layout === RadioGroupLayout.InlineFlex ||
      this.layout === RadioGroupLayout.InlineEqualWidth;
    return (h(Host, { class: {
        [RadioGroupCssClass.Base]: true,
        [GlobalCssClass.FormElement]: true,
        [GlobalCssClass.FormElementInvalid]: ((_a = this.fieldEl) === null || _a === void 0 ? void 0 : _a.error) !== '' || this.error === true,
        [RadioGroupCssClass.InlineBase]: addInlineBaseClasses,
        [`${RadioGroupCssClass.Base}--${this.layout}`]: this.layout !== RadioGroupLayout.Inline,
        [RadioGroupCssClass.HiddenControl]: this.hiddenRadio,
      }, "data-iress-required": this.required }, h("slot", null)));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "required": ["updateFieldRequiredState"]
  }; }
};
RadioGroup.style = radioGroupCss;

var ComboboxCssClass;
(function (ComboboxCssClass) {
  ComboboxCssClass["Base"] = "iress-combobox";
  ComboboxCssClass["Input"] = "iress-combobox__input";
  ComboboxCssClass["Menu"] = "iress-combobox__menu";
  ComboboxCssClass["HiddenInput"] = "iress-combobox__hidden-input";
  ComboboxCssClass["Popover"] = "iress-combobox__popover";
  ComboboxCssClass["OptionMeta"] = "iress-combobox__option-meta";
  ComboboxCssClass["TagListInput"] = "iress-combobox__tag-list-input";
  ComboboxCssClass["TagListInputWrapper"] = "iress-combobox__tag-list-input__wrapper";
  ComboboxCssClass["TagListInputWrapperInner"] = "iress-combobox__tag-list-input__wrapper-inner";
  ComboboxCssClass["TagListInputLabel"] = "iress-combobox__tag-list-input__label";
  ComboboxCssClass["Multiple"] = "iress-combobox__multiple";
  ComboboxCssClass["Watermark"] = "iress-combobox__watermark";
})(ComboboxCssClass || (ComboboxCssClass = {}));
var ComboboxSlot;
(function (ComboboxSlot) {
  ComboboxSlot["Prepend"] = "prepend";
  ComboboxSlot["Append"] = "append";
})(ComboboxSlot || (ComboboxSlot = {}));

var MenuItemCssClass;
(function (MenuItemCssClass) {
  MenuItemCssClass["Base"] = "iress-menu-item";
  MenuItemCssClass["Selected"] = "iress-menu-item--selected";
  MenuItemCssClass["Button"] = "iress-menu-item__button";
  MenuItemCssClass["Header"] = "iress-menu-item__header";
  MenuItemCssClass["Inner"] = "iress-menu-item__inner";
  MenuItemCssClass["HeaderSlots"] = "iress-menu-item__header--slots";
  MenuItemCssClass["Divider"] = "iress-menu-item--divider";
  MenuItemCssClass["MultiSelect"] = "iress-menu-item--multi-select";
})(MenuItemCssClass || (MenuItemCssClass = {}));
var MenuItemSlot;
(function (MenuItemSlot) {
  MenuItemSlot["Prepend"] = "prepend";
  MenuItemSlot["Append"] = "append";
  MenuItemSlot["IconOnly"] = "icon-only";
})(MenuItemSlot || (MenuItemSlot = {}));
var MenuItemRole;
(function (MenuItemRole) {
  MenuItemRole["ListItem"] = "listitem";
  MenuItemRole["Option"] = "option";
})(MenuItemRole || (MenuItemRole = {}));

var TextCssClass;
(function (TextCssClass) {
  TextCssClass["Base"] = "iress-text";
  TextCssClass["NoGutter"] = "iress-text--no-gutter";
  TextCssClass["Inline"] = "iress-text--inline";
  TextCssClass["Heading"] = "iress-text--heading";
  TextCssClass["Display"] = "iress-text--display";
})(TextCssClass || (TextCssClass = {}));
var TextVariant;
(function (TextVariant) {
  TextVariant["Blockquote"] = "blockquote";
  TextVariant["Body"] = "body";
  TextVariant["Bold"] = "bold";
  TextVariant["Buy"] = "buy";
  TextVariant["Code"] = "code";
  TextVariant["Danger"] = "danger";
  TextVariant["Display"] = "display";
  TextVariant["Display1"] = "display1";
  TextVariant["Display2"] = "display2";
  TextVariant["Display3"] = "display3";
  TextVariant["Display4"] = "display4";
  TextVariant["Heading1"] = "h1";
  TextVariant["Heading2"] = "h2";
  TextVariant["Heading3"] = "h3";
  TextVariant["Heading4"] = "h4";
  TextVariant["Heading5"] = "h5";
  TextVariant["Heading6"] = "h6";
  TextVariant["Info"] = "info";
  TextVariant["Italic"] = "italic";
  TextVariant["Lead"] = "lead";
  TextVariant["Muted"] = "muted";
  TextVariant["Sell"] = "sell";
  TextVariant["Small"] = "small";
  TextVariant["Success"] = "success";
  TextVariant["Warning"] = "warning";
})(TextVariant || (TextVariant = {}));
var TextElement;
(function (TextElement) {
  TextElement["P"] = "p";
  TextElement["Div"] = "div";
  TextElement["Span"] = "span";
  TextElement["H1"] = "h1";
  TextElement["H2"] = "h2";
  TextElement["H3"] = "h3";
  TextElement["H4"] = "h4";
  TextElement["H5"] = "h5";
  TextElement["H6"] = "h6";
  TextElement["Code"] = "code";
  TextElement["Blockquote"] = "blockquote";
  TextElement["Caption"] = "caption";
  TextElement["Cite"] = "cite";
  TextElement["Small"] = "small";
})(TextElement || (TextElement = {}));

const ResultsMenu = ({ results, noResultsText, resultLimitMobile, onChange, dataTestId, suffix, tags, }) => {
  const Menu = `iress-menu${suffix}`;
  const MenuItem = `iress-menu-item${suffix}`;
  const Text = `iress-text${suffix}`;
  const allowedTextVariants = [
    TextVariant.Body,
    TextVariant.Bold,
    TextVariant.Buy,
    TextVariant.Danger,
    TextVariant.Info,
    TextVariant.Italic,
    TextVariant.Muted,
    TextVariant.Sell,
    TextVariant.Small,
    TextVariant.Success,
    TextVariant.Warning,
  ];
  const renderLabel = (label) => (h("span", { ref: (el) => (el !== null ? (el.innerHTML = label) : null) }));
  const renderSlotContent = (slot, content) => {
    if (content === null || content === undefined)
      return null;
    return (h("div", { slot: slot, ref: (el) => {
        if (el !== null) {
          el.innerHTML = '';
          el.appendChild(content);
        }
      } }));
  };
  const renderMetaText = (meta) => {
    if (typeof meta === 'string')
      return (h(Text, { variant: TextVariant.Muted },
        h("span", { ref: (el) => el !== null ? (el.innerHTML = meta) : null })));
    return (h(Text, { variant: allowedTextVariants.includes(meta.variant)
        ? meta.variant
        : TextVariant.Muted },
      h("span", { ref: (el) => el !== null ? (el.innerHTML = meta.text) : null })));
  };
  const renderMeta = (metaData) => {
    const hasMeta = metaData !== undefined && metaData !== null && metaData !== '';
    if (!hasMeta)
      return null;
    if (typeof metaData === 'string') {
      return (h("div", { class: `${ComboboxCssClass.OptionMeta}` }, renderMetaText(metaData)));
    }
    return (h("div", { class: `${ComboboxCssClass.OptionMeta}` }, metaData.map((meta) => renderMetaText(meta))));
  };
  const renderResultItems = () => {
    if (results === null)
      return null;
    return results.length > 0 ? (results.map((item, index) => {
      const className = index > resultLimitMobile - 1
        ? GlobalCssClass.HiddenMobile
        : '';
      const selected = tags.includes(item.label.replace('<b>', '').replace('</b>', ''));
      return (h(MenuItem, { value: item.value, class: className, selected: selected },
        renderLabel(item.label),
        renderSlotContent(MenuItemSlot.Append, item.append),
        renderSlotContent(MenuItemSlot.Prepend, item.prepend),
        renderMeta(item.meta)));
    })) : (h(Text, null, noResultsText));
  };
  return (h(Menu, { class: ComboboxCssClass.Menu, "data-testid": dataTestId, onIressChange: onChange, changeOnBlur: true, controlledMenuItems: true }, renderResultItems()));
};

var InputCssClass;
(function (InputCssClass) {
  InputCssClass["Base"] = "iress-input";
  InputCssClass["NativeInput"] = "iress-input__native-input";
  InputCssClass["TextArea"] = "iress-input--textarea";
  InputCssClass["Label"] = "iress-input__label";
  InputCssClass["Watermark"] = "iress-input--watermark";
  InputCssClass["Clearable"] = "iress-input--clearable";
  InputCssClass["Clear"] = "iress-input__clear";
  InputCssClass["ClearShown"] = "iress-input--clear-shown";
  InputCssClass["Width2"] = "iress-input--width-2";
  InputCssClass["Width4"] = "iress-input--width-4";
  InputCssClass["Width6"] = "iress-input--width-6";
  InputCssClass["Width8"] = "iress-input--width-8";
  InputCssClass["Width10"] = "iress-input--width-10";
  InputCssClass["Width12"] = "iress-input--width-12";
  InputCssClass["Width16"] = "iress-input--width-16";
  InputCssClass["Width25Perc"] = "iress-input--width-25-perc";
  InputCssClass["Width50Perc"] = "iress-input--width-50-perc";
  InputCssClass["Width75Perc"] = "iress-input--width-75-perc";
  InputCssClass["Focus"] = "iress-input--focus";
  InputCssClass["HiddenLabel"] = "iress-input--hiddenlabel";
  InputCssClass["Error"] = "iress-input--error";
  InputCssClass["Prepend"] = "iress-input--addon-prepend";
  InputCssClass["Append"] = "iress-input--addon-append";
  InputCssClass["InputWrapper"] = "iress-input__wrapper";
  InputCssClass["AddOn"] = "iress-input__addon";
  InputCssClass["AppendAddon"] = "iress-input__addon--append";
  InputCssClass["PrependAddon"] = "iress-input__addon--prepend";
  InputCssClass["Loading"] = "iress-input--loading";
  InputCssClass["Internal"] = "iress-input__internal";
})(InputCssClass || (InputCssClass = {}));
var InputSlot;
(function (InputSlot) {
  InputSlot["Prepend"] = "prepend";
  InputSlot["Append"] = "append";
  InputSlot["Internal"] = "internal";
})(InputSlot || (InputSlot = {}));
var InputMode;
(function (InputMode) {
  InputMode["None"] = "none";
  InputMode["Text"] = "text";
  InputMode["Tel"] = "tel";
  InputMode["Url"] = "url";
  InputMode["Email"] = "email";
  InputMode["Numeric"] = "numeric";
  InputMode["Decimal"] = "decimal";
  InputMode["Search"] = "search";
})(InputMode || (InputMode = {}));
var InputWidth;
(function (InputWidth) {
  InputWidth["Two"] = "2";
  InputWidth["Four"] = "4";
  InputWidth["Six"] = "6";
  InputWidth["Eight"] = "8";
  InputWidth["Ten"] = "10";
  InputWidth["Twelve"] = "12";
  InputWidth["Sixteen"] = "16";
  InputWidth["TwentyFivePercent"] = "25Perc";
  InputWidth["FiftyPercent"] = "50Perc";
  InputWidth["SeventyFivePercent"] = "75Perc";
})(InputWidth || (InputWidth = {}));

var FieldAttributes;
(function (FieldAttributes) {
  FieldAttributes["Required"] = "required";
  FieldAttributes["DataRequired"] = "data-iress-required";
  FieldAttributes["Name"] = "name";
  FieldAttributes["DisabledValidation"] = "disabled-validation";
  FieldAttributes["OptionalLabels"] = "optional-labels";
})(FieldAttributes || (FieldAttributes = {}));
var FieldCssClass;
(function (FieldCssClass) {
  FieldCssClass["Base"] = "iress-field";
  FieldCssClass["Inline"] = "iress-field--inline";
  FieldCssClass["Stack"] = "iress-field--stack";
  FieldCssClass["Join"] = "iress-field--join";
  FieldCssClass["Invalid"] = "iress-field--invalid";
  FieldCssClass["Hint"] = "iress-field__hint";
  FieldCssClass["Errors"] = "iress-field__errors";
  FieldCssClass["InputContainer"] = "iress-field__input-container";
  FieldCssClass["InputInnerContainer"] = "iress-field__input-inner";
  FieldCssClass["Wrapper"] = "iress-field__wrapper";
  FieldCssClass["Legend"] = "iress-field__legend";
  FieldCssClass["Label"] = "iress-field__label";
})(FieldCssClass || (FieldCssClass = {}));
var FieldTagTypes;
(function (FieldTagTypes) {
  FieldTagTypes["Fieldset"] = "fieldset";
  FieldTagTypes["Div"] = "div";
  FieldTagTypes["Legend"] = "legend";
  FieldTagTypes["Label"] = "iress-label";
})(FieldTagTypes || (FieldTagTypes = {}));
var FieldSlot;
(function (FieldSlot) {
  FieldSlot["Hint"] = "hint";
})(FieldSlot || (FieldSlot = {}));

const fieldCss = ".sc-iress-field-h{--iress-font-family:var(--iress-label-font-family,\n          var(--iress-a-form-font-family,\n              var(--iress-g-font-family, inherit\n  )));--iress-font-size:var(--iress-label-font-size, inherit);--iress-font-weight:var(--iress-label-font-weight, bold);--iress-line-height:var(--iress-field-line-height,\n          var(--iress-a-form-line-height,\n              var(--iress-g-line-height, 1.5\n  )));--iress-border-left-width:var(--iress-field-border-left-width, 2px);--iress-focus-border-color:var(--iress-field-focus-border-color, var(--iress-border-color));--iress-margin-x:var(--iress-field-margin-x, 0);--iress-background-color:var(--iress-field-background-color, transparent);--iress-focus-background-color:var(--iress-field-focus-background-color, var(--iress-background-color));--iress-transition:var(--iress-field-transition, none);--iress-hint-text-color:var(--iress-field-hint-text-color,\n          var(--iress-g-muted-text-color,\n              var(--iress-default-text-color--light\n  )));--iress-hint-font-weight:var(--iress-field-hint-font-weight,\n          var(--iress-a-muted-font-weight,\n              var(--iress-g-font-weight,\n                  lighter\n  )));--iress-multi-elements-label-text-color:var(--iress-field-multi-elements-label-text-color,\n          var(--iress-g-muted-text-color,\n              var(--iress-default-text-color--light\n  )));--iress-required-text-color:var(--iress-label-required-text-color,\n          var(--iress-a-danger-text-color,\n              var(--iress-g-danger-color,\n                  var(--iress-default-danger-color\n  ))));--iress-text-color:var(--iress-label-text-color,\n          var(--iress-a-label-text-color,\n              var(--iress-g-text-color,\n                  inherit\n  )));--iress-max-width:100%;--iress-input-spacing-y:var(--iress-a-vertical-spacing-sm, var(--iress-g-spacing-sm));--iress-input-spacing-x:var(--iress-a-horizontal-spacing-sm, var(--iress-g-spacing-sm));--iress-optional-font-weight:var(--iress-label-optional-font-weight,\n          var(--iress-a-muted-font-weight,\n              var(--iress-g-font-weight, inherit\n      )));--iress-optional-text-color:var(--iress-label-optional-text-color, var(--iress-default-text-color--light));--iress-optional-font-size:var(--iress-label-meta-font-size,\n          var(--iress-g-font-size-xxxs,\n              var(--iress-g-font-size-rem,\n                  0.875em\n              )))}.iress-field--invalid.sc-iress-field-h{--iress-field-spacing-left:var(--iress-g-spacing-sm);--iress-border-color:var(--iress-field-element-invalid-border-color,\n          var(--iress-a-danger-border-color,\n              var(--iress-g-danger-color,\n                  var(--iress-default-danger-color\n  ))));--iress-focus-border-color:var(--iress-field-element-invalid-focus-border-color, var(--iress-border-color))}.sc-iress-field-h{font-family:var(--iress-font-family);font-size:var(--iress-font-size);font-weight:var(--iress-font-weight);--iress-label-ele-text-color:var(--iress-text-color);line-height:var(--iress-line-height);margin-inline-start:var(--iress-margin-x);margin-inline-end:var(--iress-margin-x);background-color:var(--iress-background-color);transition:var(--iress-transition);max-width:var(--iress-max-width);color:var(--iress-text-color);display:block}.sc-iress-field-h:focus-within{background-color:var(--iress-focus-background-color);border-color:var(--iress-focus-border-color)}.sc-iress-field-h .iress-field__label.sc-iress-field{--iress-text-color:var(--iress-label-ele-text-color)}.sc-iress-field-h .iress-field__hint.sc-iress-field,.sc-iress-field-h .iress-field__hint.sc-iress-field-s>.iress-text{color:var(--iress-hint-text-color);font-weight:var(--iress-hint-font-weight);display:block}.sc-iress-field-h .iress-label__required.sc-iress-field,.sc-iress-field-h .iress-label__optional.sc-iress-field{font-style:var(--iress-meta-font-style);font-size:var(--iress-meta-font-size);display:inline-block}.sc-iress-field-h .iress-label__required.sc-iress-field{color:var(--iress-required-text-color);font-weight:var(--iress-font-weight-base-bold, bold);top:calc(var(--iress-g-spacing-xs) * -1);position:relative;margin-inline-end:calc(0.25 * var(--iress-g-spacing-rem));margin-inline-start:0}.sc-iress-field-h .iress-label__optional.sc-iress-field{margin-inline-start:calc(0.25 * var(--iress-g-spacing-rem));margin-inline-end:0;color:var(--iress-optional-text-color);font-weight:var(--iress-optional-font-weight);font-size:var(--iress-optional-font-size)}.sc-iress-field-h fieldset.sc-iress-field{border:none;margin:0;padding:0}.sc-iress-field-h .iress-field__legend.sc-iress-field{padding-inline-start:0;padding-inline-end:0;color:var(--iress-text-color);font-size:var(--iress-font-size);font-weight:var(--iress-font-weight)}.sc-iress-field-h>.iress-field__wrapper.sc-iress-field label.sc-iress-field{color:var(--iress-label-text-color, inherit)}.sc-iress-field-h .iress-field__input-container.sc-iress-field{margin-block-start:var(--iress-g-spacing-xs)}.sc-iress-field-h .iress-label--hidden.sc-iress-field+.iress-field__input-container.sc-iress-field{margin-block-start:0}.iress-field--invalid.sc-iress-field-h{padding-inline-start:var(--iress-field-spacing-left);border-inline-start:var(--iress-border-left-width) solid var(--iress-border-color)}.sc-iress-field-h.iress-field--invalid .iress-field__input-container.sc-iress-field-s>.iress-form-element--invalid,.sc-iress-field-h.iress-field--invalid .iress-field__input-container.sc-iress-field-s .iress-form-element--invalid,.sc-iress-field-h.iress-field--invalid .iress-field__input-container.sc-iress-field-s>.iress-form-element--invalid .iress-form-element{--iress-border-color:var(--iress-field-element-invalid-border-color,\n          var(--iress-a-danger-border-color,\n              var(--iress-g-danger-color,\n                  var(--iress-default-danger-color\n  ))))}.iress-field--stack.sc-iress-field-h .iress-field__input-container.sc-iress-field>*.sc-iress-field:not([data-wrapper-children]),.sc-iress-field-h.iress-field--stack .sc-iress-field-s>*:not([data-wrapper-children]),.sc-iress-field-h.iress-field--stack .sc-iress-field-s>[data-wrapper-children]>*{padding-block-end:var(--iress-g-spacing-md)}.iress-field--stack.sc-iress-field-h .iress-field__input-container.sc-iress-field>*.sc-iress-field:last-child:not([data-wrapper-children]),.sc-iress-field-h.iress-field--stack .sc-iress-field-s>*:last-child:not([data-wrapper-children]),.sc-iress-field-h.iress-field--stack .sc-iress-field-s>[data-wrapper-children]>*:last-child{padding-block-end:0}.sc-iress-field-h .iress-field__input-container.sc-iress-field-s .iress-label{--iress-line-height:1;--iress-text-color:var(--iress-multi-elements-label-text-color)}.iress-field--inline.sc-iress-field-h .iress-field__input-container.sc-iress-field,.sc-iress-field-h.iress-field--inline .iress-field__input-container.sc-iress-field-s>[data-wrapper-children]{display:flex;flex-wrap:wrap;align-items:flex-end;flex-grow:1}.iress-field--inline.sc-iress-field-h .iress-field__input-container.sc-iress-field{margin-block-start:0}.sc-iress-field-h.iress-field--inline .sc-iress-field-s>.iress-input,.sc-iress-field-h.iress-field--inline .sc-iress-field-s>[data-wrapper-children] .iress-input,.sc-iress-field-h.iress-field--inline .sc-iress-field-s>.iress-select,.sc-iress-field-h.iress-field--inline .sc-iress-field-s>[data-wrapper-children] .iress-select,.sc-iress-field-h.iress-field--inline .sc-iress-field-s>.iress-button,.sc-iress-field-h.iress-field--inline .sc-iress-field-s>[data-wrapper-children]>.iress-button{margin-block-start:var(--iress-input-spacing-y)}.iress-field--inline.sc-iress-field-h .iress-input.sc-iress-field:not([class*=iress-input--width]),.iress-field--inline.sc-iress-field-h [data-wrapper-children].sc-iress-field .iress-input.sc-iress-field:not([class*=iress-input--width]),.sc-iress-field-h.iress-field--inline .sc-iress-field-s>.iress-input:not([class*=iress-input--width]),.sc-iress-field-h.iress-field--inline .sc-iress-field-s>[data-wrapper-children] .iress-input:not([class*=iress-input--width]),.iress-field--inline.sc-iress-field-h .iress-select.sc-iress-field:not([class*=iress-select--width]),.iress-field--inline.sc-iress-field-h [data-wrapper-children].sc-iress-field .iress-select.sc-iress-field:not([class*=iress-select--width]),.sc-iress-field-h.iress-field--inline .sc-iress-field-s>.iress-select:not([class*=iress-select--width]),.sc-iress-field-h.iress-field--inline .sc-iress-field-s>[data-wrapper-children] .iress-select:not([class*=iress-select--width]){display:block;flex-grow:1}.sc-iress-field-h.iress-field--inline .iress-field__input-container.sc-iress-field-s>*:not([data-wrapper-children]),.sc-iress-field-h.iress-field--inline .iress-field__input-container.sc-iress-field-s>[data-wrapper-children]>*{padding-inline-end:var(--iress-g-spacing-sm)}.sc-iress-field-h.iress-field--inline .iress-field__input-container.sc-iress-field-s>*:not([data-wrapper-children]):last-child,.sc-iress-field-h.iress-field--inline .iress-field__input-container.sc-iress-field-s>[data-wrapper-children]>*:last-child,.sc-iress-field-h.iress-field--join .iress-field__input-container.sc-iress-field-s>*:not([data-wrapper-children]),.sc-iress-field-h.iress-field--join .iress-field__input-container.sc-iress-field-s>[data-wrapper-children]>*{padding-inline-end:0}.iress-field--join.sc-iress-field-h .iress-field__input-container.sc-iress-field,.sc-iress-field-h.iress-field--join .iress-field__input-container.sc-iress-field-s>[data-wrapper-children]{flex-wrap:nowrap}.iress-field--join.sc-iress-field-h .iress-input.sc-iress-field:not(:last-child) .iress-input__native-input.sc-iress-field,.sc-iress-field-h.iress-field--join .sc-iress-field-s>.iress-input:not(:last-child) .iress-input__native-input,.sc-iress-field-h.iress-field--join .iress-field__input-container.sc-iress-field-s>[data-wrapper-children] .iress-input:not(:last-child) .iress-input__native-input,.iress-field--join.sc-iress-field-h .iress-input.sc-iress-field:not(:last-child) .iress-input__wrapper.sc-iress-field,.sc-iress-field-h.iress-field--join .sc-iress-field-s>.iress-input:not(:last-child) .iress-input__wrapper,.sc-iress-field-h.iress-field--join .iress-field__input-container.sc-iress-field-s>[data-wrapper-children] .iress-input:not(:last-child) .iress-input__wrapper,.iress-field--join.sc-iress-field-h .iress-select.sc-iress-field:not(:last-child) .iress-select__select.sc-iress-field,.sc-iress-field-h.iress-field--join .sc-iress-field-s>.iress-select:not(:last-child) .iress-select__select,.sc-iress-field-h.iress-field--join .iress-field__input-container.sc-iress-field-s>[data-wrapper-children] .iress-select:not(:last-child) .iress-select__select,.iress-field--join.sc-iress-field-h .iress-button.sc-iress-field:not(:last-child) .iress-button__button.sc-iress-field,.sc-iress-field-h.iress-field--join .sc-iress-field-s>.iress-button:not(:last-child) .iress-button__button,.sc-iress-field-h.iress-field--join .iress-field__input-container.sc-iress-field-s>[data-wrapper-children] .iress-button:not(:last-child) .iress-button__button{border-start-end-radius:0;border-end-end-radius:0;border-inline-end:none}.iress-field--join.sc-iress-field-h .iress-input.sc-iress-field:not(:first-child) .iress-input__native-input.sc-iress-field,.sc-iress-field-h.iress-field--join .sc-iress-field-s>.iress-input:not(:first-child) .iress-input__native-input,.sc-iress-field-h.iress-field--join .iress-field__input-container.sc-iress-field-s>[data-wrapper-children] .iress-input:not(:first-child) .iress-input__native-input,.iress-field--join.sc-iress-field-h .iress-input.sc-iress-field:not(:first-child) .iress-input__wrapper.sc-iress-field,.sc-iress-field-h.iress-field--join .sc-iress-field-s>.iress-input:not(:first-child) .iress-input__wrapper,.sc-iress-field-h.iress-field--join .iress-field__input-container.sc-iress-field-s>[data-wrapper-children] .iress-input:not(:first-child) .iress-input__wrapper,.iress-field--join.sc-iress-field-h .iress-select.sc-iress-field:not(:first-child) .iress-select__select.sc-iress-field,.sc-iress-field-h.iress-field--join .sc-iress-field-s>.iress-select:not(:first-child) .iress-select__select,.sc-iress-field-h.iress-field--join .iress-field__input-container.sc-iress-field-s>[data-wrapper-children] .iress-select:not(:first-child) .iress-select__select,.iress-field--join.sc-iress-field-h .iress-button.sc-iress-field:not(:first-child) .iress-button__button.sc-iress-field,.sc-iress-field-h.iress-field--join .sc-iress-field-s>.iress-button:not(:first-child) .iress-button__button,.sc-iress-field-h.iress-field--join .iress-field__input-container.sc-iress-field-s>[data-wrapper-children] .iress-button:not(:first-child) .iress-button__button{border-start-start-radius:0;border-end-start-radius:0}.sc-iress-field-h .iress-field__validation-message.iress-validation-message.sc-iress-field .iress-validation-message__wrapper.sc-iress-field{text-decoration:none}.iress-table.sc-iress-field-h,.iress-table .sc-iress-field-h{flex-grow:1}.iress-table.sc-iress-field-h .iress-label--hidden.sc-iress-field+.iress-field__input-container.sc-iress-field,.iress-table .sc-iress-field-h .iress-label--hidden.sc-iress-field+.iress-field__input-container.sc-iress-field{--iress-negative-margin:calc(var(--iress-input-padding-y, var(--iress-default-spacing-sm)) + var(--iress-input-border-width, 1px));margin-block-start:calc(min(var(--iress-row-spacing), var(--iress-negative-margin)) * -1)}.iress-view-mode-compact.sc-iress-field-h .iress-table.sc-iress-field,.iress-view-mode-compact .iress-table .sc-iress-field-h{--iress-padding-y:1px;--iress-input-min-height:calc(1.5 * var(--iress-g-spacing-rem));padding-block-start:revert;padding-block-end:revert}.iress-view-mode-compact.sc-iress-field-h .iress-table.sc-iress-field .iress-label--hidden.sc-iress-field+.iress-field__input-container.sc-iress-field,.iress-view-mode-compact .iress-table .sc-iress-field-h .iress-label--hidden.sc-iress-field+.iress-field__input-container.sc-iress-field{margin-block-start:calc(var(--iress-input-border-width, 1px) * -1)}";

const Field = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.iressFieldDidLoad = createEvent(this, "iressFieldDidLoad", 7);
    this.iressFieldDidUnload = createEvent(this, "iressFieldDidUnload", 7);
    this.fieldElements = [];
    this.validate = true;
    this.isInputGroup = false;
    this.errors = [];
    this.required = null;
    this.firstErrIndex = 0;
    this.optional = false;
    /**
     * Error text for when using as a controlled component
     */
    this.error = '';
    /**
     * Setting to true will disable the validation on the field
     */
    this.disabledValidation = false;
    /**
     * Visually hides the label text, but still available to screenreaders
     */
    this.hiddenLabel = false;
    /**
     * Text that is added to a label to mark a field as optional
     */
    this.optionalText = '(optional)';
    this.validateFieldElements = () => {
      if (!hasFocus(this.el)) {
        for (const el of this.fieldElements) {
          if (el && !el.hasAttribute('readonly'))
            this.updateErrors(el);
        }
        this.validateField();
      }
    };
    this.getValidationMessage = (errorMessages, ele) => {
      let msg;
      // Need to use reverse() as date inputs with invalid dates don't have a value, so will fail valueMissing as well as badInput.
      // This means the error will always be valueMissing, as this comes last in the Object.keys array, so will overwrite the badInput error
      Object.keys(errorMessages)
        .reverse()
        .forEach((errorKey) => {
        if (ele.validity && ele.validity[errorKey]) {
          msg = errorMessages[errorKey]
            ? getValidationMessage(errorMessages, ele, 0)
            : ele.validationMessage;
        }
      });
      return msg;
    };
    this.hasDisableValidation = () => {
      if (this.disabledValidation)
        return true;
      return (this.form &&
        (this.form.getAttribute(FieldAttributes.DisabledValidation) ===
          'true' ||
          this.form.hasAttribute(FieldAttributes.DisabledValidation)));
    };
    this.hasOptionalFieldLabels = () => this.form &&
      (this.form.getAttribute(FieldAttributes.OptionalLabels) === 'true' ||
        this.form.getAttribute(FieldAttributes.OptionalLabels) === '');
    this.getEleCount = () => {
      const eleTags = [
        `iress-input${this.suffix}`,
        `iress-select${this.suffix}`,
        `iress-checkbox${this.suffix}`,
        `iress-combobox${this.suffix}`,
        'select',
      ];
      let eleCount = 0;
      eleTags.forEach((tag) => (eleCount += this.el.querySelectorAll(tag).length));
      return eleCount;
    };
    this.hasMultipleInputs = () => {
      if (this.el.querySelectorAll(`iress-radio-group${this.suffix}`).length >
        0 ||
        this.el.querySelectorAll(`iress-checkbox-group${this.suffix}`)
          .length > 0) {
        return true;
      }
      if (this.getEleCount() > 1)
        return true;
      return false;
    };
    this.addOrUpdateError = (valid, nameIndex, message, el, existingMessage) => {
      if (valid !== true && existingMessage === undefined) {
        if (nameIndex >= 0) {
          this.updateError(nameIndex, message);
        }
        else {
          this.addError({
            targetId: el.name,
            message,
          });
        }
      }
    };
    this.getElementError = async (el) => {
      const combobox = el.closest(`.${ComboboxCssClass.Base}`);
      if (combobox === null) {
        el.tagName.indexOf('IRESS-') > -1
          ? await el.checkValidity()
          : el.checkValidity();
        return (this.getValidationMessage(getErrorMessageTemplates(this), el) ||
          '');
      }
      else {
        const validity = await combobox.checkValidity();
        return (validity.msg ||
          this.getValidationMessage(getErrorMessageTemplates(this), el) ||
          '');
      }
    };
    this.updateErrors = async (el) => {
      if (this.error !== '' || el === undefined)
        return;
      const message = await this.getElementError(el);
      const valid = message === '';
      const nameIndex = this.errors.findIndex((error) => error.targetId === el.name);
      const existingMessage = this.errors.find((error) => error.message === message);
      this.addOrUpdateError(valid, nameIndex, message, el, existingMessage);
      if (valid && nameIndex >= 0) {
        this.removeError(nameIndex);
      }
      const firstErr = this.el.querySelector(`.${GlobalCssClass.FormElementInvalid}`);
      if (firstErr !== null && this.errors.length > 0) {
        const index = this.errors.findIndex((err) => err.targetId === firstErr.getAttribute('name'));
        this.firstErrIndex = index > -1 ? index : 0;
      }
    };
    this.addError = (error) => {
      this.errors = [...this.errors, error];
    };
    this.updateError = (i, errorMessage) => {
      const errors = [...this.errors];
      errors[i].message = errorMessage;
      this.errors = errors;
    };
    this.removeError = (i) => {
      const errors = [...this.errors];
      errors.splice(i, 1);
      this.errors = errors;
    };
    this.getLabelProps = () => {
      this.setForInput();
      const labelProps = {
        ['for']: this.forinput,
        focusOn: false,
        labelText: this.label,
        required: this.required && !this.optional,
        optional: this.optional && !this.required,
        optionalText: this.optionalText,
        hiddenLabel: this.hiddenLabel,
      };
      if (this.isInputGroup) {
        delete labelProps.for;
        delete labelProps.focusOn;
      }
      return labelProps;
    };
    this.legendText = (labelProps) => (h("span", { class: LabelCssClass.LabelText }, labelProps.required && (h("span", { class: LabelCssClass.Required }, h("span", { "aria-hidden": "true" }, "*"), h("span", { class: GlobalCssClass.SROnly }, "Required"))), labelProps.labelText, labelProps.optional && (h("span", { class: LabelCssClass.Optional }, this.optionalText))));
    this.getHintText = () => (h("div", { class: {
        [FieldCssClass.Hint]: true,
        [GlobalCssClass.SROnly]: this.hiddenLabel === true,
      } }, this.hint !== undefined ? (this.hint) : (h("slot", { name: FieldSlot.Hint }))));
    this.getErrorContent = () => {
      if (this.error !== undefined || this.errors.length > 0) {
        const ValidationMessage = `iress-validation-message${this.suffix}`;
        const ValidationSummary = `iress-validation-summary${this.suffix}`;
        return (h("div", { class: FieldCssClass.Errors }, this.error !== '' ||
          (this.errors.length > 0 && this.isInputGroup === false) ? (h(ValidationMessage, { class: "iress-field__validation-message", status: SystemValidationStatus.Error }, this.error ||
          this.errors[this.firstErrIndex].message)) : null, this.error === '' &&
          this.errors.length > 0 &&
          this.isInputGroup === true ? (h(ValidationSummary, { messages: this.errors })) : null));
      }
      return null;
    };
    this.getHostCssClassMap = () => ({
      [FieldCssClass.Base]: true,
      [FieldCssClass.Inline]: this.inline === true,
      [FieldCssClass.Stack]: this.inline !== true,
      [FieldCssClass.Join]: this.join === true,
      [FieldCssClass.Invalid]: this.errors.length > 0 || this.error !== '',
    });
    this.slotWrapper = () => (h("div", { class: `${FieldCssClass.InputContainer} ${this.inline ? '' : `${FieldCssClass.Stack}`}` }, h("slot", null)));
    this.renderInputGroup = (labelProps) => (h("fieldset", { class: FieldCssClass.Wrapper }, h("legend", Object.assign({}, labelProps, { class: FieldCssClass.Legend }), h("div", { class: this.hiddenLabel ? GlobalCssClass.SROnly : '' }, this.legendText(labelProps), this.getHintText()), this.getErrorContent()), this.slotWrapper()));
    this.renderSingleField = (labelProps) => {
      const Label = `iress-label${this.suffix}`;
      return (h("div", { class: FieldCssClass.Wrapper }, h(Label, Object.assign({}, labelProps), this.getHintText(), this.getErrorContent()), this.slotWrapper()));
    };
  }
  handleErrorChange() {
    this.fieldElements.forEach((item) => {
      const component = item.closest(`.${GlobalCssClass.FormElement}`);
      component === null || component === void 0 ? void 0 : component.validate();
    });
  }
  // eslint-disable-next-line
  blurHandler() {
    if (this.validate) {
      // Using setTimeout as focus is momentarily shifted to body before moving on
      setTimeout(() => {
        this.validateFieldElements();
      }, 10);
    }
  }
  errorChangeHandler() {
    if (this.validate && !hasFocus(this.el)) {
      for (const el of this.fieldElements) {
        this.updateErrors(el);
      }
    }
  }
  /**
   * Resets field to initial state
   */
  async resetField() {
    setTimeout(() => {
      this.errors = [];
    }, 15);
  }
  /**
   * Validates the form elements
   */
  async validateField() {
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    this.fieldElements.forEach(async (ele) => {
      if (ele) {
        if (isCustomFormElement(ele)) {
          await ele.validate();
        }
        else {
          const component = ele.closest(`.${ComboboxCssClass.Base}`) ||
            ele.closest(`.${GlobalCssClass.FormElement}`);
          if (component)
            component.validate();
        }
      }
    });
  }
  /**
   * Registers input elements within field
   */
  async registerInputElement(fieldData) {
    var _a;
    const inputIsRegistered = this.fieldElements.findIndex((ele) => ele.name === fieldData.name) >
      -1;
    if (inputIsRegistered) {
      // The input is already registered so the only thing it can update is the required state
      if (fieldData.required !== this.required)
        this.required = fieldData.required;
    }
    else {
      // Register the new input as a child of this instance
      const combobox = (_a = fieldData.element) === null || _a === void 0 ? void 0 : _a.closest(`.${ComboboxCssClass.Base}`);
      const insideCombobox = combobox !== null;
      if (this.error !== '') {
        const selector = insideCombobox === true
          ? `.${ComboboxCssClass.Base}`
          : `.${GlobalCssClass.FormElement}`;
        fieldData.element
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          .closest(selector)
          .validate();
      }
      this.fieldElements.push(fieldData.element);
      this.required = fieldData.required;
      this.setForInput();
    }
  }
  /**
   * Unregisters input elements within field
   */
  async unregisterInputElement(fieldData) {
    const fieldIndex = this.fieldElements.findIndex((ele) => ele.name === fieldData.name);
    if (fieldIndex >= 0) {
      this.fieldElements.splice(fieldIndex, 1);
      const errorIndex = this.errors.findIndex((error) => error.targetId === fieldData.name);
      this.required =
        this.fieldElements.filter((ele) => ele.required === true)
          .length > 0;
      this.setForInput();
      if (errorIndex >= 0) {
        this.removeError(errorIndex);
        for (const el of this.fieldElements) {
          this.updateErrors(el);
        }
      }
    }
  }
  componentWillLoad() {
    this.form = this.el.closest('.iress-form');
    this.optional = this.hasOptionalFieldLabels();
    this.validate = !this.hasDisableValidation();
    this.suffix = getSuffix(this.el, 'iress-field');
    this.isInputGroup = this.hasMultipleInputs();
  }
  componentDidLoad() {
    this.iressFieldDidLoad.emit();
  }
  disconnectedCallback() {
    this.iressFieldDidUnload.emit();
  }
  setForInput() {
    if (this.isInputGroup !== true) {
      const firstChild = this.el.querySelector('.iress-slider:first-child input') ||
        this.el.querySelector('.iress-input:first-child input') ||
        this.el.querySelector('.iress-select:first-child select') ||
        this.el.querySelector('.iress-input:first-child textarea');
      const newFor = firstChild !== null ? firstChild.getAttribute('id') : '';
      if (this.forinput === undefined) {
        this.forinput = newFor;
      }
      else {
        const label = this.el.querySelector('label');
        if (label !== null)
          label.setAttribute('for', newFor);
      }
    }
  }
  render() {
    const labelProps = this.getLabelProps();
    return (h(Host, { class: this.getHostCssClassMap() }, this.isInputGroup
      ? this.renderInputGroup(labelProps)
      : this.renderSingleField(labelProps)));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "error": ["handleErrorChange"]
  }; }
};
Field.style = fieldCss;

const inputCss = ".sc-iress-input-h{--iress-font-family:var(--iress-input-font-family, var(--iress-a-form-font-family, var(--iress-g-font-family, inherit)));--iress-font-size:var(--iress-input-font-size, inherit);--iress-font-weight:var(--iress-input-font-weight, var(--iress-g-font-weight, normal));--iress-background-color:var(--iress-input-background-color, var(--iress-a-form-background-color, var(--iress-g-background-color, var(--iress-default-background-color))));--iress-border-width:var(--iress-input-border-width, var(--iress-a-form-border-width, var(--iress-g-border-width, var(--iress-default-border-width))));--iress-addon-border-width:var(\n        --iress-input-addon-border-width,\n        var(--iress-input-border-width, var(--iress-a-form-border-width, var(--iress-g-border-width, var(--iress-default-border-width))))\n    );--iress-border-color:var(--iress-input-border-color, var(--iress-g-form-border-color, var(--iress-default-form-border-color)));--iress-border-radius:var(--iress-input-border-radius, var(--iress-a-form-border-radius, var(--iress-g-border-radius, var(--iress-default-border-radius))));--iress-text-color:var(--iress-input-text-color, var(--iress-g-text-color, inherit));--iress-focus-border-color:var(--iress-input-focus-border-color, var(--iress-focus-color));--iress-focus-box-shadow:0 0 0 var(--iress-g-focus-width, 2px) var(--iress-focus-color);--iress-focus-background-color:var(--iress-input-focus-background-color, var(--iress-background-color));--iress-focus-text-color:var(--iress-input-focus-text-color, var(--iress-text-color));--iress-watermark-text-color:var(--iress-input-watermark-text-color, var(--iress-default-text-color--placeholder));--iress-placeholder-text-color:var(--iress-input-placeholder-text-color, var(--iress-default-text-color--placeholder));--iress-padding-x:var(--iress-input-padding-x, var(--iress-g-spacing-sm));--iress-padding-y:var(--iress-input-padding-y, var(--iress-g-spacing-sm));--iress-transition-hover-duration:var(--iress-input-transition-hover-duration, 0s);--iress-transition-hover-type:var(--iress-input-transition-hover-type, none);--iress-transition-hover:all var(--iress-transition-hover-duration) var(--iress-transition-hover-type);--iress-label-padding-bottom:var(--iress-input-label-padding-bottom, var(--iress-g-spacing-sm));--iress-min-height:var(--iress-input-min-height, var(--iress-default-min-height))}.iress-input.iress-input--width-2.sc-iress-input-h .iress-input__wrapper.sc-iress-input,.iress-input.iress-input--width-4.sc-iress-input-h .iress-input__wrapper.sc-iress-input,.iress-input.iress-input--width-6.sc-iress-input-h .iress-input__wrapper.sc-iress-input,.iress-input.iress-input--width-8.sc-iress-input-h .iress-input__wrapper.sc-iress-input,.iress-input.iress-input--width-10.sc-iress-input-h .iress-input__wrapper.sc-iress-input,.iress-input.iress-input--width-12.sc-iress-input-h .iress-input__wrapper.sc-iress-input,.iress-input.iress-input--width-16.sc-iress-input-h .iress-input__wrapper.sc-iress-input,.iress-input.iress-input--width-25-perc.sc-iress-input-h .iress-input__wrapper.sc-iress-input,.iress-input.iress-input--width-50-perc.sc-iress-input-h .iress-input__wrapper.sc-iress-input,.iress-input.iress-input--width-75-perc.sc-iress-input-h .iress-input__wrapper.sc-iress-input{display:inline-flex;flex-grow:0}.iress-input--width-2.sc-iress-input-h .iress-input__native-input.sc-iress-input{width:calc((2 * var(--iress-padding-x)) + calc(2 * var(--iress-g-spacing-rem)));max-width:100%;flex-grow:0}.iress-input--width-4.sc-iress-input-h .iress-input__native-input.sc-iress-input{width:calc((2 * var(--iress-padding-x)) + calc(4 * var(--iress-g-spacing-rem)));max-width:100%;flex-grow:0}.iress-input--width-6.sc-iress-input-h .iress-input__native-input.sc-iress-input{width:calc((2 * var(--iress-padding-x)) + calc(6 * var(--iress-g-spacing-rem)));max-width:100%;flex-grow:0}.iress-input--width-8.sc-iress-input-h .iress-input__native-input.sc-iress-input{width:calc((2 * var(--iress-padding-x)) + calc(8 * var(--iress-g-spacing-rem)));max-width:100%;flex-grow:0}.iress-input--width-10.sc-iress-input-h .iress-input__native-input.sc-iress-input{width:calc((2 * var(--iress-padding-x)) + calc(10 * var(--iress-g-spacing-rem)));max-width:100%;flex-grow:0}.iress-input--width-12.sc-iress-input-h .iress-input__native-input.sc-iress-input{width:calc((2 * var(--iress-padding-x)) + calc(12 * var(--iress-g-spacing-rem)));max-width:100%;flex-grow:0}.iress-input--width-16.sc-iress-input-h .iress-input__native-input.sc-iress-input{width:calc((2 * var(--iress-padding-x)) + calc(16 * var(--iress-g-spacing-rem)));max-width:100%;flex-grow:0}.iress-input--width-25-perc.sc-iress-input-h .iress-input__wrapper.sc-iress-input{width:25%;flex-grow:0}.iress-input--width-50-perc.sc-iress-input-h .iress-input__wrapper.sc-iress-input{width:50%;flex-grow:0}.iress-input--width-75-perc.sc-iress-input-h .iress-input__wrapper.sc-iress-input{width:75%;flex-grow:0}.iress-field--inline.sc-iress-input-h .iress-input__wrapper.sc-iress-input,.iress-field--inline .sc-iress-input-h .iress-input__wrapper.sc-iress-input{width:100%}.iress-field--inline.iress-input--width-25-perc.sc-iress-input-h,.iress-field--inline .iress-input--width-25-perc.sc-iress-input-h{width:25%}.iress-field--inline.iress-input--width-50-perc.sc-iress-input-h,.iress-field--inline .iress-input--width-50-perc.sc-iress-input-h{width:50%}.iress-field--inline.iress-input--width-75-perc.sc-iress-input-h,.iress-field--inline .iress-input--width-75-perc.sc-iress-input-h{width:75%}.iress-field--inline.iress-input--width-16.sc-iress-input-h,.iress-field--inline .iress-input--width-16.sc-iress-input-h{width:75%}.iress-input.sc-iress-input-h{display:block;line-height:1;position:relative}.iress-input.sc-iress-input-h *.sc-iress-input,.iress-input.sc-iress-input-h *.sc-iress-input::before,.iress-input.sc-iress-input-h *.sc-iress-input::after{box-sizing:border-box}.iress-input.sc-iress-input-h .iress-input__wrapper.sc-iress-input{border-radius:var(--iress-border-radius);display:flex;align-items:stretch;min-height:var(--iress-min-height);margin:0;flex-grow:1;border-width:var(--iress-border-width);border-style:solid;border-color:var(--iress-border-color);background-color:var(--iress-background-color)}.iress-input--focus.sc-iress-input-h .iress-input__wrapper.sc-iress-input{border-color:var(--iress-focus-border-color);box-shadow:var(--iress-focus-box-shadow)}.iress-input__native-input.sc-iress-input{border-width:0;border-radius:var(--iress-border-radius);padding-inline-start:var(--iress-padding-x);padding-inline-end:var(--iress-padding-x);padding-block-start:var(--iress-padding-y);padding-block-end:var(--iress-padding-y);background-color:var(--iress-background-color);font-size:var(--iress-font-size);font-family:var(--iress-font-family);font-weight:var(--iress-font-weight);color:var(--iress-text-color);transition:var(--iress-transition-hover);height:calc(var(--iress-min-height) - (2 * var(--iress-border-width)));flex:1 1 auto;max-width:100%;min-width:var(--iress-g-font-size-rem);width:100%}textarea.iress-input__native-input.sc-iress-input{line-height:1.5;height:auto;min-height:calc(var(--iress-min-height) - (2 * var(--iress-border-width)))}.iress-input__native-input.sc-iress-input::placeholder{color:var(--iress-placeholder-text-color)}.sc-iress-input-h .iress-input__label.sc-iress-input{padding-block-end:var(--iress-label-padding-bottom)}.iress-input--hiddenlabel.sc-iress-input-h .iress-input__label.sc-iress-input{border:0;clip:rect(0, 0, 0, 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.sc-iress-input-h .iress-input__addon.sc-iress-input{border-radius:var(--iress-border-radius);background-color:var(--iress-background-color);color:var(--iress-text-color);min-height:calc(var(--iress-min-height) - (2 * var(--iress-border-width)));line-height:1;display:inline-flex;align-items:center;font-weight:300}.sc-iress-input-h .iress-input__internal.sc-iress-input{font-weight:300}.sc-iress-input-h .iress-input__addon.sc-iress-input:empty,.sc-iress-input-h .iress-input__internal.sc-iress-input:empty{display:none}.iress-input.sc-iress-input-h .iress-input__addon.sc-iress-input~.iress-input__native-input.sc-iress-input{border-inline-start:none}.sc-iress-input-h.iress-input .sc-iress-input-s>*{padding-block-start:0;padding-block-end:0;padding-inline-start:calc(0.75 * var(--iress-g-font-size-rem));padding-inline-end:calc(0.75 * var(--iress-g-font-size-rem))}.iress-input--textarea.sc-iress-input-h .iress-input__addon.sc-iress-input{align-items:flex-start}.sc-iress-input-h.iress-input--textarea .sc-iress-input-s>*{padding-block-start:calc(0.75 * var(--iress-g-font-size-rem))}.iress-input__native-input.sc-iress-input:focus{color:var(--iress-focus-text-color);outline:none}.sc-iress-input-h .iress-input__addon--prepend.sc-iress-input{border-start-end-radius:0;border-end-end-radius:0;border-inline-end:var(--iress-addon-border-width) solid var(--iress-border-color)}.iress-input--addon-prepend.sc-iress-input-h .iress-input__native-input.sc-iress-input{border-start-start-radius:0;border-end-start-radius:0}.sc-iress-input-h .iress-input__addon--append.sc-iress-input{border-start-start-radius:0;border-end-start-radius:0;border-inline-start:var(--iress-addon-border-width) solid var(--iress-border-color)}.iress-input--addon-append.sc-iress-input-h .iress-input__native-input.sc-iress-input{border-start-end-radius:0;border-end-end-radius:0;border-inline-end:none}.iress-input--clearable.sc-iress-input-h .iress-input__clear.sc-iress-input{height:100%;line-height:1.5;border:none;background-color:transparent;font-family:inherit;font-weight:inherit;font-size:calc(1.5 * var(--iress-g-font-size-rem));color:inherit;display:inline-flex}.iress-view-mode-compact.sc-iress-input-h .iress-input__clear.sc-iress-input,.iress-view-mode-compact .sc-iress-input-h .iress-input__clear.sc-iress-input{line-height:1.2}.iress-combobox__tag-list-input.sc-iress-input-h .iress-input__clear.sc-iress-input,.iress-combobox__tag-list-input .sc-iress-input-h .iress-input__clear.sc-iress-input{line-height:1}.iress-input--clearable.sc-iress-input-h .iress-input__clear.sc-iress-input:focus{outline:none;box-shadow:var(--iress-focus-box-shadow);position:relative}.iress-input--loading.sc-iress-input-h .iress-input__clear.sc-iress-input{display:none}.sc-iress-input-h.iress-input--loading .sc-iress-input-s>.iress-spinner{display:flex;align-items:center;height:100%;border-inline-end:var(--iress-border-width) solid var(--iress-border-color)}.iress-input--watermark.sc-iress-input-h .iress-input__addon.sc-iress-input{color:var(--iress-watermark-text-color)}.iress-input--watermark.sc-iress-input-h .iress-input__addon.sc-iress-input+.iress-input__native-input.sc-iress-input{padding-inline-start:0}.iress-input--watermark.sc-iress-input-h .iress-input__addon.sc-iress-input:not(:first-child){border-inline-start:none}.iress-input--watermark.sc-iress-input-h .iress-input__addon.sc-iress-input:not(:last-child),.iress-input--watermark.sc-iress-input-h .iress-input__native-input.sc-iress-input:not(:last-child),.sc-iress-input-h.iress-input--loading .sc-iress-input-s>.iress-spinner{border-inline-end:none}.iress-input--watermark.iress-input--clear-shown.sc-iress-input-h .iress-input__clear.sc-iress-input:not(:only-child){border-inline-end:none}.iress-input--watermark.iress-input--addon-append.sc-iress-input-h .iress-input__clear.sc-iress-input,.sc-iress-input-h.iress-input--watermark.iress-input--addon-append .sc-iress-input-s>.iress-spinner{padding-inline-end:0}.iress-input--watermark.sc-iress-input-h .iress-input__native-input.sc-iress-input+.iress-input__addon.sc-iress-input{border-inline-start:none}.iress-input.sc-iress-input-h input[type=\"search\"].sc-iress-input::-webkit-search-decoration,.iress-input.sc-iress-input-h input[type=\"search\"].sc-iress-input::-webkit-search-cancel-button,.iress-input.sc-iress-input-h input[type=\"search\"].sc-iress-input::-webkit-search-results-button,.iress-input.sc-iress-input-h input[type=\"search\"].sc-iress-input::-webkit-search-results-decoration{-webkit-appearance:none}.sc-iress-input:not(output):-moz-ui-invalid{box-shadow:none}.iress-theme-dark.sc-iress-input-h .sc-iress-input::-webkit-calendar-picker-indicator,.iress-theme-dark .sc-iress-input-h .sc-iress-input::-webkit-calendar-picker-indicator{filter:invert(1)}.iress-table.sc-iress-input-h .iress-table__cell--right.sc-iress-input .iress-input__native-input.sc-iress-input,.iress-table .iress-table__cell--right .sc-iress-input-h .iress-input__native-input.sc-iress-input{text-align:end}.iress-view-mode-compact.sc-iress-input-h .iress-table.sc-iress-input,.iress-view-mode-compact .iress-table .sc-iress-input-h{--iress-padding-y:0.75px}.iress-view-mode-compact.sc-iress-input-h .iress-table.sc-iress-input .iress-input__addon.sc-iress-input,.iress-view-mode-compact .iress-table .sc-iress-input-h .iress-input__addon.sc-iress-input{height:var(--iress-input-min-height, auto)}";

let inputIds = 0;
const Input = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.iressInputDidLoad = createEvent(this, "iressInputDidLoad", 7);
    this.iressInputDidUnload = createEvent(this, "iressInputDidUnload", 7);
    this.iressInput = createEvent(this, "iressInput", 7);
    this.iressChange = createEvent(this, "iressChange", 7);
    this.iressBlur = createEvent(this, "iressBlur", 7);
    this.iressFocus = createEvent(this, "iressFocus", 7);
    this.iressClear = createEvent(this, "iressClear", 7);
    this.iressKeyDown = createEvent(this, "iressKeyDown", 7);
    this.iressKeyUp = createEvent(this, "iressKeyUp", 7);
    this.iressErrorChange = createEvent(this, "iressErrorChange", 7);
    this.hasFocus = false;
    this.error = '';
    /**
     * Indicates whether the value of the control can be automatically completed by the browser.
     */
    this.autocomplete = 'off';
    /**
     * Whether auto correction should be enabled when the user is entering/editing the text value.
     */
    this.autocorrect = 'off';
    /**
     * If `true`, then user can clear the value of the input. Will be ignored if `rows` prop is in use.
     */
    this.clearable = false;
    /**
     * The Boolean multiple prop, if set, means the form control accepts one or more values. Valid for the `email` and `file` input types
     */
    this.multiple = false;
    /**
     * If `true`, the (optional) text is shown in the label.
     * Will be ignored if `required` is set to `true`
     */
    this.optional = false;
    /**
     * If `true`, the user cannot modify the value.
     */
    this.readonly = false;
    /**
     * If `true`, the user must fill in a value before submitting a form.
     */
    this.required = false;
    /**
     * Number of rows in the textarea (when set the component renders a textarea element)
     */
    this.rows = 0;
    /**
     * The type of control to display. The default type is text.
     */
    this.type = TextFieldType.Text;
    /**
     * The value of the input.
     */
    this.value = '';
    /**
     * When set to `true` add ons will render with a different style. Will be ignored if `prepend` or `append` slots are not being used.
     */
    this.watermark = false;
    /**
     * Sets the aria-expanded attribute on the HTML input. Only needed for autocomplete controls, and should be dynamically set to true when search results are shown
     */
    this.isExpanded = false;
    this.getStatus = () => ({
      value: this.value,
      element: this.nativeInput,
      name: this.name,
      type: this.type,
      required: this.required,
      error: this.error,
      label: this.multiInputLabel,
    });
    this.onChange = () => {
      this.updateErrors(this.nativeInput.validationMessage || '');
      this.iressChange.emit(this.getStatus());
    };
    this.onInput = (evt) => {
      const input = evt.target;
      if (input !== null) {
        this.value = input.value || '';
      }
      this.iressInput.emit(evt);
    };
    this.onBlur = () => {
      this.hasFocus = false;
      this.iressBlur.emit(this.getStatus());
    };
    this.onFocus = () => {
      this.hasFocus = true;
      this.iressFocus.emit(this.getStatus());
    };
    this.handleClear = () => {
      this.nativeInput.focus();
      this.value = '';
      this.iressClear.emit(this.getStatus());
    };
    this.getInputMode = () => {
      if (this.inputmode !== undefined)
        return this.inputmode;
      if (this.rows > 1)
        return InputMode.Text;
      switch (this.type) {
        case TextFieldType.Number:
          return InputMode.Decimal;
        case TextFieldType.Email:
          return InputMode.Email;
        case TextFieldType.Tel:
          return InputMode.Tel;
        case TextFieldType.Url:
          return InputMode.Url;
        case TextFieldType.Search:
          return InputMode.Search;
        case TextFieldType.Text:
          return InputMode.Text;
        default:
          return null;
      }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.getCommonProps = () => ({
      class: {
        [InputCssClass.NativeInput]: true,
      },
      inputMode: this.getInputMode(),
      minLength: this.minlength,
      maxLength: this.maxlength,
      name: this.name,
      pattern: this.pattern,
      placeholder: this.placeholder || '',
      readOnly: this.readonly,
      required: this.required,
      onInput: this.readonly === true ? null : this.onInput,
      onBlur: this.onBlur,
      onFocus: this.onFocus,
      onChange: this.onChange,
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.getInputProps = () => ({
      autocomplete: this.autocomplete,
      autocorrect: this.autocorrect,
      min: this.min,
      max: this.max,
      step: this.step === undefined && this.type === TextFieldType.Number
        ? 'any'
        : this.step,
      type: this.type,
      accept: this.accept,
      multiple: this.multiple,
      capture: this.capture,
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.getAutocompleteAttributes = () => {
      if (this.isAutocomplete && this.type === TextFieldType.Text) {
        return {
          role: 'combobox',
          'aria-autocomplete': 'list',
          'aria-expanded': this.isExpanded ? 'true' : 'false',
          'aria-owns': `${this.name}__list`,
        };
      }
      return {};
    };
    this.getHostCssClassMap = (clear) => {
      const widthClass = this.width &&
        `${InputCssClass[`Width${this.width}`]} ${GlobalCssClass.IgnoreStack}`;
      return {
        [InputCssClass.Base]: true,
        [GlobalCssClass.FormElement]: true,
        [GlobalCssClass.FormElementInvalid]: this.error !== '',
        [InputCssClass.TextArea]: this.rows > 1,
        [InputCssClass.Focus]: this.hasFocus || this.isExpanded,
        [InputCssClass.HiddenLabel]: this.hiddenLabel,
        [widthClass]: this.width !== undefined,
        [InputCssClass.Prepend]: this.hasPrependSlot,
        [InputCssClass.Append]: this.hasAppendSlot === true,
        [InputCssClass.Watermark]: this.watermark === true,
        [InputCssClass.Clearable]: this.clearable === true && this.rows < 2,
        [InputCssClass.ClearShown]: clear,
      };
    };
    this.renderNativeElement = (nativeEleId) => {
      const value = this.getValue();
      if (this.rows > 1) {
        return (h("textarea", Object.assign({}, this.getCommonProps(), { rows: this.rows, "data-testid": nativeTestid(this.el, 'textarea'), id: nativeEleId,
          // using the value property so that it works in React as well as other environments
          ref: (el) => (el.value = value) })));
      }
      return (h("input", Object.assign({}, this.getCommonProps(), this.getInputProps(), this.getAutocompleteAttributes(), { value: value, "data-testid": nativeTestid(this.el, 'input'), id: nativeEleId })));
    };
    this.renderClearBtn = () => (h("button", { class: InputCssClass.Clear, onClick: this.handleClear, type: "button" }, h("span", { "aria-hidden": "true" }, "\u00D7"), h("span", { class: GlobalCssClass.SROnly }, "Clear")));
    this.getNativeElementId = () => {
      return this.isAutocomplete === true && this.type === TextFieldType.Text
        ? nativeId(this.el, 'input') || this.name
        : this.name;
    };
    this.isClearable = () => this.clearable === true && this.value !== '' && this.rows < 2;
  }
  updateFieldRequiredState(prev, current) {
    if (prev !== current && this.willRegister)
      this.registerInput();
  }
  // eslint-disable-next-line
  handleKeyDown(evt) {
    this.iressKeyDown.emit(evt);
  }
  // eslint-disable-next-line
  handleKeyUp(evt) {
    this.iressKeyUp.emit(evt);
  }
  // eslint-disable-next-line
  focusHandler() {
    this.nativeInput.focus();
  }
  /**
   * Validates the input.
   */
  async validate() {
    var _a;
    const fieldError = ((_a = this.fieldEl) === null || _a === void 0 ? void 0 : _a.error) || '';
    this.updateErrors(this.nativeInput.validationMessage || fieldError);
  }
  /**
   * Resets the input to its original state.
   */
  async reset() {
    this.error = '';
    this.value = '';
    if (this.rows > 1)
      this.el.querySelector('textarea').value = '';
  }
  /**
   * Gets the input HTML element.
   */
  getNativeElement() {
    return Promise.resolve(this.nativeInput);
  }
  componentWillLoad() {
    var _a;
    this.suffix = getSuffix(this.el, 'iress-input');
    this.inputId = `iress-input${this.suffix}-${inputIds++}`;
    this.name = (_a = this.name) !== null && _a !== void 0 ? _a : this.inputId;
    this.hasPrependSlot =
      this.el.querySelector('[slot="prepend"]') !== null;
    this.hasAppendSlot = this.el.querySelector('[slot="append"]') !== null;
    this.fieldEl = this.el.closest(`.${FieldCssClass.Base}`);
    this.hasField = this.fieldEl !== null && this.fieldEl !== undefined;
    this.comboboxMultiEl = this.el.closest(`.${ComboboxCssClass.Multiple}`);
    this.hasComboboxMulti =
      this.comboboxMultiEl !== null && this.comboboxMultiEl !== undefined;
    this.willRegister =
      this.hasField === true && this.hasComboboxMulti === false;
  }
  componentDidLoad() {
    const ele = this.rows > 1 ? 'textarea' : 'input';
    this.nativeInput = this.el.querySelector(ele);
    this.iressInputDidLoad.emit(this.nativeInput);
    if (this.willRegister)
      this.registerInput();
  }
  disconnectedCallback() {
    if (this.willRegister)
      this.unregisterInput();
    this.iressInputDidUnload.emit(this.nativeInput);
  }
  async registerInput() {
    if ((await typeof this.fieldEl.registerInputElement) === 'function')
      await this.fieldEl.registerInputElement(this.getStatus());
  }
  async unregisterInput() {
    if ((await typeof this.fieldEl.unregisterInputElement) === 'function')
      await this.fieldEl.unregisterInputElement(this.getStatus());
  }
  getValue() {
    return this.value || '';
  }
  updateErrors(valMsg) {
    if ((this.error !== '' && valMsg === '') ||
      (this.error === '' && valMsg !== '')) {
      this.iressErrorChange.emit(this.getStatus());
    }
    this.error = valMsg;
  }
  render() {
    const clear = this.isClearable();
    const nativeEleId = this.getNativeElementId();
    const Label = `iress-label${this.suffix}`;
    return (h(Host, { class: this.getHostCssClassMap(clear) }, this.multiInputLabel && (h(Label, { class: InputCssClass.Label, for: nativeEleId, labelText: this.multiInputLabel, required: this.required, optional: this.optional })), h("div", { class: InputCssClass.InputWrapper }, this.hasPrependSlot === true && (h("div", { class: `${InputCssClass.AddOn} ${InputCssClass.PrependAddon}` }, h("slot", { name: InputSlot.Prepend }))), this.renderNativeElement(nativeEleId), h("div", { class: InputCssClass.Internal }, clear === true && this.renderClearBtn(), h("slot", { name: InputSlot.Internal })), this.hasAppendSlot === true && (h("div", { class: `${InputCssClass.AddOn} ${InputCssClass.AppendAddon}` }, h("slot", { name: InputSlot.Append }))))));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "required": ["updateFieldRequiredState"]
  }; }
};
Input.style = inputCss;

var InlineCssClass;
(function (InlineCssClass) {
  InlineCssClass["Base"] = "iress-inline";
  InlineCssClass["Inner"] = "iress-inline__inner";
  InlineCssClass["NoWrap"] = "iress-inline--no-wrap";
  InlineCssClass["HorizontalAlign"] = "iress-inline__h-align";
  InlineCssClass["VerticalAlign"] = "iress-inline__v-align";
  InlineCssClass["Gutter"] = "iress-inline__gutter";
})(InlineCssClass || (InlineCssClass = {}));
var InlineHorizontalAlign;
(function (InlineHorizontalAlign) {
  InlineHorizontalAlign["Around"] = "around";
  InlineHorizontalAlign["Between"] = "between";
  InlineHorizontalAlign["Center"] = "center";
  InlineHorizontalAlign["Evenly"] = "evenly";
  InlineHorizontalAlign["Left"] = "left";
  InlineHorizontalAlign["Right"] = "right";
})(InlineHorizontalAlign || (InlineHorizontalAlign = {}));
var InlineVerticalAlign;
(function (InlineVerticalAlign) {
  InlineVerticalAlign["Bottom"] = "bottom";
  InlineVerticalAlign["Middle"] = "middle";
  InlineVerticalAlign["Stretch"] = "stretch";
  InlineVerticalAlign["Top"] = "top";
})(InlineVerticalAlign || (InlineVerticalAlign = {}));
var InlineGutter;
(function (InlineGutter) {
  InlineGutter["None"] = "none";
  InlineGutter["Xs"] = "xs";
  InlineGutter["Sm"] = "sm";
  InlineGutter["Md"] = "md";
  InlineGutter["Lg"] = "lg";
  InlineGutter["Xl"] = "xl";
})(InlineGutter || (InlineGutter = {}));

const inlineCss = ".sc-iress-inline-h{--gutter-xs:var(--iress-inline-xs-gutter,\n      var(--iress-a-horizontal-spacing-xs,\n          var(--iress-g-spacing-xs)));--gutter-sm:var(--iress-inline-sm-gutter,\n      var(--iress-a-horizontal-spacing-sm,\n          var(--iress-g-spacing-sm)));--gutter-md:var(--iress-inline-md-gutter,\n      var(--iress-a-horizontal-spacing-md,\n          var(--iress-g-spacing-md)));--gutter-lg:var(--iress-inline-lg-gutter,\n      var(--iress-a-horizontal-spacing-lg,\n          var(--iress-g-spacing-lg)));--gutter-xl:var(--iress-inline-xl-gutter,\n      var(--iress-a-horizontal-spacing-xl,\n          var(--iress-g-spacing-xl)));--child-display:var(--iress-inline-child-display, inline-block);display:block}.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{display:flex;flex-wrap:wrap;height:100%}.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{flex-basis:100%}.sc-iress-inline-h>.iress-inline__inner.iress-inline--no-wrap.sc-iress-inline,.sc-iress-inline-h>.iress-inline__inner.iress-inline--no-wrap.sc-iress-inline-s>[data-wrapper-children]{flex-wrap:nowrap}.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline-s>.iress-button,.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-button{--iress-margin-right:0}.iress-inline__h-align--around.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__h-align--around>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{justify-content:space-around}.iress-inline__h-align--between.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__h-align--between>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{justify-content:space-between}.iress-inline__h-align--center.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__h-align--center>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{justify-content:center}.iress-inline__h-align--evenly.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__h-align--evenly>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{justify-content:space-evenly}.iress-inline__h-align--left.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__h-align--left>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{justify-content:flex-start}.iress-inline__h-align--right.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__h-align--right>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{justify-content:flex-end}.iress-inline__v-align--middle.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__v-align--middle>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{align-items:center}.iress-inline__v-align--bottom.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__v-align--bottom>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{align-items:flex-end}.iress-inline__v-align--stretch.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__v-align--stretch>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{align-items:stretch}.iress-inline__v-align--top.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__v-align--top>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{align-items:flex-start}.iress-inline__gutter--xs.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter--xs>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-xs);row-gap:var(--gutter-xs)}.sc-iress-inline-h.iress-inline__gutter--xs>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter--xs>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter--xs>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter--sm.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter--sm>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-sm);row-gap:var(--gutter-sm)}.sc-iress-inline-h.iress-inline__gutter--sm>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter--sm>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter--sm>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter--md.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter--md>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-md);row-gap:var(--gutter-md)}.sc-iress-inline-h.iress-inline__gutter--md>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter--md>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter--md>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter--lg.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter--lg>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-lg);row-gap:var(--gutter-lg)}.sc-iress-inline-h.iress-inline__gutter--lg>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter--lg>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter--lg>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter--xl.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter--xl>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-xl);row-gap:var(--gutter-xl)}.sc-iress-inline-h.iress-inline__gutter--xl>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter--xl>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter--xl>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-xs--none.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-xs--none>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{row-gap:0;column-gap:0}.sc-iress-inline-h.iress-inline__gutter-xs--none>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-xs--none>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-xs--none>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-xs--xs.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-xs--xs>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-xs);row-gap:var(--gutter-xs)}.sc-iress-inline-h.iress-inline__gutter-xs--xs>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-xs--xs>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-xs--xs>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-xs--sm.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-xs--sm>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-sm);row-gap:var(--gutter-sm)}.sc-iress-inline-h.iress-inline__gutter-xs--sm>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-xs--sm>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-xs--sm>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-xs--md.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-xs--md>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-md);row-gap:var(--gutter-md)}.sc-iress-inline-h.iress-inline__gutter-xs--md>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-xs--md>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-xs--md>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-xs--lg.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-xs--lg>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-lg);row-gap:var(--gutter-lg)}.sc-iress-inline-h.iress-inline__gutter-xs--lg>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-xs--lg>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-xs--lg>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-xs--xl.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-xs--xl>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-xl);row-gap:var(--gutter-xl)}.sc-iress-inline-h.iress-inline__gutter-xs--xl>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-xs--xl>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-xs--xl>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}@media only screen and (min-width: 576px){.iress-inline__gutter-sm--none.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-sm--none>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{row-gap:0;column-gap:0}.sc-iress-inline-h.iress-inline__gutter-sm--none>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-sm--none>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-sm--none>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-sm--xs.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-sm--xs>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-xs);row-gap:var(--gutter-xs)}.sc-iress-inline-h.iress-inline__gutter-sm--xs>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-sm--xs>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-sm--xs>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-sm--sm.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-sm--sm>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-sm);row-gap:var(--gutter-sm)}.sc-iress-inline-h.iress-inline__gutter-sm--sm>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-sm--sm>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-sm--sm>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-sm--md.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-sm--md>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-md);row-gap:var(--gutter-md)}.sc-iress-inline-h.iress-inline__gutter-sm--md>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-sm--md>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-sm--md>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-sm--lg.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-sm--lg>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-lg);row-gap:var(--gutter-lg)}.sc-iress-inline-h.iress-inline__gutter-sm--lg>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-sm--lg>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-sm--lg>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-sm--xl.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-sm--xl>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-xl);row-gap:var(--gutter-xl)}.sc-iress-inline-h.iress-inline__gutter-sm--xl>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-sm--xl>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-sm--xl>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}}@media only screen and (min-width: 768px){.iress-inline__gutter-md--none.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-md--none>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{row-gap:0;column-gap:0}.sc-iress-inline-h.iress-inline__gutter-md--none>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-md--none>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-md--none>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-md--xs.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-md--xs>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-xs);row-gap:var(--gutter-xs)}.sc-iress-inline-h.iress-inline__gutter-md--xs>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-md--xs>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-md--xs>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-md--sm.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-md--sm>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-sm);row-gap:var(--gutter-sm)}.sc-iress-inline-h.iress-inline__gutter-md--sm>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-md--sm>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-md--sm>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-md--md.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-md--md>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-md);row-gap:var(--gutter-md)}.sc-iress-inline-h.iress-inline__gutter-md--md>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-md--md>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-md--md>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-md--lg.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-md--lg>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-lg);row-gap:var(--gutter-lg)}.sc-iress-inline-h.iress-inline__gutter-md--lg>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-md--lg>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-md--lg>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-md--xl.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-md--xl>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-xl);row-gap:var(--gutter-xl)}.sc-iress-inline-h.iress-inline__gutter-md--xl>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-md--xl>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-md--xl>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}}@media only screen and (min-width: 1024px){.iress-inline__gutter-lg--none.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-lg--none>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{row-gap:0;column-gap:0}.sc-iress-inline-h.iress-inline__gutter-lg--none>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-lg--none>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-lg--none>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-lg--xs.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-lg--xs>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-xs);row-gap:var(--gutter-xs)}.sc-iress-inline-h.iress-inline__gutter-lg--xs>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-lg--xs>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-lg--xs>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-lg--sm.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-lg--sm>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-sm);row-gap:var(--gutter-sm)}.sc-iress-inline-h.iress-inline__gutter-lg--sm>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-lg--sm>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-lg--sm>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-lg--md.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-lg--md>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-md);row-gap:var(--gutter-md)}.sc-iress-inline-h.iress-inline__gutter-lg--md>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-lg--md>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-lg--md>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-lg--lg.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-lg--lg>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-lg);row-gap:var(--gutter-lg)}.sc-iress-inline-h.iress-inline__gutter-lg--lg>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-lg--lg>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-lg--lg>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-lg--xl.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-lg--xl>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-xl);row-gap:var(--gutter-xl)}.sc-iress-inline-h.iress-inline__gutter-lg--xl>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-lg--xl>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-lg--xl>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}}@media only screen and (min-width: 1200px){.iress-inline__gutter-xl--none.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-xl--none>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{row-gap:0;column-gap:0}.sc-iress-inline-h.iress-inline__gutter-xl--none>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-xl--none>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-xl--none>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-xl--xs.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-xl--xs>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-xs);row-gap:var(--gutter-xs)}.sc-iress-inline-h.iress-inline__gutter-xl--xs>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-xl--xs>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-xl--xs>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-xl--sm.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-xl--sm>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-sm);row-gap:var(--gutter-sm)}.sc-iress-inline-h.iress-inline__gutter-xl--sm>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-xl--sm>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-xl--sm>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-xl--md.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-xl--md>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-md);row-gap:var(--gutter-md)}.sc-iress-inline-h.iress-inline__gutter-xl--md>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-xl--md>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-xl--md>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-xl--lg.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-xl--lg>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-lg);row-gap:var(--gutter-lg)}.sc-iress-inline-h.iress-inline__gutter-xl--lg>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-xl--lg>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-xl--lg>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}.iress-inline__gutter-xl--xl.sc-iress-inline-h>.iress-inline__inner.sc-iress-inline,.sc-iress-inline-h.iress-inline__gutter-xl--xl>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]{column-gap:var(--gutter-xl);row-gap:var(--gutter-xl)}.sc-iress-inline-h.iress-inline__gutter-xl--xl>.iress-inline__inner.sc-iress-inline-s>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-xl--xl>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>*,.sc-iress-inline-h.iress-inline__gutter-xl--xl>.iress-inline__inner.sc-iress-inline-s>[data-wrapper-children]>.iress-hide>[data-wrapper-children]>*{display:var(--child-display)}}";

const Inline = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    /**
     * Sets the horizontal alignment of the inline content
     */
    this.horizontalAlign = InlineHorizontalAlign.Left;
    /**
     * Sets the vertical alignment of the inline content
     */
    this.verticalAlign = InlineVerticalAlign.Top;
    /**
     * Sets the gutter size of the Inline
     */
    this.gutter = InlineGutter.None;
    /**
     * Wraps content when stretches beyond container
     */
    this.noWrap = false;
  }
  render() {
    const gutterValues = getResponsiveValuesFromProp(this.gutter);
    const gutterClasses = getResponsiveLayoutClasses(gutterValues, InlineCssClass, 'Gutter');
    return (h(Host, { class: Object.assign({ [InlineCssClass.Base]: true, [`${InlineCssClass.VerticalAlign}--${this.verticalAlign}`]: true, [`${InlineCssClass.HorizontalAlign}--${this.horizontalAlign}`]: true }, gutterClasses) }, h("div", { class: {
        [InlineCssClass.Inner]: true,
        [InlineCssClass.NoWrap]: this.noWrap,
      } }, h("slot", null))));
  }
};
Inline.style = inlineCss;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


const applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function getBoundingClientRect(element, includeScale) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  var rect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (isHTMLElement(element) && includeScale) {
    var offsetHeight = element.offsetHeight;
    var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
    // Fallback to 1 in case both values are `0`

    if (offsetWidth > 0) {
      scaleX = round(rect.width) / offsetWidth || 1;
    }

    if (offsetHeight > 0) {
      scaleY = round(rect.height) / offsetHeight || 1;
    }
  }

  return {
    width: rect.width / scaleX,
    height: rect.height / scaleY,
    top: rect.top / scaleY,
    right: rect.right / scaleX,
    bottom: rect.bottom / scaleY,
    left: rect.left / scaleX,
    x: rect.left / scaleX,
    y: rect.top / scaleY
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
  var isIE = navigator.userAgent.indexOf('Trident') !== -1;

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


const arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


const computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


const eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
  // can be obscured underneath it.
  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
  // if it isn't open, so if this isn't available, the popper will be detected
  // to overflow the bottom of the screen too early.

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
    // errors due to floating point numbers, so we need to check precision.
    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
    // Feature detection fails in mobile emulation mode in Chrome.
    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
    // 0.001
    // Fallback here: "Not Safari" userAgent

    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


const flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


const hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


const offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


const popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


const preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

var PopoverCssClass;
(function (PopoverCssClass) {
  PopoverCssClass["Base"] = "iress-popover";
  PopoverCssClass["InputActivator"] = "iress-popover--input";
  PopoverCssClass["Active"] = "iress-popover--active";
  PopoverCssClass["Content"] = "iress-popover__content";
  PopoverCssClass["Activator"] = "iress-popover__activator";
  PopoverCssClass["Inline"] = "iress-popover--inline";
})(PopoverCssClass || (PopoverCssClass = {}));
var PopoverType;
(function (PopoverType) {
  PopoverType["Menu"] = "menu";
  PopoverType["Listbox"] = "listbox";
  PopoverType["Tree"] = "tree";
  PopoverType["Grid"] = "grid";
  PopoverType["Dialog"] = "dialog";
})(PopoverType || (PopoverType = {}));
var PopoverSlot;
(function (PopoverSlot) {
  PopoverSlot["Activator"] = "activator";
})(PopoverSlot || (PopoverSlot = {}));

var MenuCssClass;
(function (MenuCssClass) {
  MenuCssClass["Base"] = "iress-menu";
  MenuCssClass["Fluid"] = "iress-menu--fluid";
  MenuCssClass["Inline"] = "iress-menu--inline";
})(MenuCssClass || (MenuCssClass = {}));
var MenuType;
(function (MenuType) {
  MenuType["Menu"] = "menu";
  MenuType["List"] = "list";
  MenuType["Listbox"] = "listbox";
  MenuType["Nav"] = "nav";
})(MenuType || (MenuType = {}));
var MenuLayout;
(function (MenuLayout) {
  MenuLayout["Stack"] = "stack";
  MenuLayout["Inline"] = "inline";
  MenuLayout["InlineEqualWidth"] = "inline-equal-width";
})(MenuLayout || (MenuLayout = {}));

const elements = [
	{
		tag: "a",
		attributes: {
			disallowed: [
				"aria-pressed"
			],
			specUrl: "https://html.spec.whatwg.org/multipage/text-level-semantics.html#the-a-element"
		}
	},
	{
		tag: "button",
		attributes: {
			disallowed: [
				"download",
				"disabled",
				"href"
			],
			specUrl: "https://html.spec.whatwg.org/multipage/form-elements.html#the-button-element"
		}
	}
];

var ButtonMode;
(function (ButtonMode) {
  ButtonMode["Primary"] = "primary";
  ButtonMode["Secondary"] = "secondary";
  ButtonMode["Tertiary"] = "tertiary";
  ButtonMode["Link"] = "link";
  ButtonMode["Danger"] = "danger";
  ButtonMode["Positive"] = "positive";
  ButtonMode["Negative"] = "negative";
})(ButtonMode || (ButtonMode = {}));
var ButtonType;
(function (ButtonType) {
  ButtonType["Button"] = "button";
  ButtonType["Reset"] = "reset";
  ButtonType["Submit"] = "submit";
})(ButtonType || (ButtonType = {}));
var ButtonSlot;
(function (ButtonSlot) {
  ButtonSlot["IconOnly"] = "icon-only";
  ButtonSlot["Prepend"] = "prepend";
  ButtonSlot["Append"] = "append";
})(ButtonSlot || (ButtonSlot = {}));
var ButtonTagType;
(function (ButtonTagType) {
  ButtonTagType["Button"] = "button";
  ButtonTagType["Link"] = "a";
})(ButtonTagType || (ButtonTagType = {}));
var ButtonCssClass;
(function (ButtonCssClass) {
  ButtonCssClass["Base"] = "iress-button";
  ButtonCssClass["Fluid"] = "iress-button--fluid";
  ButtonCssClass["Button"] = "iress-button__button";
  ButtonCssClass["Inner"] = "iress-button__inner";
  ButtonCssClass["HasCustomRouting"] = "iress-button--custom-route";
  ButtonCssClass["NoWrap"] = "iress-button--no-wrap";
  ButtonCssClass["Checked"] = "iress-button--checked";
})(ButtonCssClass || (ButtonCssClass = {}));

const buttonCss = ".iress-button--primary.sc-iress-button-h{--iress-background-color:var(--iress-button-primary-background-color, var(--iress-g-primary-color, var(--iress-default-primary-color)));--iress-background-image:var(--iress-button-primary-background-image, none);--iress-text-color:var(--iress-button-primary-text-color, var(--iress-g-primary-contrast-color, var(--iress-default-text-color--alt)));--iress-border-color:var(--iress-button-primary-border-color, var(--iress-background-color));--iress-box-shadow-size:var(--iress-button-primary-box-shadow-size, 0 0);--iress-box-shadow-color:var(--iress-button-primary-box-shadow-color, transparent);--iress-box-shadow:var(--iress-box-shadow-size) var(--iress-box-shadow-color);--iress-text-decoration:var(--iress-button-primary-text-decoration, none);--iress-hover-background-color:var(\n        --iress-button-primary-hover-background-color,\n        var(--iress-g-primary-hover-color, var(--iress-g-hover-background-color, var(--iress-default-hover-background-color)))\n    );--iress-hover-background-image:var(--iress-button-primary-hover-background-image, none);--iress-hover-text-color:var(--iress-button-primary-hover-text-color, var(--iress-g-primary-contrast-color, var(--iress-g-hover-text-color, var(--iress-default-text-color--hover))));--iress-hover-border-color:var(--iress-button-primary-hover-border-color, var(--iress-hover-background-color));--iress-hover-box-shadow-size:var(--iress-button-primary-hover-box-shadow-size, 0 0);--iress-hover-box-shadow-color:var(--iress-button-primary-hover-box-shadow-color, transparent);--iress-hover-box-shadow:var(--iress-hover-box-shadow-size) var(--iress-hover-box-shadow-color);--iress-hover-text-decoration:var(--iress-button-primary-hover-text-decoration, none);--iress-active-background-color:var(--iress-button-primary-active-background-color, var(--iress-background-color));--iress-active-background-image:var(--iress-button-primary-active-background-image, linear-gradient(to right, var(--iress-active-background-color), var(--iress-active-background-color) 100%));--iress-active-text-color:var(--iress-button-primary-active-text-color, var(--iress-text-color));--iress-active-border-color:var(--iress-button-primary-active-border-color, var(--iress-active-background-color));--iress-active-box-shadow-size:var(--iress-button-primary-active-box-shadow-size, 0 0);--iress-active-box-shadow-color:var(--iress-button-primary-active-box-shadow-color, transparent);--iress-active-box-shadow:var(--iress-active-box-shadow-size) var(--iress-active-box-shadow-color);--iress-active-text-decoration:var(--iress-button-primary-active-text-decoration, none)}.iress-button--secondary.sc-iress-button-h{--iress-background-color:var(--iress-button-secondary-background-color, var(--iress-g-background-color, transparent));--iress-background-image:var(--iress-button-secondary-background-image, none);--iress-text-color:var(--iress-button-secondary-text-color, var(--iress-g-primary-color, var(--iress-default-primary-color)));--iress-border-color:var(--iress-button-secondary-border-color, var(--iress-g-primary-color, var(--iress-default-primary-color)));--iress-box-shadow-size:var(--iress-button-secondary-box-shadow-size, 0 0);--iress-box-shadow-color:var(--iress-button-secondary-box-shadow-color, transparent);--iress-box-shadow:var(--iress-box-shadow-size) var(--iress-box-shadow-color);--iress-text-decoration:var(--iress-button-secondary-text-decoration, none);--iress-hover-background-color:var(--iress-button-secondary-hover-background-color, var(--iress-g-hover-background-color, var(--iress-default-hover-background-color)));--iress-hover-background-image:var(--iress-button-secondary-hover-background-image, none);--iress-hover-text-color:var(--iress-button-secondary-hover-text-color, var(--iress-g-hover-text-color, var(--iress-default-text-color--hover)));--iress-hover-border-color:var(--iress-button-secondary-hover-border-color, var(--iress-border-color));--iress-hover-box-shadow-size:var(--iress-button-secondary-hover-box-shadow-size, 0 0);--iress-hover-box-shadow-color:var(--iress-button-secondary-hover-box-shadow-color, transparent);--iress-hover-box-shadow:var(--iress-hover-box-shadow-size) var(--iress-hover-box-shadow-color);--iress-hover-text-decoration:var(--iress-button-secondary-hover-text-decoration, none);--iress-active-background-color:var(--iress-button-secondary-active-background-color, var(--iress-background-color));--iress-active-background-image:var(--iress-button-secondary-active-background-image, linear-gradient(to right, var(--iress-active-background-color), var(--iress-active-background-color) 100%));--iress-active-text-color:var(--iress-button-secondary-active-text-color, var(--iress-text-color));--iress-active-border-color:var(--iress-button-secondary-active-border-color, var(--iress-active-background-color));--iress-active-box-shadow-size:var(--iress-button-secondary-active-box-shadow-size, 0 0);--iress-active-box-shadow-color:var(--iress-button-secondary-active-box-shadow-color, transparent);--iress-active-box-shadow:var(--iress-active-box-shadow-size) var(--iress-active-box-shadow-color);--iress-active-text-decoration:var(--iress-button-secondary-active-text-decoration, none)}.iress-button--tertiary.sc-iress-button-h{--iress-background-color:var(--iress-button-tertiary-background-color, transparent);--iress-background-image:var(--iress-button-tertiary-background-image, none);--iress-text-color:var(--iress-button-tertiary-text-color, var(--iress-g-link-text-color, var(--iress-default-link-color)));--iress-border-color:var(--iress-button-tertiary-border-color, var(--iress-background-color));--iress-box-shadow-size:var(--iress-button-tertiary-box-shadow-size, 0 0);--iress-box-shadow-color:var(--iress-button-tertiary-box-shadow-color, transparent);--iress-box-shadow:var(--iress-box-shadow-size) var(--iress-box-shadow-color);--iress-text-decoration:var(--iress-button-tertiary-text-decoration, none);--iress-hover-background-color:var(--iress-button-tertiary-hover-background-color, var(--iress-g-hover-background-color, var(--iress-default-hover-background-color)));--iress-hover-background-image:var(--iress-button-tertiary-hover-background-image, none);--iress-hover-text-color:var(--iress-button-tertiary-hover-text-color, var(--iress-g-hover-text-color, var(--iress-default-text-color--hover)));--iress-hover-border-color:var(--iress-button-tertiary-hover-border-color, var(--iress-hover-background-color));--iress-hover-box-shadow-size:var(--iress-button-tertiary-hover-box-shadow-size, 0 0);--iress-hover-box-shadow-color:var(--iress-button-tertiary-hover-box-shadow-color, transparent);--iress-hover-box-shadow:var(--iress-hover-box-shadow-size) var(--iress-hover-box-shadow-color);--iress-hover-text-decoration:var(--iress-button-tertiary-hover-text-decoration, none);--iress-active-background-color:var(--iress-button-tertiary-active-background-color, var(--iress-background-color));--iress-active-background-image:var(--iress-button-tertiary-active-background-image, none);--iress-active-text-color:var(--iress-button-tertiary-active-text-color, var(--iress-text-color));--iress-active-border-color:var(--iress-button-tertiary-active-border-color, var(--iress-active-background-color));--iress-active-box-shadow-size:var(--iress-button-tertiary-active-box-shadow-size, 0 0);--iress-active-box-shadow-color:var(--iress-button-tertiary-active-box-shadow-color, transparent);--iress-active-box-shadow:var(--iress-active-box-shadow-size) var(--iress-active-box-shadow-color);--iress-active-text-decoration:var(--iress-button-tertiary-active-text-decoration, none)}.iress-button--link.sc-iress-button-h{--iress-background-color:var(--iress-button-link-background-color, transparent);--iress-background-image:var(--iress-button-link-background-image, none);--iress-text-color:var(--iress-button-link-text-color, var(--iress-g-link-text-color, var(--iress-default-link-color)));--iress-border-color:var(--iress-button-link-border-color, transparent);--iress-box-shadow-size:var(--iress-button-link-box-shadow-size, 0 0);--iress-box-shadow-color:var(--iress-button-link-box-shadow-color, transparent);--iress-box-shadow:var(--iress-box-shadow-size) var(--iress-box-shadow-color);--iress-text-decoration:var(--iress-button-link-text-decoration, underline);--iress-hover-background-color:var(--iress-button-link-hover-background-color, transparent);--iress-hover-background-image:var(--iress-button-link-hover-background-image, none);--iress-hover-text-color:var(--iress-button-link-hover-text-color, var(--iress-a-link-hover-text-color, var(--iress-text-color)));--iress-hover-border-color:var(--iress-button-link-hover-border-color, transparent);--iress-hover-box-shadow-size:var(--iress-button-link-hover-box-shadow-size, 0 0);--iress-hover-box-shadow-color:var(--iress-button-link-hover-box-shadow-color, transparent);--iress-hover-box-shadow:var(--iress-hover-box-shadow-size) var(--iress-hover-box-shadow-color);--iress-hover-text-decoration:var(--iress-button-link-hover-text-decoration, none);--iress-active-background-color:var(--iress-button-link-active-background-color, transparent);--iress-active-background-image:var(--iress-button-link-active-background-image, none);--iress-active-text-color:var(--iress-button-link-active-text-color, var(--iress-a-link-active-text-color, var(--iress-text-color)));--iress-active-border-color:var(--iress-button-link-active-border-color, transparent);--iress-active-box-shadow-size:var(--iress-button-link-active-box-shadow-size, 0 0);--iress-active-box-shadow-color:var(--iress-button-link-active-box-shadow-color, transparent);--iress-active-box-shadow:var(--iress-active-box-shadow-size) var(--iress-active-box-shadow-color);--iress-active-text-decoration:var(--iress-button-link-active-text-decoration, none)}.iress-button--danger.sc-iress-button-h{--iress-background-color:var(--iress-button-danger-background-color, transparent);--iress-background-image:var(--iress-button-danger-background-image, none);--iress-text-color:var(--iress-button-danger-text-color, var(--iress-a-danger-text-color, var(--iress-g-danger-color, var(--iress-default-danger-color))));--iress-border-color:var(--iress-button-danger-border-color, var(--iress-a-danger-border-color, var(--iress-g-danger-color, var(--iress-default-danger-color))));--iress-box-shadow-size:var(--iress-button-danger-box-shadow-size, 0 0);--iress-box-shadow-color:var(--iress-button-danger-box-shadow-color, transparent);--iress-box-shadow:var(--iress-box-shadow-size) var(--iress-box-shadow-color);--iress-text-decoration:var(--iress-button-danger-text-decoration, none);--iress-hover-background-color:var(\n        --iress-button-danger-hover-background-color,\n        var(--iress-a-danger-hover-background-color, var(--iress-g-hover-background-color, var(--iress-default-hover-background-color)))\n    );--iress-hover-background-image:var(--iress-button-danger-hover-background-image, none);--iress-hover-text-color:var(--iress-button-danger-hover-text-color, var(--iress-a-danger-hover-text-color, var(--iress-g-hover-text-color, var(--iress-default-text-color--hover))));--iress-hover-border-color:var(--iress-button-danger-hover-border-color, var(--iress-border-color));--iress-hover-box-shadow-size:var(--iress-button-danger-hover-box-shadow-size, 0 0);--iress-hover-box-shadow-color:var(--iress-button-danger-hover-box-shadow-color, transparent);--iress-hover-box-shadow:var(--iress-hover-box-shadow-size) var(--iress-hover-box-shadow-color);--iress-hover-text-decoration:var(--iress-button-danger-hover-text-decoration, none);--iress-active-background-color:var(--iress-button-danger-active-background-color, var(--iress-background-color));--iress-active-background-image:var(--iress-button-danger-active-background-image, linear-gradient(to right, var(--iress-active-background-color), var(--iress-active-background-color) 100%));--iress-active-text-color:var(--iress-button-danger-active-text-color, var(--iress-text-color));--iress-active-border-color:var(--iress-button-danger-active-border-color, var(--iress-border-color));--iress-active-box-shadow-size:var(--iress-button-danger-active-box-shadow-size, 0 0);--iress-active-box-shadow-color:var(--iress-button-danger-active-box-shadow-color, transparent);--iress-active-box-shadow:var(--iress-active-box-shadow-size) var(--iress-active-box-shadow-color);--iress-active-text-decoration:var(--iress-button-danger-active-text-decoration, none)}.iress-button--info.sc-iress-button-h{--iress-background-color:var(--iress-button-info-background-color, transparent);--iress-background-image:var(--iress-button-info-background-image, none);--iress-text-color:var(--iress-button-info-text-color, var(--iress-a-info-text-color, var(--iress-g-info-color, var(--iress-default-info-color))));--iress-border-color:var(--iress-button-info-border-color, var(--iress-a-info-border-color, var(--iress-g-info-color, var(--iress-default-info-color))));--iress-box-shadow-size:var(--iress-button-info-box-shadow-size, 0 0);--iress-box-shadow-color:var(--iress-button-info-box-shadow-color, transparent);--iress-box-shadow:var(--iress-box-shadow-size) var(--iress-box-shadow-color);--iress-text-decoration:var(--iress-button-info-text-decoration, none);--iress-hover-background-color:var(\n        --iress-button-info-hover-background-color,\n        var(--iress-a-info-hover-background-color, var(--iress-g-hover-background-color, var(--iress-default-hover-background-color)))\n    );--iress-hover-background-image:var(--iress-button-info-hover-background-image, none);--iress-hover-text-color:var(--iress-button-info-hover-text-color, var(--iress-a-info-hover-text-color, var(--iress-g-hover-text-color, var(--iress-default-text-color--hover))));--iress-hover-border-color:var(--iress-button-info-hover-border-color, var(--iress-border-color));--iress-hover-box-shadow-size:var(--iress-button-info-hover-box-shadow-size, 0 0);--iress-hover-box-shadow-color:var(--iress-button-info-hover-box-shadow-color, transparent);--iress-hover-box-shadow:var(--iress-hover-box-shadow-size) var(--iress-hover-box-shadow-color);--iress-hover-text-decoration:var(--iress-button-info-hover-text-decoration, none);--iress-active-background-color:var(--iress-button-info-active-background-color, var(--iress-background-color));--iress-active-background-image:var(--iress-button-info-active-background-image, linear-gradient(to right, var(--iress-active-background-color), var(--iress-active-background-color) 100%));--iress-active-text-color:var(--iress-button-info-active-text-color, var(--iress-text-color));--iress-active-border-color:var(--iress-button-info-active-border-color, var(--iress-border-color));--iress-active-box-shadow-size:var(--iress-button-info-active-box-shadow-size, 0 0);--iress-active-box-shadow-color:var(--iress-button-info-active-box-shadow-color, transparent);--iress-active-box-shadow:var(--iress-active-box-shadow-size) var(--iress-active-box-shadow-color);--iress-active-text-decoration:var(--iress-button-info-active-text-decoration, none)}.iress-button--success.sc-iress-button-h{--iress-background-color:var(--iress-button-success-background-color, transparent);--iress-background-image:var(--iress-button-success-background-image, none);--iress-text-color:var(--iress-button-success-text-color, var(--iress-a-success-text-color, var(--iress-g-success-color, var(--iress-default-success-color))));--iress-border-color:var(--iress-button-success-border-color, var(--iress-a-success-border-color, var(--iress-g-success-color, var(--iress-default-success-color))));--iress-box-shadow-size:var(--iress-button-success-box-shadow-size, 0 0);--iress-box-shadow-color:var(--iress-button-success-box-shadow-color, transparent);--iress-box-shadow:var(--iress-box-shadow-size) var(--iress-box-shadow-color);--iress-text-decoration:var(--iress-button-success-text-decoration, none);--iress-hover-background-color:var(\n        --iress-button-success-hover-background-color,\n        var(--iress-a-success-hover-background-color, var(--iress-g-hover-background-color, var(--iress-default-hover-background-color)))\n    );--iress-hover-background-image:var(--iress-button-success-hover-background-image, none);--iress-hover-text-color:var(--iress-button-success-hover-text-color, var(--iress-a-success-hover-text-color, var(--iress-g-hover-text-color, var(--iress-default-text-color--hover))));--iress-hover-border-color:var(--iress-button-success-hover-border-color, var(--iress-border-color));--iress-hover-box-shadow-size:var(--iress-button-success-hover-box-shadow-size, 0 0);--iress-hover-box-shadow-color:var(--iress-button-success-hover-box-shadow-color, transparent);--iress-hover-box-shadow:var(--iress-hover-box-shadow-size) var(--iress-hover-box-shadow-color);--iress-hover-text-decoration:var(--iress-button-success-hover-text-decoration, none);--iress-active-background-color:var(--iress-button-success-active-background-color, var(--iress-background-color));--iress-active-background-image:var(--iress-button-success-active-background-image, linear-gradient(to right, var(--iress-active-background-color), var(--iress-active-background-color) 100%));--iress-active-text-color:var(--iress-button-success-active-text-color, var(--iress-text-color));--iress-active-border-color:var(--iress-button-success-active-border-color, var(--iress-border-color));--iress-active-box-shadow-size:var(--iress-button-success-active-box-shadow-size, 0 0);--iress-active-box-shadow-color:var(--iress-button-success-active-box-shadow-color, transparent);--iress-active-box-shadow:var(--iress-active-box-shadow-size) var(--iress-active-box-shadow-color);--iress-active-text-decoration:var(--iress-button-success-active-text-decoration, none)}.iress-button--warning.sc-iress-button-h{--iress-background-color:var(--iress-button-warning-background-color, transparent);--iress-background-image:var(--iress-button-warning-background-image, none);--iress-text-color:var(--iress-button-warning-text-color, var(--iress-a-warning-text-color, var(--iress-g-warning-color, var(--iress-default-warning-color))));--iress-border-color:var(--iress-button-warning-border-color, var(--iress-a-warning-border-color, var(--iress-g-warning-color, var(--iress-default-warning-color))));--iress-box-shadow-size:var(--iress-button-warning-box-shadow-size, 0 0);--iress-box-shadow-color:var(--iress-button-warning-box-shadow-color, transparent);--iress-box-shadow:var(--iress-box-shadow-size) var(--iress-box-shadow-color);--iress-text-decoration:var(--iress-button-warning-text-decoration, none);--iress-hover-background-color:var(\n        --iress-button-warning-hover-background-color,\n        var(--iress-a-warning-hover-background-color, var(--iress-g-hover-background-color, var(--iress-default-hover-background-color)))\n    );--iress-hover-background-image:var(--iress-button-warning-hover-background-image, none);--iress-hover-text-color:var(--iress-button-warning-hover-text-color, var(--iress-a-warning-hover-text-color, var(--iress-g-hover-text-color, var(--iress-default-text-color--hover))));--iress-hover-border-color:var(--iress-button-warning-hover-border-color, var(--iress-border-color));--iress-hover-box-shadow-size:var(--iress-button-warning-hover-box-shadow-size, 0 0);--iress-hover-box-shadow-color:var(--iress-button-warning-hover-box-shadow-color, transparent);--iress-hover-box-shadow:var(--iress-hover-box-shadow-size) var(--iress-hover-box-shadow-color);--iress-hover-text-decoration:var(--iress-button-warning-hover-text-decoration, none);--iress-active-background-color:var(--iress-button-warning-active-background-color, var(--iress-background-color));--iress-active-background-image:var(--iress-button-warning-active-background-image, linear-gradient(to right, var(--iress-active-background-color), var(--iress-active-background-color) 100%));--iress-active-text-color:var(--iress-button-warning-active-text-color, var(--iress-text-color));--iress-active-border-color:var(--iress-button-warning-active-border-color, var(--iress-border-color));--iress-active-box-shadow-size:var(--iress-button-warning-active-box-shadow-size, 0 0);--iress-active-box-shadow-color:var(--iress-button-warning-active-box-shadow-color, transparent);--iress-active-box-shadow:var(--iress-active-box-shadow-size) var(--iress-active-box-shadow-color);--iress-active-text-decoration:var(--iress-button-warning-active-text-decoration, none)}.iress-button--negative.sc-iress-button-h{--iress-background-color:var(--iress-button-negative-background-color, var(--iress-a-negative-background-color, var(--iress-g-negative-color, var(--iress-default-negative-color))));--iress-background-image:var(--iress-button-negative-background-image, none);--iress-text-color:var(--iress-button-negative-text-color, var(--iress-g-negative-contrast-color, var(--iress-default-text-color--alt)));--iress-border-color:var(--iress-button-negative-border-color, var(--iress-a-negative-border-color, var(--iress-g-negative-color, var(--iress-default-negative-color))));--iress-box-shadow-size:var(--iress-button-negative-box-shadow-size, 0 0);--iress-box-shadow-color:var(--iress-button-negative-box-shadow-color, transparent);--iress-box-shadow:var(--iress-box-shadow-size) var(--iress-box-shadow-color);--iress-text-decoration:var(--iress-button-negative-text-decoration, none);--iress-hover-background-color:var(\n        --iress-button-negative-hover-background-color,\n        var(--iress-a-negative-hover-background-color, var(--iress-g-hover-background-color, var(--iress-default-negative-hover-color)))\n    );--iress-hover-background-image:var(--iress-button-negative-hover-background-image, none);--iress-hover-text-color:var(--iress-button-negative-hover-text-color, var(--iress-a-negative-hover-text-color, var(--iress-g-hover-background-color, var(--iress-default-text-color--alt))));--iress-hover-border-color:var(--iress-button-negative-hover-border-color, var(--iress-hover-background-color));--iress-hover-box-shadow-size:var(--iress-button-negative-hover-box-shadow-size, 0 0);--iress-hover-box-shadow-color:var(--iress-button-negative-hover-box-shadow-color, transparent);--iress-hover-box-shadow:var(--iress-hover-box-shadow-size) var(--iress-hover-box-shadow-color);--iress-hover-text-decoration:var(--iress-button-negative-hover-text-decoration, none);--iress-active-background-color:var(--iress-button-negative-active-background-color, var(--iress-background-color));--iress-active-background-image:var(--iress-button-negative-active-background-image, linear-gradient(to right, var(--iress-active-background-color), var(--iress-active-background-color) 100%));--iress-active-text-color:var(--iress-button-negative-active-text-color, var(--iress-text-color));--iress-active-border-color:var(--iress-button-negative-active-border-color, var(--iress-active-background-color));--iress-active-box-shadow-size:var(--iress-button-negative-active-box-shadow-size, 0 0);--iress-active-box-shadow-color:var(--iress-button-negative-active-box-shadow-color, transparent);--iress-active-box-shadow:var(--iress-active-box-shadow-size) var(--iress-active-box-shadow-color);--iress-active-text-decoration:var(--iress-button-negative-active-text-decoration, none)}.iress-button--positive.sc-iress-button-h{--iress-background-color:var(--iress-button-positive-background-color, var(--iress-a-positive-background-color, var(--iress-g-positive-color, var(--iress-default-positive-color))));--iress-background-image:var(--iress-button-positive-background-image, none);--iress-text-color:var(--iress-button-sell-text-color, var(--iress-g-positive-contrast-color, var(--iress-default-text-color--alt)));--iress-border-color:var(--iress-button-positive-border-color, var(--iress-a-positive-border-color, var(--iress-g-positive-color, var(--iress-default-positive-color))));--iress-box-shadow-size:var(--iress-button-positive-box-shadow-size, 0 0);--iress-box-shadow-color:var(--iress-button-positive-box-shadow-color, transparent);--iress-box-shadow:var(--iress-box-shadow-size) var(--iress-box-shadow-color);--iress-text-decoration:var(--iress-button-positive-text-decoration, none);--iress-hover-background-color:var(\n        --iress-button-positive-hover-background-color,\n        var(--iress-a-positive-hover-background-color, var(--iress-g-hover-background-color, var(--iress-default-positive-hover-color)))\n    );--iress-hover-background-image:var(--iress-button-positive-hover-background-image, none);--iress-hover-text-color:var(--iress-button-positive-hover-text-color, var(--iress-a-positive-hover-text-color, var(--iress-g-hover-background-color, var(--iress-default-text-color--alt))));--iress-hover-border-color:var(--iress-button-positive-hover-border-color, var(--iress-hover-background-color));--iress-hover-box-shadow-size:var(--iress-button-positive-hover-box-shadow-size, 0 0);--iress-hover-box-shadow-color:var(--iress-button-positive-hover-box-shadow-color, transparent);--iress-hover-box-shadow:var(--iress-hover-box-shadow-size) var(--iress-hover-box-shadow-color);--iress-hover-text-decoration:var(--iress-button-positive-hover-text-decoration, none);--iress-active-background-color:var(--iress-button-positive-active-background-color, var(--iress-background-color));--iress-active-background-image:var(--iress-button-positive-active-background-image, linear-gradient(to right, var(--iress-active-background-color), var(--iress-active-background-color) 100%));--iress-active-text-color:var(--iress-button-positive-active-text-color, var(--iress-text-color));--iress-active-border-color:var(--iress-button-positive-active-border-color, var(--iress-active-background-color));--iress-active-box-shadow-size:var(--iress-button-positive-active-box-shadow-size, 0 0);--iress-active-box-shadow-color:var(--iress-button-positive-active-box-shadow-color, transparent);--iress-active-box-shadow:var(--iress-active-box-shadow-size) var(--iress-active-box-shadow-color);--iress-active-text-decoration:var(--iress-button-positive-active-text-decoration, none)}.iress-button.sc-iress-button-h{--iress-font-family:var(--iress-button-font-family,\n          var(--iress-a-form-font-family,\n              var(--iress-g-font-family,\n                  inherit\n      )));--iress-font-size:var(--iress-button-font-size, inherit);--iress-font-weight:var(--iress-button-font-weight, var(--iress-g-font-weight, normal));--iress-line-height:var(--iress-button-line-height,\n          var(--iress-a-form-line-height,\n              var(--iress-g-line-height,\n                  1.5\n      )));--iress-text-align:center;--iress-padding-x:var(--iress-button-padding-x, var(--iress-g-spacing-sm));--iress-padding-y:var(--iress-button-padding-y, var(--iress-g-spacing-xs));--iress-margin-right:var(--iress-button-margin-right, var(--iress-g-spacing-xs));--iress-border-width:var(--iress-button-border-width,\n          var(--iress-a-button-border-width,\n              var(--iress-g-border-width,\n                  var(--iress-default-border-width\n  ))));--iress-border-radius:var(--iress-button-border-radius,\n          var(--iress-a-button-border-radius,\n              var(--iress-g-border-radius,\n                  var(--iress-default-border-radius\n  ))));--iress-transition-hover-duration:var(--iress-button-transition-hover-duration,\n          var(--iress-g-transition-hover-duration,\n              var(--iress-default-hover-transition-duration\n  )));--iress-transition-hover-type:var(--iress-button-transition-hover-type,\n          var(--iress-g-transition-hover-type,\n              var(--iress-default-hover-transition-type\n  )));--iress-focus-background-color:var(--iress-hover-background-color);--iress-focus-background-image:var(--iress-hover-background-image);--iress-focus-border-color:var(--iress-focus-color);--iress-focus-box-shadow-size:var(--iress-g-focus-width, 2px);--iress-focus-box-shadow:0 0 0 var(--iress-focus-box-shadow-size) var(--iress-focus-color);--iress-inset-focus-box-shadow:inset 0 0 0 var(--iress-focus-box-shadow-size) var(--iress-focus-color);--iress-focus-text-color:var(--iress-hover-text-color);--iress-min-height:var(--iress-input-min-height, var(--iress-default-min-height));--iress-slot-margin-x:var(--iress-button-slot-margin-x, var(--iress-g-spacing-sm));--iress-active-animation:var(--iress-button-animation-active, 0.1s ease-out iressButtonFill)}.sc-iress-button-h,.sc-iress-button-h *.sc-iress-button,.sc-iress-button-h *.sc-iress-button::before,.sc-iress-button-h *.sc-iress-button::after{box-sizing:border-box;display:inline-block}.iress-button.sc-iress-button-h .iress-button__button.sc-iress-button{font-family:var(--iress-font-family);font-size:var(--iress-font-size);font-weight:var(--iress-font-weight);line-height:var(--iress-line-height);background-color:var(--iress-background-color);background-image:var(--iress-background-image);text-align:var(--iress-text-align);color:var(--iress-text-color);border-radius:var(--iress-border-radius);border-width:var(--iress-border-width);border-style:solid;border-color:var(--iress-border-color);padding-block-start:var(--iress-padding-y);padding-block-end:var(--iress-padding-y);padding-inline-start:calc(var(--iress-padding-x) + 0.125 * var(--iress-border-radius));padding-inline-end:calc(var(--iress-padding-x) + 0.125 * var(--iress-border-radius));margin-block:0;margin-inline-start:0;margin-inline-end:var(--iress-margin-right);transition-timing-function:var(--iress-transition-hover-type);transition-duration:var(--iress-transition-hover-duration);text-decoration:var(--iress-text-decoration);display:inline-flex;align-items:center;min-height:var(--iress-min-height);width:auto;max-width:100%;user-select:none;vertical-align:top;vertical-align:-webkit-baseline-middle;pointer-events:auto;font-kerning:none;cursor:pointer;background-position:center;animation-fill-mode:forwards;background-repeat:no-repeat;background-size:100% 100%;transition-property:color, background-color, border-color, transform, -webkit-transform}.iress-button--link.sc-iress-button-h .iress-button__button.sc-iress-button{padding-inline-start:0;padding-inline-end:0}.iress-button.sc-iress-button-h:last-child .iress-button__button.sc-iress-button{margin-inline-end:0}.iress-button.sc-iress-button-h .iress-button__inner.sc-iress-button{display:flex;justify-content:center}.iress-button--no-wrap.sc-iress-button-h .iress-button__button.sc-iress-button{white-space:nowrap;max-width:initial}@media (hover: hover){.iress-button.sc-iress-button-h .iress-button__button.sc-iress-button:hover{background-color:var(--iress-hover-background-color);background-image:var(--iress-hover-background-image);border-color:var(--iress-hover-border-color);box-shadow:var(--iress-hover-box-shadow);color:var(--iress-hover-text-color);text-decoration:var(--iress-hover-text-decoration)}}.iress-button--vrt-hover.sc-iress-button-h .iress-button__button.sc-iress-button{background-color:var(--iress-hover-background-color);background-image:var(--iress-hover-background-image);border-color:var(--iress-hover-border-color);box-shadow:var(--iress-hover-box-shadow);color:var(--iress-hover-text-color);text-decoration:var(--iress-hover-text-decoration)}.iress-button.sc-iress-button-h .iress-button__button.sc-iress-button:focus:focus-visible,.iress-button--vrt-focus.sc-iress-button-h .iress-button__button.sc-iress-button{background-color:var(--iress-focus-background-color);background-image:var(--iress-focus-background-image);border-color:var(--iress-focus-border-color);box-shadow:var(--iress-focus-box-shadow);color:var(--iress-focus-text-color);outline:none;text-decoration:var(--iress-hover-text-decoration)}.iress-button.sc-iress-button-h .iress-button__button.sc-iress-button:focus:not(:focus-visible){box-shadow:none}@keyframes iressButtonFill{0%{background-size:0 0}100%{background-size:100% 100%}}.iress-button.sc-iress-button-h .iress-button__button.sc-iress-button:active,.iress-button--vrt-active.sc-iress-button-h .iress-button__button.sc-iress-button{background-color:var(--iress-active-background-color);border-color:var(--iress-active-border-color);box-shadow:var(--iress-active-box-shadow);color:var(--iress-active-text-color);text-decoration:var(--iress-active-text-decoration);animation:var(--iress-active-animation);background-image:var(--iress-active-background-image)}.iress-button--fluid.sc-iress-button-h,.iress-button--fluid.sc-iress-button-h .iress-button__button.sc-iress-button,.iress-button--fluid-xs.sc-iress-button-h,.iress-button--fluid-xs.sc-iress-button-h .iress-button__button.sc-iress-button,.iress-button--fluid-sm.sc-iress-button-h,.iress-button--fluid-sm.sc-iress-button-h .iress-button__button.sc-iress-button,.iress-button--fluid-md.sc-iress-button-h,.iress-button--fluid-md.sc-iress-button-h .iress-button__button.sc-iress-button,.iress-button--fluid-lg.sc-iress-button-h,.iress-button--fluid-lg.sc-iress-button-h .iress-button__button.sc-iress-button,.iress-button--fluid-xl.sc-iress-button-h,.iress-button--fluid-xl.sc-iress-button-h .iress-button__button.sc-iress-button{display:flex;width:100%;margin-inline-end:0}.iress-button--fluid.sc-iress-button-h>.iress-button__inner.sc-iress-button,.iress-button--fluid.sc-iress-button-h .iress-button__button.sc-iress-button>.iress-button__inner.sc-iress-button,.iress-button--fluid-xs.sc-iress-button-h>.iress-button__inner.sc-iress-button,.iress-button--fluid-xs.sc-iress-button-h .iress-button__button.sc-iress-button>.iress-button__inner.sc-iress-button,.iress-button--fluid-sm.sc-iress-button-h>.iress-button__inner.sc-iress-button,.iress-button--fluid-sm.sc-iress-button-h .iress-button__button.sc-iress-button>.iress-button__inner.sc-iress-button,.iress-button--fluid-md.sc-iress-button-h>.iress-button__inner.sc-iress-button,.iress-button--fluid-md.sc-iress-button-h .iress-button__button.sc-iress-button>.iress-button__inner.sc-iress-button,.iress-button--fluid-lg.sc-iress-button-h>.iress-button__inner.sc-iress-button,.iress-button--fluid-lg.sc-iress-button-h .iress-button__button.sc-iress-button>.iress-button__inner.sc-iress-button,.iress-button--fluid-xl.sc-iress-button-h>.iress-button__inner.sc-iress-button,.iress-button--fluid-xl.sc-iress-button-h .iress-button__button.sc-iress-button>.iress-button__inner.sc-iress-button{display:flex;justify-content:var(--iress-text-align);width:100%}.sc-iress-button-h.iress-button .sc-iress-button-s>[slot=prepend]{display:inline-block;margin-inline-end:var(--iress-slot-margin-x)}.sc-iress-button-h.iress-button .sc-iress-button-s>[slot=append]{display:inline-block;margin-inline-start:var(--iress-slot-margin-x)}.sc-iress-button-h.iress-button .sc-iress-button-s>.iress-badge{margin-block-start:calc(-0.06 * var(--iress-g-spacing-rem));margin-block-end:calc(-0.06 * var(--iress-g-spacing-rem))}.sc-iress-button-h.iress-button .sc-iress-button-s>.iress-badge[slot=append]{margin-inline-end:calc(-0.25 * var(--iress-g-spacing-rem))}.iress-filter__activator.sc-iress-button-h .iress-button__button.sc-iress-button{padding-inline-end:calc(2 * var(--iress-padding-x) + 0.75 * var(--iress-g-spacing-rem));position:relative}.iress-table.sc-iress-button-h .iress-button__button.sc-iress-button,.iress-table .sc-iress-button-h .iress-button__button.sc-iress-button{--iress-negative-margin:calc(var(--iress-padding-y, var(--iress-default-spacing-xs)) + var(--iress-border-width, 1px) + 1px);margin-block-start:calc(-1 * min(var(--iress-row-spacing), var(--iress-negative-margin)))}.iress-popover.sc-iress-button-h .iress-menu-item.sc-iress-button .iress-button__button.sc-iress-button,.iress-popover .iress-menu-item .sc-iress-button-h .iress-button__button.sc-iress-button{border-radius:0px}.iress-popover.sc-iress-button-h .iress-menu-item.sc-iress-button:first-child .iress-button__button.sc-iress-button,.iress-popover .iress-menu-item:first-child .sc-iress-button-h .iress-button__button.sc-iress-button{border-start-start-radius:var(--iress-popper-border-radius, var(--iress-border-radius));border-start-end-radius:var(--iress-popper-border-radius, var(--iress-border-radius))}.iress-popover.sc-iress-button-h .iress-menu-item.sc-iress-button:last-child .iress-button__button.sc-iress-button,.iress-popover .iress-menu-item:last-child .sc-iress-button-h .iress-button__button.sc-iress-button{border-end-start-radius:var(--iress-popper-border-radius, var(--iress-border-radius));border-end-end-radius:var(--iress-popper-border-radius, var(--iress-border-radius))}.iress-view-mode-compact.sc-iress-button-h .iress-table.iress-button.sc-iress-button,.iress-view-mode-compact .iress-table .iress-button.sc-iress-button-h{--iress-padding-y:0;--iress-input-min-height:calc(1.5 * var(--iress-g-spacing-rem));--iress-line-height:1.2;display:contents}.iress-view-mode-compact.sc-iress-button-h .iress-table.sc-iress-button .iress-button__button.sc-iress-button,.iress-view-mode-compact .iress-table .sc-iress-button-h .iress-button__button.sc-iress-button{--iress-negative-margin:calc(var(--iress-padding-y, var(--iress-default-spacing-xs)) + var(--iress-border-width, 1px));margin-block-start:calc(-1 * min(var(--iress-row-spacing), var(--iress-negative-margin)))}@media only screen and (min-width: 576px){.iress-button--fluid-xs.sc-iress-button-h,.iress-button--fluid-xs.sc-iress-button-h .iress-button__button.sc-iress-button{display:inline-flex;width:auto}.iress-button--fluid-xs.sc-iress-button-h>.iress-button__inner.sc-iress-button,.iress-button--fluid-xs.sc-iress-button-h .iress-button__button.sc-iress-button>.iress-button__inner.sc-iress-button{width:auto;justify-content:center}.iress-button--fluid-xs.sc-iress-button-h .iress-button__button.sc-iress-button{margin-inline-end:var(--iress-margin-right)}}@media only screen and (min-width: 768px){.iress-button--fluid-sm.sc-iress-button-h,.iress-button--fluid-sm.sc-iress-button-h .iress-button__button.sc-iress-button{display:inline-flex;width:auto}.iress-button--fluid-sm.sc-iress-button-h>.iress-button__inner.sc-iress-button,.iress-button--fluid-sm.sc-iress-button-h .iress-button__button.sc-iress-button>.iress-button__inner.sc-iress-button{width:auto;justify-content:center}.iress-button--fluid-sm.sc-iress-button-h .iress-button__button.sc-iress-button{margin-inline-end:var(--iress-margin-right)}}@media only screen and (min-width: 1024px){.iress-button--fluid-md.sc-iress-button-h,.iress-button--fluid-md.sc-iress-button-h .iress-button__button.sc-iress-button{display:inline-flex;width:auto}.iress-button--fluid-md.sc-iress-button-h>.iress-button__inner.sc-iress-button,.iress-button--fluid-md.sc-iress-button-h .iress-button__button.sc-iress-button>.iress-button__inner.sc-iress-button{width:auto;justify-content:center}.iress-button--fluid-md.sc-iress-button-h .iress-button__button.sc-iress-button{margin-inline-end:var(--iress-margin-right)}}@media only screen and (min-width: 1200px){.iress-button--fluid-lg.sc-iress-button-h,.iress-button--fluid-lg.sc-iress-button-h .iress-button__button.sc-iress-button{display:inline-flex;width:auto}.iress-button--fluid-lg.sc-iress-button-h>.iress-button__inner.sc-iress-button,.iress-button--fluid-lg.sc-iress-button-h .iress-button__button.sc-iress-button>.iress-button__inner.sc-iress-button{width:auto;justify-content:center}.iress-button--fluid-lg.sc-iress-button-h .iress-button__button.sc-iress-button{margin-inline-end:var(--iress-margin-right)}}";

const Button = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.iressFocus = createEvent(this, "iressFocus", 7);
    this.iressBlur = createEvent(this, "iressBlur", 7);
    this.iressClick = createEvent(this, "iressClick", 7);
    /**
     * Used to supply custom routing elements like react-router's <Link>. If true, only the default slot will be rendered.
     */
    this.customRoute = false;
    /**
     * If `true`, the button will stretch to fill it's container. If set to a breakpoint, the button will be fluid up till that breakpoint
     */
    this.fluid = false;
    /**
     * Style of the button
     */
    this.mode = ButtonMode.Secondary;
    /**
     * The type of the button.
     */
    this.type = ButtonType.Button;
    /**
     * Prevents text wrapping if set to true.
     */
    this.noWrap = false;
    this.onClick = (e) => {
      this.iressClick.emit(e);
    };
    this.onFocus = (e) => {
      this.iressFocus.emit(e);
    };
    this.onBlur = (e) => {
      this.iressBlur.emit(e);
    };
    this.buttonAttrs = () => elements.filter((el) => el.tag === 'button')[0];
    this.anchorAttrs = () => elements.filter((el) => el.tag === 'a')[0];
    this.getHostClassMap = () => {
      const hasFluid = this.fluid !== undefined &&
        this.fluid !== false &&
        this.fluid !== 'false';
      const fluidBoolean = this.fluid === true || this.fluid === 'true' || this.fluid === '';
      const fluidModifier = hasFluid && !fluidBoolean ? `-${this.fluid}` : '';
      const classMap = {
        [ButtonCssClass.Base]: true,
        [`${ButtonCssClass.Fluid}`]: hasFluid,
        [`${ButtonCssClass.Base}--${this.mode}`]: true,
        [ButtonCssClass.HasCustomRouting]: this.customRoute,
        [ButtonCssClass.NoWrap]: this.noWrap,
      };
      if (fluidModifier !== '') {
        classMap[`${ButtonCssClass.Fluid}${fluidModifier}`] = true;
      }
      return classMap;
    };
  }
  componentWillRender() {
    if (this.customRoute) {
      const customRouteLink = this.el.querySelector('a');
      customRouteLink === null || customRouteLink === void 0 ? void 0 : customRouteLink.classList.add(`${ButtonCssClass.Button}`, 'sc-iress-button');
      const customRouteButton = this.el.querySelector('button');
      customRouteButton === null || customRouteButton === void 0 ? void 0 : customRouteButton.classList.add(`${ButtonCssClass.Button}`, 'sc-iress-button');
    }
  }
  render() {
    const TagType = this.href === undefined ? ButtonTagType.Button : ButtonTagType.Link;
    const { type, href, rel, target, attrs } = this;
    const eleAttrs = TagType === ButtonTagType.Button
      ? {
        type,
      }
      : {
        href,
        rel,
        target,
      };
    const testIdSuffix = TagType === ButtonTagType.Button ? 'button' : 'link';
    const disallowedAttrs = TagType === ButtonTagType.Button
      ? this.buttonAttrs()
      : this.anchorAttrs();
    const customAttrs = getAllowedAttrs(attrs, disallowedAttrs);
    return (h(Host, { class: this.getHostClassMap() }, this.customRoute ? (h("slot", null)) : (h(TagType, Object.assign({}, eleAttrs, { class: ButtonCssClass.Button, onClick: this.onClick, onFocus: this.onFocus, onBlur: this.onBlur, "data-testid": nativeTestid(this.el, testIdSuffix) }, customAttrs), h("span", { class: ButtonCssClass.Inner }, h("slot", { name: ButtonSlot.IconOnly }), h("slot", { name: ButtonSlot.Prepend }), h("slot", null), h("slot", { name: ButtonSlot.Append }))))));
  }
  get el() { return getElement(this); }
};
Button.style = buttonCss;

const MenuItemHeader = ({ headingLevel, el, suffix, dataTestId, }) => {
  if (headingLevel === undefined)
    return null;
  const Text = `iress-text${suffix}`;
  const hasNamedSlotContent = hasSlotContent(MenuItemSlot.Prepend, el) ||
    hasSlotContent(MenuItemSlot.Append, el);
  return (h("div", { class: {
      [MenuItemCssClass.Header]: true,
      [MenuItemCssClass.HeaderSlots]: hasNamedSlotContent,
    }, "data-testid": dataTestId },
    h("slot", { name: MenuItemSlot.Prepend }),
    h(Text, { element: headingLevel },
      h("slot", null)),
    h("slot", { name: MenuItemSlot.Append })));
};

const menuItemCss = ".sc-iress-menu-item-h{--iress-button-font-family:var(--iress-menu-item-font-family,\n          var(--iress-g-font-family, inherit\n  ));--iress-button-font-size:var(--iress-menu-item-font-size, inherit);--iress-button-font-weight:var(--iress-menu-item-font-weight,\n          var(--iress-g-font-weight,\n              normal\n  ));--iress-button-min-height:var(--iress-menu-item-min-height, var(--iress-default-min-height));--iress-background-color:var(--iress-menu-item-background-color, transparent);--iress-button-hover-background-color:var(--iress-menu-item-hover-background-color,\n          var(--iress-a-layout-hover-background-color,\n              var(--iress-g-hover-background-color,\n                  var(--iress-default-hover-background-color\n  ))));--iress-button-active-background-color:var(--iress-menu-item-active-background-color,\n          var(--iress-background-color\n  ));--iress-text-align:var(--iress-menu-item-text-align, flex-start);--iress-button-text-color:var(--iress-menu-item-text-color,\n          var(--iress-g-text-color,\n              inherit)\n  );--iress-button-hover-text-color:var(--iress-menu-item-hover-text-color,\n          var(--iress-a-layout-hover-text-color,\n              var(--iress-g-hover-text-color,\n                  var(--iress-text-color\n  ))));--iress-button-active-text-color:var(--iress-menu-item-active-text-color,\n          var(--iress-text-color\n  ));--iress-item-border-radius:var(--iress-menu-item-border-radius, 0px);--iress-button-padding-x:var(--iress-menu-item-padding-x,\n          var(--iress-g-spacing-md\n  ));--iress-button-padding-y:var(--iress-menu-item-padding-y,\n          var(--iress-g-spacing-sm\n  ));--iress-header-background-color:var(--iress-menu-item-header-background-color, transparent);--iress-header-font-family:var(--iress-menu-item-header-font-family, var(--iress-a-heading-font-family, var(--iress-g-font-family)));--iress-header-text-color:var(--iress-menu-item-header-text-color,\n          var(--iress-a-heading-text-color,\n              var(--iress-g-primary-color,\n                  inherit\n  )));--iress-header-text-align:var(--iress-menu-item-header-text-align, start);--iress-header-padding-x:var(--iress-menu-item-padding-x,\n          var(--iress-g-spacing-md\n  ));--iress-header-padding-top:var(--iress-menu-item-padding-y,\n          var(--iress-g-spacing-sm\n  ));--iress-header-padding-bottom:var(--iress-menu-item-padding-y,\n          var(--iress-g-spacing-xs\n  ));--iress-divider-border-width:var(--iress-menu-item-divider-border-width, 1px);--iress-divider-border-color:var(--iress-menu-item-divider-border-color,\n          var(--iress-g-border-color,\n              var(--iress-default-border-color\n  )));--iress-checkbox-spacing:var(--iress-g-spacing-sm);--iress-mark-color:var(--iress-menu-item-active-border-color,\n          var(--iress-a-active-border-color,\n              var(--iress-g-primary-color,\n                  var(--iress-default-active-color\n  ))));--iress-transition-hover-duration:var(--iress-menu-item-transition-hover-duration,\n          var(--iress-g-transition-hover-duration,\n              var(--iress-default-transition--hover\n  )));--iress-transition-hover-type:var(--iress-menu-item-transition-hover-type,\n          var(--iress-g-transition-hover-type,\n              var(--iress-default-transition-type\n  )));--iress-nav-button-selected-background-color:var(--iress-menu-item-nav-selected-background-color,\n          var(--iress-a-active-background-color,\n              var(--iress-g-primary-color,\n                  var(--iress-default-primary-color\n  ))));--iress-nav-button-text-align:var(--iress-menu-item-nav-text-align,\n          var(--iress-text-align\n  ));--iress-nav-button-selected-text-color:var(--iress-menu-item-nav-selected-text-color,\n          var(--iress-a-active-contrast-color,\n              var(--iress-g-primary-contrast-color,\n                  var(--iress-default-primary-contrast-color\n  ))));--iress-nav-item-border-radius:var(--iress-menu-item-nav-border-radius,\n          var(--iress-item-border-radius\n  ))}.iress-combobox.sc-iress-menu-item-h,.iress-combobox .sc-iress-menu-item-h{--iress-menu-item-min-height:auto}.sc-iress-menu-item-h{display:block;background-color:var(--iress-background-color);transition:all var(--iress-transition-hover-duration) var(--iress-transition-hover-type)}.sc-iress-menu-item-h .iress-menu-item__button.iress-button.sc-iress-menu-item{--iress-font-family:var(--iress-button-font-family);--iress-font-size:var(--iress-button-font-size);--iress-font-weight:var(--iress-button-font-weight);--iress-background-color:transparent;--iress-hover-background-color:var(--iress-button-hover-background-color);--iress-active-background-color:var(--iress-button-active-background-color);--iress-text-color:var(--iress-button-text-color);--iress-hover-text-color:var(--iress-button-hover-text-color);--iress-active-text-color:var(--iress-button-active-text-color);--iress-border-width:0;--iress-border-color:transparent;--iress-border-radius:var(--iress-item-border-radius);--iress-hover-border-color:transparent;--iress-active-border-color:transparent;--iress-text-align:var(--iress-item-text-align);--iress-min-height:var(--iress-button-min-height);--iress-padding-x:var(--iress-button-padding-x);--iress-padding-y:var(--iress-button-padding-y);--iress-margin-right:0;--iress-focus-box-shadow:inset 0 0 0 var(--iress-focus-box-shadow-size) var(--iress-focus-color);white-space:pre-line;overflow:hidden}.sc-iress-menu-item-h .iress-button.sc-iress-menu-item-s>.iress-button__button:focus{z-index:1}.sc-iress-menu-item-h .iress-menu-item__button.iress-button.sc-iress-menu-item .iress-button__inner.sc-iress-menu-item{white-space:pre-line}.sc-iress-menu-item-h .iress-menu-item__header.sc-iress-menu-item{background-color:var(--iress-header-background-color);font-size:var(--iress-header-font-size);padding:var(--iress-header-padding-top) var(--iress-header-padding-x) var(--iress-header-padding-bottom);white-space:nowrap}.sc-iress-menu-item-h .iress-menu-item__header.sc-iress-menu-item .iress-text.sc-iress-menu-item{--iress-font-family:var(--iress-header-font-family);--iress-font-weight:var(--iress-header-font-weight);--iress-text-color:var(--iress-header-text-color);--iress-text-align:var(--iress-header-text-align)}.sc-iress-menu-item-h .iress-menu-item__header--slots.sc-iress-menu-item{display:flex;align-items:center}.sc-iress-menu-item-h .iress-menu-item__header--slots.sc-iress-menu-item-s>[slot=prepend]{display:inline-block;margin-inline-end:var(--iress-button-slot-margin-x, var(--iress-default-spacing-sm))}.sc-iress-menu-item-h .iress-menu-item__header--slots.sc-iress-menu-item-s>[slot=append]{display:inline-block;margin-inline-start:var(--iress-button-slot-margin-x, var(--iress-default-spacing-sm))}.sc-iress-menu-item-h .iress-menu-item__inner.sc-iress-menu-item{flex-grow:1;display:block}.iress-menu-item--selected.sc-iress-menu-item-h:not(.iress-menu-item--multi-select){position:relative}.iress-menu-item--selected.sc-iress-menu-item-h:not(.iress-menu-item--multi-select)::before{content:\"\";width:var(--iress-default-border-width--lg);position:absolute;z-index:2;inset-inline-start:var(--iress-g-focus-width, 2px);inset-block:var(--iress-g-focus-width, 2px);background-color:var(--iress-mark-color);transition:all var(--iress-transition-hover-duration) var(--iress-transition-hover-type)}.iress-menu--nav.sc-iress-menu-item-h .iress-menu-item__button.iress-button.sc-iress-menu-item,.iress-menu--nav .sc-iress-menu-item-h .iress-menu-item__button.iress-button.sc-iress-menu-item{--iress-text-align:var(--iress-nav-button-text-align)}.iress-menu--nav.iress-menu-item--selected.sc-iress-menu-item-h:not(.iress-menu-item--multi-select) .iress-menu-item__button.iress-button.sc-iress-menu-item,.iress-menu--nav .iress-menu-item--selected.sc-iress-menu-item-h:not(.iress-menu-item--multi-select) .iress-menu-item__button.iress-button.sc-iress-menu-item{--iress-background-color:var(--iress-nav-button-selected-background-color);--iress-text-color:var(--iress-nav-button-selected-text-color)}.iress-menu--nav.iress-menu-item--selected.sc-iress-menu-item-h:not(.iress-menu-item--multi-select)::before,.iress-menu--nav .iress-menu-item--selected.sc-iress-menu-item-h:not(.iress-menu-item--multi-select)::before{background-color:var(--iress-nav-mark-color)}.iress-menu-item--multi-select.sc-iress-menu-item-h .iress-checkbox__label.sc-iress-menu-item{display:inline-block;position:relative;min-width:var(--iress-size);height:var(--iress-size);margin-inline-end:var(--iress-checkbox-spacing)}.iress-menu-item--multi-select.sc-iress-menu-item-h::before{display:none}.iress-menu-item--divider.sc-iress-menu-item-h{border-block-end:var(--iress-divider-border-width) solid var(--iress-divider-border-color)}.iress-menu--inline.sc-iress-menu-item-h,.iress-menu--inline .sc-iress-menu-item-h{display:inline-block;--iress-header-padding-top:var(--iress-button-padding-y);--iress-header-padding-bottom:var(--iress-button-padding-y)}.iress-menu--inline-equal-width.sc-iress-menu-item-h,.iress-menu--inline-equal-width .sc-iress-menu-item-h{flex:1;text-align:center}.iress-menu--inline.iress-menu-item--divider.sc-iress-menu-item-h,.iress-menu--inline .iress-menu-item--divider.sc-iress-menu-item-h,.iress-menu--inline-equal-width.iress-menu-item--divider.sc-iress-menu-item-h,.iress-menu--inline-equal-width .iress-menu-item--divider.sc-iress-menu-item-h{border-block-end:none;border-inline-end:var(--iress-divider-border-width) solid var(--iress-divider-border-color)}.iress-menu--inline.iress-menu-item--selected.sc-iress-menu-item-h:not(.iress-menu-item--multi-select)::before,.iress-menu--inline .iress-menu-item--selected.sc-iress-menu-item-h:not(.iress-menu-item--multi-select)::before,.iress-menu--inline-equal-width.iress-menu-item--selected.sc-iress-menu-item-h:not(.iress-menu-item--multi-select)::before,.iress-menu--inline-equal-width .iress-menu-item--selected.sc-iress-menu-item-h:not(.iress-menu-item--multi-select)::before{width:calc(100% - var(--iress-g-focus-width, 2px) * 2);inset-block-start:auto;height:var(--iress-default-border-width--lg)}.iress-menu--inline.sc-iress-menu-item-h .iress-menu-item__button.sc-iress-menu-item,.iress-menu--inline .sc-iress-menu-item-h .iress-menu-item__button.sc-iress-menu-item,.iress-menu--inline-equal-width.sc-iress-menu-item-h .iress-menu-item__button.sc-iress-menu-item,.iress-menu--inline-equal-width .sc-iress-menu-item-h .iress-menu-item__button.sc-iress-menu-item{white-space:normal}";

let menuItemIds = 0;
const MenuItem = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.iressClick = createEvent(this, "iressClick", 7);
    /**
     * To be used when menu type is listbox
     */
    this.value = '';
    /**
     * Used to supply custom routing elements like react-router's <Link>. If true, only the default slot will be rendered.
     */
    this.customRoute = false;
    this.getButtonAttributes = (menuRole) => {
      const role = MenuItem.getRole(menuRole);
      const btnAttrs = { id: this.itemId };
      if (role === null) {
        btnAttrs['role'] =
          menuRole === MenuType.Listbox ? 'option' : 'menuitem';
        btnAttrs['tabindex'] = '-1';
      }
      if (this.value !== '') {
        btnAttrs['data-value'] = this.value;
        btnAttrs['aria-selected'] =
          this.selected === true ? 'true' : 'false';
      }
      if (this.href !== undefined) {
        btnAttrs['target'] = this.target;
        btnAttrs['rel'] = this.rel;
      }
      return btnAttrs;
    };
    this.getA11ySelected = (menuRole, selected = false) => {
      if (selected && menuRole === MenuType.List) {
        const inNav = this.el.closest('nav') !== null;
        if (inNav) {
          return { 'aria-current': 'page' };
        }
        else {
          return { 'aria-current': `${selected}` };
        }
      }
    };
    this.renderContents = () => {
      var _a;
      const noWrap = (_a = this.menu) === null || _a === void 0 ? void 0 : _a.getAttribute('no-wrap');
      const btnAttrs = this.getButtonAttributes(this.menuRole);
      const Button = `iress-button${this.suffix}`;
      const CheckboxMark = `iress-checkbox-mark${this.suffix}`;
      if (this.customRoute)
        return (h(Button, { "custom-route": true, class: MenuItemCssClass.Button, fluid: true }, h("slot", null)));
      if (this.headingLevel !== undefined)
        return (h(MenuItemHeader, { suffix: this.suffix, headingLevel: this.headingLevel, el: this.el, dataTestId: nativeTestid(this.el, 'menu-item') }));
      return (h(Button, { href: this.href, class: MenuItemCssClass.Button, mode: ButtonMode.Secondary, fluid: true, attrs: btnAttrs, "no-wrap": noWrap, "data-testid": nativeTestid(this.el, 'menu-item') }, this.renderPrependSlot(this.isMultiSelect, CheckboxMark), h("span", { class: MenuItemCssClass.Inner }, h("slot", null)), h("slot", { name: MenuItemSlot.IconOnly, slot: ButtonSlot.IconOnly }), h("slot", { name: MenuItemSlot.Append, slot: ButtonSlot.Append })));
    };
  }
  // /**
  //  * Emitted when the menu item is clicked.
  //  */
  //  @Event() iressKeyDown: EventEmitter<KeyboardEvent>;
  componentWillLoad() {
    var _a, _b;
    this.suffix = getSuffix(this.el, 'iress-menu-item');
    this.itemId = `iress-menu-item${this.suffix}-${menuItemIds++}`;
    this.menu = this.el.closest('.iress-menu');
    this.menuRole = (_a = this.menu) === null || _a === void 0 ? void 0 : _a.getAttribute('role');
    this.isMultiSelect = (_b = this.menu) === null || _b === void 0 ? void 0 : _b.hasAttribute('multi-select');
  }
  static getRole(menuRole) {
    if (menuRole === MenuType.Menu || menuRole === MenuType.Listbox)
      return null;
    return MenuItemRole.ListItem;
  }
  renderPrependSlot(isMultiSelect, CheckboxMark) {
    return isMultiSelect === true ? (h(CheckboxMark, { class: CheckboxCssClass.Label, checked: this.selected, slot: ButtonSlot.Prepend })) : (h("slot", { name: MenuItemSlot.Prepend, slot: ButtonSlot.Prepend }));
  }
  render() {
    return (h(Host, Object.assign({ class: {
        [MenuItemCssClass.Base]: true,
        [MenuItemCssClass.Divider]: this.divider === true,
        [MenuItemCssClass.Selected]: this.selected === true &&
          this.headingLevel === undefined,
        [MenuItemCssClass.MultiSelect]: this.isMultiSelect === true &&
          this.headingLevel === undefined,
      }, role: MenuItem.getRole(this.menuRole) }, this.getA11ySelected(this.menuRole, this.selected)), this.renderContents()));
  }
  get el() { return getElement(this); }
};
MenuItem.style = menuItemCss;

const menuCss = ".sc-iress-menu-h{max-width:100%}.sc-iress-menu-h.sc-iress-menu-s>.iress-menu-item[role=listitem]:last-child{margin-block-end:2px}.iress-menu--stack.sc-iress-menu-h,.iress-menu--inline.sc-iress-menu-h{display:inline-block}.iress-menu--fluid.sc-iress-menu-h,.sc-iress-menu-h.iress-menu--fluid.sc-iress-menu-s>[data-wrapper-children]{display:block;width:100%}.iress-menu--inline-equal-width.sc-iress-menu-h,.sc-iress-menu-h.iress-menu--inline-equal-width.sc-iress-menu-s>[data-wrapper-children]{display:flex}.iress-menu--inline.sc-iress-menu-h{display:inline-flex}.sc-iress-menu-h.iress-menu--inline.sc-iress-menu-s>.iress-menu-item[role=listitem]:last-child{margin-block-end:0px}.sc-iress-menu-h.sc-iress-menu-s>.iress-text{padding:var(--iress-g-spacing-xs) var(--iress-g-spacing-md)}";

const Menu = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.iressChange = createEvent(this, "iressChange", 7);
    this.iressMenuBlur = createEvent(this, "iressMenuBlur", 7);
    this.a11yAttrs = {};
    this.activeDescendant = null;
    /**
     * Set to `true` if menu is within a component that is controlling menu items
     */
    this.controlledMenuItems = false;
    /**
     * Selected values of Menu when type is Listbox
     */
    this.selected = [];
    /**
     * Layout of Menu, either `stack`, `inline` or `inline-equal-width`
     */
    this.layout = MenuLayout.Stack;
    /**
     * If set to true, change event will be fire with the correctly selected value
     */
    this.changeOnBlur = false;
    this.setFocusItems = () => {
      this.focusItems = this.el.querySelectorAll(`.${MenuItemCssClass.Base} button`);
    };
    this.setSelectedByValue = (value) => {
      this.focusItems.forEach((item) => {
        const menuItem = item.closest(`.${MenuItemCssClass.Base}`);
        if (item.getAttribute('data-value') === value) {
          menuItem.setAttribute('selected', '');
        }
        else {
          if (this.multiSelect !== true &&
            menuItem.hasAttribute('selected')) {
            menuItem.removeAttribute('selected');
          }
        }
      });
    };
    this.setInitialSelectedItems = () => {
      if (typeof this.selected !== 'string') {
        if (this.multiSelect === true) {
          this.selected.forEach((value) => {
            this.setSelectedByValue(value);
          });
        }
      }
      else {
        this.setSelectedByValue(this.selected);
      }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.getButtonValue = (buttonNode) => {
      var _a;
      const buttonValue = ((_a = buttonNode.querySelector('button')) === null || _a === void 0 ? void 0 : _a.dataset.value) || null;
      if (buttonValue !== null)
        return buttonValue;
      while ((buttonNode === null || buttonNode === void 0 ? void 0 : buttonNode.nodeName) !== 'BUTTON' &&
        !(buttonNode === null || buttonNode === void 0 ? void 0 : buttonNode.nodeName.includes('IRESS-MENU'))) {
        buttonNode = buttonNode.parentNode;
      }
      return buttonNode.nodeName === 'BUTTON'
        ? buttonNode.dataset.value
        : null;
    };
    this.clearSelectedItems = () => this.focusItems.forEach((item) => item
      .closest(`.${MenuItemCssClass.Base}`)
      .removeAttribute('selected'));
    this.updateSelectedMenuItems = (menuItemNode) => {
      if (this.multiSelect !== true) {
        this.clearSelectedItems();
      }
      while ((menuItemNode === null || menuItemNode === void 0 ? void 0 : menuItemNode.nodeName.includes('IRESS-MENU-ITEM')) !== true &&
        (menuItemNode === null || menuItemNode === void 0 ? void 0 : menuItemNode.nodeName) !== 'BODY') {
        menuItemNode = menuItemNode.parentNode;
      }
      if (menuItemNode.nodeName !== 'BODY') {
        menuItemNode.getAttribute('selected') === null
          ? menuItemNode.setAttribute('selected', '')
          : menuItemNode.removeAttribute('selected');
      }
    };
    this.updateSelected = (value) => {
      if (this.multiSelect !== true) {
        if (this.selected !== value)
          this.selected = value;
        this.iressChange.emit(this.selected);
      }
      else {
        this.selected =
          this.selected.indexOf(value) === -1
            ? [...this.selected, value]
            : [...this.selected].filter((val) => val !== value);
        this.iressChange.emit(this.selected);
      }
    };
    this.handleClick = (e) => {
      const eventPath = e.composedPath();
      const node = hasShadowDom(e.target)
        ? eventPath[0]
        : e.target; // eslint-disable-line
      if (this.a11yAttrs['role'] === MenuType.Listbox) {
        const value = this.getButtonValue(node);
        if (value !== null) {
          this.updateSelected(value);
          if (!this.controlledMenuItems) {
            this.updateSelectedMenuItems(node);
          }
        }
      }
    };
    this.shouldChangeOnBlur = () => this.role === MenuType.Listbox &&
      this.multiSelect !== true &&
      this.changeOnBlur === true;
    this.handleTabPress = (e) => {
      var _a;
      if (this.role === MenuType.Menu || this.role === MenuType.Listbox) {
        if (e.shiftKey) {
          this.el.removeAttribute('tabindex');
          setTimeout(() => this.el.setAttribute('tabindex', '0'), 150);
        }
        else {
          this.el.setAttribute('tabindex', '0');
          if (this.shouldChangeOnBlur()) {
            const value = (_a = this.el
              .querySelector(`#${this.activeDescendant}`)) === null || _a === void 0 ? void 0 : _a.getAttribute('data-value');
            this.updateSelected(value);
          }
          this.iressMenuBlur.emit();
        }
      }
    };
    this.handleKeydown = (e) => {
      if (e.key === 'Tab')
        return this.handleTabPress(e);
      const currentIndex = this.getCurrentFocusIndex();
      if (currentIndex < 0 || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp'))
        return;
      e.preventDefault();
      const newIndex = e.key === 'ArrowDown'
        ? this.handleArrowDownKey(e, currentIndex)
        : this.handleArrowUpKey(e, currentIndex);
      if (newIndex > -1) {
        this.focusOnButtonByIndex(newIndex);
        this.el.removeAttribute('tabindex');
      }
    };
    this.handleIressBlur = (e) => {
      if (this.type === MenuType.Listbox ||
        this.type === MenuType.Menu ||
        this.multiSelect)
        e.stopPropagation();
    };
    this.handleMenuFocus = () => this.focusOnButtonByIndex(0);
  }
  // type can be dynamically changed by popover
  typeHandler() {
    this.setA11yAttrs();
    this.initialSetUp();
  }
  connectedCallback() {
    if (typeof this.selected === 'string' && this.multiSelect === true)
      this.selected = JSON.parse(this.selected);
    if (this.multiSelect === true)
      this.type = MenuType.Listbox;
  }
  componentDidLoad() {
    this.initialSetUp();
  }
  componentWillUpdate() {
    this.setFocusItems();
    if (typeof this.selected === 'string' && this.multiSelect === true)
      this.selected = JSON.parse(this.selected);
    if (!this.controlledMenuItems) {
      this.el
        .querySelectorAll(`.${MenuItemCssClass.Base}`)
        .forEach((menuItem) => {
        const itemVal = menuItem.getAttribute('value');
        const itemSel = typeof this.selected === 'string'
          ? itemVal === this.selected
          : this.selected.includes(itemVal);
        itemSel
          ? menuItem.setAttribute('selected', '')
          : menuItem.removeAttribute('selected');
      });
    }
  }
  /**
   * returns value of menu item that has been clicked. Expects a click event for a button within an menu item.
   */
  async getClickedMenuItemValue(e, eventPath) {
    const node = hasShadowDom(e.target)
      ? eventPath[0]
      : e.target; // eslint-disable-line
    return this.getButtonValue(node);
  }
  initialSetUp() {
    if (this.hasArrowKeyNav) {
      this.setFocusItems();
      if (this.a11yAttrs['role'] === MenuType.Listbox) {
        this.setInitialSelectedItems();
      }
    }
  }
  getRole() {
    var _a;
    if (this.multiSelect)
      return MenuType.Listbox;
    if (this.type === MenuType.Nav)
      return MenuType.List;
    const popoverType = (_a = this.el
      .closest('.iress-popover')) === null || _a === void 0 ? void 0 : _a.getAttribute('type');
    if (popoverType !== null) {
      if (popoverType === PopoverType.Listbox)
        return MenuType.Listbox;
      if (popoverType === PopoverType.Menu)
        return MenuType.Menu;
    }
    return this.type || MenuType.List;
  }
  getCurrentFocusIndex() {
    let focusIndex = -1;
    const activeEle = getActiveElement();
    this.focusItems.forEach((item, i) => {
      if (item === activeEle)
        focusIndex = i;
    });
    return focusIndex;
  }
  handleArrowUpKey(e, currentIndex) {
    if (this.role === MenuType.Listbox) {
      if (currentIndex < 1)
        return currentIndex;
      // stops propagation for every Up keypress except for when on first item
      e.stopPropagation();
      return currentIndex - 1;
    }
    return currentIndex < 1 ? this.focusItems.length - 1 : currentIndex - 1;
  }
  handleArrowDownKey(e, currentIndex) {
    e.stopPropagation();
    if (this.role === MenuType.Listbox)
      return currentIndex === this.focusItems.length - 1
        ? currentIndex
        : currentIndex + 1;
    return currentIndex === this.focusItems.length - 1
      ? 0
      : currentIndex + 1;
  }
  focusOnButtonByIndex(index) {
    this.focusItems = this.el.querySelectorAll('.iress-menu-item button');
    if (this.focusItems.length < 1)
      return;
    const button = this.focusItems[index];
    if (button !== null && button !== undefined) {
      button.focus();
      this.activeDescendant = button.id;
    }
  }
  setA11yAttrs() {
    this.role = this.getRole();
    this.a11yAttrs['role'] = this.role;
    if (this.role === MenuType.Listbox || this.role === MenuType.Menu) {
      this.hasArrowKeyNav = true;
      this.a11yAttrs['tabindex'] = '0';
    }
    if (this.role === MenuType.Listbox && this.multiSelect === true) {
      this.a11yAttrs['aria-multiselectable'] = 'true';
    }
  }
  render() {
    this.setA11yAttrs();
    return (h(Host, Object.assign({ class: {
        [MenuCssClass.Base]: true,
        [MenuCssClass.Fluid]: this.fluid === true,
        [`${MenuCssClass.Base}--${this.layout}`]: true,
        [`${MenuCssClass.Base}--${MenuType.Nav}`]: this.type === MenuType.Nav,
      } }, this.a11yAttrs, { "aria-activedescendant": this.activeDescendant, onFocus: this.hasArrowKeyNav && this.handleMenuFocus, onKeyDown: this.hasArrowKeyNav && this.handleKeydown, onIressBlur: this.hasArrowKeyNav && this.handleIressBlur, onClick: this.hasArrowKeyNav && this.handleClick }), h("slot", null)));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "type": ["typeHandler"]
  }; }
};
Menu.style = menuCss;

var CardCssClass;
(function (CardCssClass) {
  CardCssClass["Base"] = "iress-card";
  CardCssClass["Card"] = "iress-card__card";
  CardCssClass["Wrapper"] = "iress-card__wrapper";
  CardCssClass["Prepend"] = "iress-card__prepend";
  CardCssClass["TopRight"] = "iress-card__top-right";
  CardCssClass["TopRightButton"] = "iress-card__top-right--button";
  CardCssClass["Supplemental"] = "iress-card__supplemental";
  CardCssClass["Footer"] = "iress-card__footer";
  CardCssClass["Header"] = "iress-card__header";
  CardCssClass["HeaderWrapper"] = "iress-card__header-wrapper";
  CardCssClass["Content"] = "iress-card__content";
  CardCssClass["Body"] = "iress-card__body";
  CardCssClass["Heading"] = "iress-card__heading";
  CardCssClass["Link"] = "iress-card__link";
  CardCssClass["Button"] = "iress-card__button";
  CardCssClass["SupplementalFirst"] = "iress-card--supplemental-first";
  CardCssClass["Stretch"] = "iress-card--stretch";
  CardCssClass["Clickable"] = "iress-card--clickable";
  CardCssClass["HasHeading"] = "iress-card--has-heading";
  CardCssClass["HasPrepend"] = "iress-card--has-prepend";
  CardCssClass["HasSupplemental"] = "iress-card--has-supplemental";
  CardCssClass["HasSlots"] = "iress-card--has-slots";
  CardCssClass["Selected"] = "iress-card--selected";
})(CardCssClass || (CardCssClass = {}));
var CardSlot;
(function (CardSlot) {
  CardSlot["Footer"] = "footer";
  CardSlot["Header"] = "header";
  CardSlot["Prepend"] = "prepend";
  CardSlot["TopRight"] = "top-right";
  CardSlot["Supplemental"] = "supplemental";
})(CardSlot || (CardSlot = {}));

const cardCss = ".sc-iress-card-h{--iress-font-family:var(--iress-card-font-family, var(--iress-g-font-family, inherit));--iress-font-size:var(--iress-card-font-size, inherit);--iress-font-weight:var(--iress-card-font-weight, var(--iress-g-font-weight, normal));--iress-padding-unit-sm:var(--iress-card-sm-padding, var(--iress-g-spacing-sm));--iress-padding-unit-md:var(--iress-card-md-padding, var(--iress-g-spacing-md));--iress-padding-unit-lg:var(--iress-card-lg-padding, var(--iress-g-spacing-lg));--iress-padding-unit-half:calc(var(--iress-padding-unit) / 2);--iress-background-color:var(--iress-card-background-color,\n          var(--iress-a-layout-background-color,\n              var(--iress-g-background-color,\n                  var(--iress-default-background-color\n  ))));--iress-clickable-background-color:var(--iress-card-clickable-background-color, var(--iress-background-color));--iress-box-shadow-color:var(--iress-card-box-shadow-color,\n          var(--iress-g-box-shadow-color,\n              var(--iress-default-box-shadow-color\n  )));--iress-clickable-box-shadow:var(--iress-card-clickable-box-shadow-size, 0 0) var(--iress-box-shadow-color);--iress-clickable-hover-box-shadow:var(--iress-card-clickable-hover-box-shadow-size, 0 0) var(--iress-box-shadow-color);--iress-clickable-hover-background-color:var(--iress-card-clickable-hover-background-color,\n          var(--iress-card-background-color,\n              var(--iress-a-layout-hover-background-color,\n                  var(--iress-g-hover-background-color,\n                      var(--iress-default-hover-background-color\n  )))));--iress-text-color:var(--iress-card-text-color, inherit);--iress-border-radius:var(--iress-card-border-radius,\n          var(--iress-g-border-radius,\n              var(--iress-default-border-radius\n  )));--iress-border-color:var(--iress-card-border-color, transparent);--iress-clickable-border-color:var(--iress-card-clickable-border-color, var(--iress-border-color));--iress-border-width:var(--iress-card-border-width, var(--iress-g-border-width, var(--iress-default-border-width)));--iress-border:var(--iress-border-width) solid var(--iress-border-color);--iress-box-shadow:var(--iress-card-box-shadow-size, 0 0) var(--iress-box-shadow-color);--iress-transition-duration:var(--iress-card-transition-hover-duration, var(--iress-g-transition-hover-duration, 0.2s));--iress-transition-type:var(--iress-card-transition-hover-type, var(--iress-g-transition-hover-type, ease-in-out));--iress-transition:all var(--iress-transition-duration) var(--iress-transition-type);--iress-text-align:start;--iress-focus-width:var(--iress-g-focus-width, 2px);--iress-focus-indicator:0 0 0 var(--iress-focus-width) var(--iress-focus-color);--iress-line-height:var(--iress-card-line-height, var(--iress-g-line-height, 1.5));--iress-top-right-padding:var(--iress-padding-unit) var(--iress-padding-unit) var(--iress-padding-unit-half) var(--iress-padding-unit-half);--iress-top-right-padding-button:0;--iress-top-right-border-color:var(--iress-card-top-right-border-color, transparent);--iress-top-right-hover-border-color:var(--iress-card-top-right-hover-border-color, transparent);--iress-heading-padding:0 0 var(--iress-padding-unit-half);--iress-heading-padding-slots:var(--iress-padding-unit) var(--iress-padding-unit) var(--iress-padding-unit-half);--iress-supplemental-padding:0;--iress-footer-padding:var(--iress-padding-unit);--iress-footer-border-width:var(--iress-card-footer-border-width, 1px);--iress-footer-border-color:var(--iress-card-footer-border-color,\n          var(--iress-g-border-color,\n              var(--iress-default-border-color\n  )));--iress-footer-border:var(--iress-footer-border-width) solid var(--iress-footer-border-color);--iress-prepend-icon-color:var(--iress-card-prepend-icon-color, inherit);--iress-prepend-icon-font-size-default:var(--iress-card-prepend-icon-default-font-size, inherit)}.iress-card--padding-none.sc-iress-card-h{--iress-padding-unit:0}.iress-card--padding-sm.sc-iress-card-h{--iress-padding-unit:var(--iress-padding-unit-sm)}.iress-card--padding-md.sc-iress-card-h{--iress-padding-unit:var(--iress-padding-unit-md)}.iress-card--padding-lg.sc-iress-card-h{--iress-padding-unit:var(--iress-padding-unit-lg)}.iress-card--clickable.sc-iress-card-h{--iress-box-shadow:var(--iress-clickable-box-shadow, none);--iress-focus-width:calc(var(--iress-g-focus-width, 2px) + var(--iress-border-width))}.iress-card--selected.sc-iress-card-h{--iress-border-color:var(--iress-card-selected-border-color,\n          var(--iress-a-active-border-color,\n              var(--iress-g-primary-color,\n                  var(--iress-default-form-border-color\n  ))));--iress-border:var(--iress-border-width) solid var(--iress-border-color)}.sc-iress-card-h{--top-right-button-border-radius:var(--iress-border-radius);--top-right-button-border-color:var(--iress-top-right-border-color);--top-right-button-hover-border-color:var(--iress-top-right-hover-border-color);display:block;border-radius:var(--iress-border-radius);border:var(--iress-border);position:relative}.sc-iress-card-h .iress-card__card.sc-iress-card{font-family:var(--iress-font-family);font-size:var(--iress-font-size);font-weight:var(--iress-font-weight);line-height:var(--iress-line-height);min-height:var(--iress-min-height);background-color:var(--iress-background-color);border-radius:calc(var(--iress-border-radius) - var(--iress-border-width));color:var(--iress-text-color);transition:var(--iress-transition);box-shadow:var(--iress-box-shadow);text-align:var(--iress-text-align);padding:var(--iress-padding-unit);position:relative;width:100%;align-items:normal}.iress-card--stretch.sc-iress-card-h{flex-grow:1;display:flex}.iress-card--stretch.sc-iress-card-h .iress-card__card.sc-iress-card{display:flex;flex-direction:column}.iress-card--stretch.sc-iress-card-h .iress-card__card.sc-iress-card .iress-card__wrapper.sc-iress-card{flex-grow:1;display:flex}.iress-card--stretch.sc-iress-card-h .iress-card__card.sc-iress-card .iress-card__content.sc-iress-card,.iress-card--stretch.sc-iress-card-h .iress-card__card.sc-iress-card .iress-card__body.sc-iress-card,.sc-iress-card-h.iress-card--stretch .iress-card__card .iress-card__body.sc-iress-card-s>[data-wrapper-children]{flex-grow:1;display:flex;flex-direction:column}.iress-card--stretch.sc-iress-card-h .iress-card__card.sc-iress-card .iress-card__footer.sc-iress-card{flex-grow:0}.sc-iress-card-h.iress-card--stretch .iress-card__card .sc-iress-card-s .iress-panel--stretch{--iress-height:auto;flex-grow:1}.iress-card--clickable.sc-iress-card-h{border:none;padding:var(--iress-border-width)}.iress-card--clickable.sc-iress-card-h::after{content:\"\";position:absolute;inset:0;border-color:var(--iress-border-color);border-style:solid;border-width:var(--iress-border-width);border-radius:var(--iress-border-radius);pointer-events:none}.iress-card--clickable.sc-iress-card-h .iress-card__card.sc-iress-card{border:none;background-color:var(--iress-clickable-background-color);box-shadow:var(--iress-clickable-box-shadow);margin:0}.iress-card--clickable.sc-iress-card-h a.iress-card__card.sc-iress-card{display:inline-block;text-decoration:none}@media (hover: hover){.iress-card--clickable.sc-iress-card-h .iress-card__card.sc-iress-card:hover{box-shadow:var(--iress-clickable-hover-box-shadow);background-color:var(--iress-clickable-hover-background-color);cursor:pointer}}.iress-card--clickable.iress-card--vrt-hover.sc-iress-card-h .iress-card__card.sc-iress-card{box-shadow:var(--iress-clickable-hover-box-shadow);background-color:var(--iress-clickable-hover-background-color);cursor:pointer}.iress-card--clickable.sc-iress-card-h .iress-card__card.sc-iress-card:active,.iress-card--clickable.iress-card--vrt-active.sc-iress-card-h .iress-card__card.sc-iress-card{box-shadow:var(--iress-box-shadow)}.iress-card--clickable.sc-iress-card-h .iress-card__card.sc-iress-card:focus-within,.iress-card--clickable.iress-card--vrt-focus.sc-iress-card-h .iress-card__card.sc-iress-card{box-shadow:var(--iress-focus-indicator, var(--iress-hover-box-shadow))}.iress-card--has-slots.sc-iress-card-h .iress-card__wrapper.sc-iress-card{display:flex;align-items:stretch;flex-grow:1}.iress-card--has-slots.sc-iress-card-h .iress-card__card.sc-iress-card{display:flex;flex-direction:column;flex-grow:1;padding:0}.iress-card--has-slots.sc-iress-card-h .iress-card__body.sc-iress-card{padding:var(--iress-padding-unit)}.iress-card--has-slots.iress-card--has-heading.sc-iress-card-h:not(.iress-card--has-supplemental) .iress-card__body.sc-iress-card{padding-block-start:0}.sc-iress-card-h .iress-card__top-right.sc-iress-card{padding:var(--iress-top-right-padding);float:right;float:inline-end}[dir=rtl].sc-iress-card-h .iress-card__top-right.sc-iress-card,[dir=rtl] .sc-iress-card-h .iress-card__top-right.sc-iress-card{float:left;float:inline-end}.sc-iress-card-h .iress-card__top-right.iress-card__top-right--button.sc-iress-card{padding:var(--iress-top-right-padding-button)}.sc-iress-card-h .iress-card__top-right--button.sc-iress-card-s>.iress-button,.sc-iress-card-h .iress-card__top-right--button.sc-iress-card-s>[data-wrapper-children]>.iress-button,.sc-iress-card-h .iress-card__top-right--button.sc-iress-card-s>.iress-popover .iress-popover__activator>.iress-button,.sc-iress-card-h .iress-card__top-right--button.sc-iress-card-s>[data-wrapper-children] .iress-popover__activator>.iress-button{--iress-border-radius:var(--top-right-button-border-radius);--iress-border-color:var(--top-right-button-border-color);--iress-hover-border-color:var(--top-right-button-hover-border-color)}.sc-iress-card-h .iress-card__top-right--button.sc-iress-card-s>.iress-button .iress-button__button,.sc-iress-card-h .iress-card__top-right--button.sc-iress-card-s>[data-wrapper-children]>.iress-button .iress-button__button,.sc-iress-card-h .iress-card__top-right--button.sc-iress-card-s>.iress-popover .iress-popover__activator>.iress-button .iress-button__button,.sc-iress-card-h .iress-card__top-right--button.sc-iress-card-s>[data-wrapper-children] .iress-popover__activator>.iress-button .iress-button__button{padding-inline-start:var(--iress-button-padding-x, var(--iress-g-spacing-sm));padding-inline-end:var(--iress-button-padding-x, var(--iress-g-spacing-sm))}.sc-iress-card-h .iress-card__top-right--button.sc-iress-card-s>.iress-button .iress-button__button:focus:focus-visible,.sc-iress-card-h .iress-card__top-right--button.sc-iress-card-s>[data-wrapper-children]>.iress-button .iress-button__button:focus:focus-visible,.sc-iress-card-h .iress-card__top-right--button.sc-iress-card-s>.iress-popover .iress-popover__activator>.iress-button .iress-button__button:focus:focus-visible,.sc-iress-card-h .iress-card__top-right--button.sc-iress-card-s>[data-wrapper-children] .iress-popover__activator>.iress-button .iress-button__button:focus:focus-visible{box-shadow:var(--iress-inset-focus-box-shadow)}.sc-iress-card-h .iress-card__top-right--button.sc-iress-card-s>.iress-button .iress-button__inner,.sc-iress-card-h .iress-card__top-right--button.sc-iress-card-s>[data-wrapper-children]>.iress-button .iress-button__inner,.sc-iress-card-h .iress-card__top-right--button.sc-iress-card-s>.iress-popover .iress-popover__activator>.iress-button .iress-button__inner,.sc-iress-card-h .iress-card__top-right--button.sc-iress-card-s>[data-wrapper-children]>.iress-popover>.iress-button .iress-button__inner{min-width:var(--iress-g-spacing-rem)}.iress-card--has-slots.sc-iress-card-h .iress-card__header.sc-iress-card{display:flex}.sc-iress-card-h .iress-card__heading.sc-iress-card{padding:var(--iress-heading-padding)}.iress-card--has-slots.sc-iress-card-h .iress-card__heading.sc-iress-card{padding:var(--iress-heading-padding-slots);flex-grow:1}.sc-iress-card-h:not(.iress-card--supplemental-first) .iress-card__header.sc-iress-card .iress-card__top-right.sc-iress-card{position:relative}.iress-card--supplemental-first.sc-iress-card-h .iress-card__header-wrapper.sc-iress-card{display:flex;flex-direction:column-reverse}.iress-card--supplemental-first.sc-iress-card-h .iress-card__top-right.sc-iress-card,.iress-card--has-supplemental.sc-iress-card-h:not(.iress-card--has-heading) .iress-card__top-right.sc-iress-card{position:absolute;inset-block-start:0;inset-inline-end:0}.iress-card--has-slots.iress-card--supplemental-first.sc-iress-card-h .iress-card__heading.sc-iress-card{padding-block-end:var(--iress-padding-unit-half);padding-block-start:0}.iress-card--has-heading.sc-iress-card-h .iress-card__supplemental.sc-iress-card{padding-block-start:var(--iress-padding-unit-half)}.iress-card--supplemental-first.sc-iress-card-h .iress-card__supplemental.sc-iress-card{padding-block-end:var(--iress-padding-unit);padding-block-start:0;border-start-start-radius:var(--iress-border-radius);border-start-end-radius:var(--iress-border-radius);overflow:hidden}.sc-iress-card-h.iress-card--supplemental-first .iress-card__supplemental.sc-iress-card-s>*{border-radius:0}.iress-card--has-slots.iress-card--supplemental-first.iress-card--has-heading.sc-iress-card-h .iress-card__body.sc-iress-card{padding-block-start:0}.sc-iress-card-h .iress-card__supplemental.sc-iress-card{padding:var(--iress-supplemental-padding)}.sc-iress-card-h .iress-card__supplemental.sc-iress-card-s>img,.sc-iress-card-h .iress-card__supplemental.sc-iress-card-s>.iress-skeleton{display:block;width:100%;height:auto;max-width:100%}.sc-iress-card-h .iress-card__content.sc-iress-card{width:100%}.sc-iress-card-h .iress-card__footer.sc-iress-card{padding:var(--iress-footer-padding);border-block-start:var(--iress-footer-border)}.sc-iress-card-h .iress-card__prepend.sc-iress-card{padding:var(--iress-padding-unit)}.sc-iress-card-h .iress-card__prepend.sc-iress-card-s>.iress-icon{color:var(--iress-prepend-icon-color)}.sc-iress-card-h .iress-card__prepend.sc-iress-card-s>.iress-icon:not([size]){font-size:var(--iress-prepend-icon-font-size--default);line-height:1}.iress-card--has-supplemental.iress-card--supplemental-first.sc-iress-card-h .iress-card__prepend.sc-iress-card{padding-inline-end:var(--iress-padding-unit)}.iress-card--has-prepend.sc-iress-card-h .iress-card__heading.sc-iress-card,.iress-card--has-prepend.sc-iress-card-h .iress-card__body.sc-iress-card{padding-inline-start:0}.iress-card--clickable.sc-iress-card-h .iress-card__link.sc-iress-card,.sc-iress-card-h .iress-card__button.sc-iress-card,.sc-iress-card-h .iress-card__heading.sc-iress-card-s .iress-card__button{all:inherit;color:var(--iress-card-heading-link-text-color, var(--iress-g-link-text-color, var(--iress-default-link-color)));text-decoration:underline;transition:color var(--iress-transition-duration) var(--iress-transition-type);display:inline-block}@media (hover: hover){.sc-iress-card-h .iress-card__button.sc-iress-card:hover,.sc-iress-card-h .iress-card__heading.sc-iress-card-s .iress-card__button:hover{text-decoration:none;cursor:pointer}}.sc-iress-card-h .iress-card__button.sc-iress-card:active,.sc-iress-card-h .iress-card__button.sc-iress-card:focus,.sc-iress-card-h .iress-card__heading.sc-iress-card-s .iress-card__button:active,.sc-iress-card-h .iress-card__heading.sc-iress-card-s .iress-card__button:focus{color:var(--iress-card-heading-link-active-text-color, var(--iress-a-link-active-text-color, var(--iress-g-link-text-color, var(--iress-default-link-color))));text-decoration:none;cursor:pointer}.sc-iress-card-h .iress-card__button.sc-iress-card:focus,.sc-iress-card-h .iress-card__card.sc-iress-card:focus,.sc-iress-card-h .iress-card__heading.sc-iress-card-s .iress-card__button:focus{box-shadow:var(--iress-focus-indicator);outline:none}.iress-card--clickable.sc-iress-card-h .iress-card__button.sc-iress-card,.iress-card--clickable.sc-iress-card-h .iress-card__link.sc-iress-card,.sc-iress-card-h.iress-card--clickable .iress-card__heading.sc-iress-card-s .iress-card__button,.sc-iress-card-h.iress-card--clickable .iress-card__heading.sc-iress-card-s .iress-card__link{text-decoration:none}@media (hover: hover){.iress-card--clickable.sc-iress-card-h .iress-card__card.sc-iress-card:hover .iress-card__link.sc-iress-card,.iress-card--clickable.sc-iress-card-h .iress-card__card.sc-iress-card:hover .iress-card__button.sc-iress-card,.sc-iress-card-h.iress-card--clickable .iress-card__card:hover .iress-card__heading.sc-iress-card-s .iress-card__button,.sc-iress-card-h.iress-card--clickable .iress-card__card:hover .iress-card__heading.sc-iress-card-s .iress-card__link{color:var(--iress-card-heading-link-hover-text-color, var(--iress-a-link-hover-text-color, var(--iress-g-link-text-color, var(--iress-default-link-color))));box-shadow:none}}.iress-card--clickable.sc-iress-card-h .iress-card__card.sc-iress-card:focus-within .iress-card__link.sc-iress-card,.iress-card--clickable.sc-iress-card-h .iress-card__card.sc-iress-card:focus-within .iress-card__button.sc-iress-card,.sc-iress-card-h.iress-card--clickable .iress-card__heading.sc-iress-card-s .iress-card__button:focus,.sc-iress-card-h.iress-card--clickable .iress-card__heading.sc-iress-card-s .iress-card__link:focus{color:var(--iress-a-link-hover-text-color, var(--iress-g-link-text-color, var(--iress-default-link-color)));box-shadow:none}.sc-iress-card-h .iress-card__body.sc-iress-card-s>*:last-child,.sc-iress-card-h .iress-card__body.sc-iress-card-s>.iress-text:last-child *:last-child,.sc-iress-card-h .iress-card__body.sc-iress-card-s>[data-wrapper-children]>.iress-text:last-child>*:last-child{margin-block-end:0}.iress-card--clickable.iress-card--selected.sc-iress-card-h .iress-card__card.sc-iress-card:focus{border-color:var(--iress-g-focus-color)}.iress-card--selected.sc-iress-card-h{border:none;padding:var(--iress-border-width)}.iress-card--selected.sc-iress-card-h::after{content:\"\";position:absolute;inset:0;border-color:var(--iress-border-color);border-style:solid;border-width:calc(var(--iress-border-width) + 2px);border-radius:var(--iress-border-radius);pointer-events:none}";

const Card = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.iressCardClick = createEvent(this, "iressCardClick", 7);
    this.hasPrependSlotContent = false;
    this.hasHeaderSlotContent = false;
    this.hasTopRightSlotContent = false;
    this.hasSupplementalSlotContent = false;
    this.hasFooterSlotContent = false;
    this.hasClickableChildren = false;
    this.hasHeading = false;
    this.hasHeaderContent = false;
    this.isClickable = false;
    this.clickableButtonCard = false;
    this.clickableLinkCard = false;
    this.clickableHeaderCard = false;
    this.clickableHeaderSlotCard = false;
    /**
     * Sets the amount of padding for card. Inherits values from iress-panel
     */
    this.padding = PaddingSize.Md;
    /**
     * When set to true, Card stretches to fill available height
     */
    this.stretch = false;
    /**
     * Enables card onClick event on the heading. To be used with the click event and heading props
     */
    this.button = false;
    /**
     * Enables card clickability, the card will appear focusable and clickable, although the actual focus / click will be on the heading. To be used with the `href` / `button` props and heading props
     */
    this.clickable = false;
    /**
     * When set to true, the supplementary slot will (visually) be displayed first (using flexbox, not changing source order)
     */
    this.supplementalFirst = false;
    this.setHeaderVars = () => {
      this.hasHeading = validateHeadingProps(this.headingText, this.headingLevel, 'IressCard');
      this.hasHeaderContent =
        this.hasHeading ||
          this.hasHeaderSlotContent ||
          this.hasTopRightSlotContent ||
          this.hasSupplementalSlotContent;
    };
    this.checkClickableChildren = () => {
      const hasLinks = this.el.querySelectorAll(`a:not(.${CardCssClass.Link})`).length > 0;
      const hasButtons = this.el.querySelectorAll(`button:not(.${CardCssClass.Card}):not(.${CardCssClass.Button})`).length > 0;
      const hasIressButtons = this.el.querySelectorAll(`${ButtonCssClass.Base}`).length > 0;
      this.hasClickableChildren = hasLinks || hasButtons || hasIressButtons;
    };
    this.setClickableVars = (hasNoHeadingOrHeaderSlotContent) => {
      const clickablePropSetAndNoClickableChildren = this.clickable && !this.hasClickableChildren;
      this.clickableHeaderCard =
        (this.href !== undefined || this.button) &&
          this.hasHeading &&
          clickablePropSetAndNoClickableChildren;
      this.clickableHeaderSlotCard =
        this.hasHeaderSlotContent && clickablePropSetAndNoClickableChildren;
      this.clickableButtonCard =
        this.button &&
          clickablePropSetAndNoClickableChildren &&
          hasNoHeadingOrHeaderSlotContent;
      this.clickableLinkCard =
        this.href !== undefined &&
          clickablePropSetAndNoClickableChildren &&
          hasNoHeadingOrHeaderSlotContent;
    };
    this.checkHeadingPropsAreSetCorrectly = () => {
      const headingTextButNoLevel = this.headingText !== undefined && this.headingLevel === undefined;
      const headingLevelButNoText = this.headingText === undefined && this.headingLevel !== undefined;
      if (headingTextButNoLevel || headingLevelButNoText)
        idsLogger('Both headingLevel and headingText must be provided if you want to show a header on a card', LoggerLevels.Warn);
      if (this.hasHeading && this.hasHeaderSlotContent)
        idsLogger(`You've supplied header text and header slot content. Only the header slot content will be rendered`, LoggerLevels.Warn);
    };
    this.hasHeadingOrHeaderSlot = () => this.hasHeading || this.hasHeaderSlotContent;
    this.hasNamedSlotContent = () => this.hasPrependSlotContent ||
      this.hasTopRightSlotContent ||
      this.hasSupplementalSlotContent ||
      this.hasHeaderSlotContent ||
      this.hasFooterSlotContent;
    this.onClick = (e) => {
      this.iressCardClick.emit(e);
    };
    this.renderHeading = () => {
      const Text = `iress-text${this.suffix}`;
      return !this.hasHeaderSlotContent ? (h(Text, { class: CardCssClass.Heading, element: this.headingLevel }, this.href !== undefined ? (h("a", { href: this.href, class: CardCssClass.Link }, this.headingText)) : this.button ? (h("button", { class: CardCssClass.Button, onClick: this.onClick }, this.headingText)) : (this.headingText))) : null;
    };
    this.renderTopRightSlot = () => {
      const Button = `iress-button${this.suffix}`;
      const hasTopRightButton = this.el.querySelectorAll(`[slot="${CardSlot.TopRight}"] ${Button}, ${Button}[slot="${CardSlot.TopRight}"]`).length > 0;
      return this.hasTopRightSlotContent ? (h("div", { class: {
          [CardCssClass.TopRight]: true,
          [CardCssClass.TopRightButton]: hasTopRightButton,
        } }, h("slot", { name: CardSlot.TopRight }))) : null;
    };
    this.renderHeaderSlot = () => this.hasHeaderSlotContent ? (h("div", { class: CardCssClass.Heading }, h("slot", { name: CardSlot.Header }))) : null;
    this.setCardAttributes = () => this.clickableButtonCard
      ? { onClick: this.onClick, type: 'button' }
      : this.clickableLinkCard
        ? { href: this.href }
        : null;
    this.setCardTagType = () => this.clickableButtonCard
      ? 'button'
      : this.clickableLinkCard
        ? 'a'
        : 'article';
    this.getHeaderContent = () => (h("div", { class: CardCssClass.HeaderWrapper }, this.hasHeading || this.hasHeaderSlotContent ? (h("div", { class: CardCssClass.Header }, this.renderHeading(), this.renderHeaderSlot(), this.renderTopRightSlot())) : (this.renderTopRightSlot()), this.hasSupplementalSlotContent ? (h("div", { class: CardCssClass.Supplemental }, h("slot", { name: CardSlot.Supplemental }))) : null));
    this.getHostCssClassMap = () => ({
      [CardCssClass.Base]: true,
      [`${CardCssClass.Base}--padding-${this.padding}`]: true,
      [CardCssClass.HasSupplemental]: this.hasSupplementalSlotContent,
      [CardCssClass.SupplementalFirst]: this.supplementalFirst,
      [CardCssClass.Stretch]: this.stretch,
      [CardCssClass.Clickable]: this.isClickable,
      [CardCssClass.HasHeading]: this.hasHeadingOrHeaderSlot(),
      [CardCssClass.HasPrepend]: this.hasPrependSlotContent,
      [CardCssClass.HasSlots]: this.hasNamedSlotContent(),
      [CardCssClass.Selected]: this.selected === true,
    });
  }
  componentWillLoad() {
    this.suffix = getSuffix(this.el, 'iress-card');
    this.hasPrependSlotContent = hasSlotContent(CardSlot.Prepend, this.el);
    this.hasTopRightSlotContent = hasSlotContent(CardSlot.TopRight, this.el);
    this.hasSupplementalSlotContent = hasSlotContent(CardSlot.Supplemental, this.el);
    this.hasFooterSlotContent = hasSlotContent(CardSlot.Footer, this.el);
    this.hasHeaderSlotContent = hasSlotContent(CardSlot.Header, this.el);
    if (this.hasHeaderSlotContent) {
      const headerSlot = this.el.querySelector(`[slot=${CardSlot.Header}]`);
      if (headerSlot !== undefined) {
        const slottedLink = headerSlot.tagName === 'A'
          ? headerSlot
          : headerSlot.querySelector('a');
        slottedLink === null || slottedLink === void 0 ? void 0 : slottedLink.classList.add(`${CardCssClass.Link}`);
        const slottedButton = headerSlot.tagName === 'BUTTON'
          ? headerSlot
          : headerSlot.querySelector('button');
        slottedButton === null || slottedButton === void 0 ? void 0 : slottedButton.classList.add(`${CardCssClass.Button}`);
      }
    }
  }
  componentWillRender() {
    // Heading checks
    this.setHeaderVars();
    this.checkHeadingPropsAreSetCorrectly();
    // Clickable checks
    this.checkClickableChildren();
    const hasNoHeadingOrHeaderSlotContent = !this.hasHeaderSlotContent && !this.hasHeading;
    this.setClickableVars(hasNoHeadingOrHeaderSlotContent);
    this.isClickable =
      this.clickableHeaderCard ||
        this.clickableHeaderSlotCard ||
        this.clickableLinkCard ||
        this.clickableButtonCard;
  }
  // eslint-disable-next-line
  cardClick(e) {
    if (this.clickableHeaderCard || this.clickableHeaderSlotCard) {
      const clickTarget = this.el.querySelector(`.${CardCssClass.Header} a`) ||
        this.el.querySelector(`.${CardCssClass.Header} button`);
      if (clickTarget && e.target !== clickTarget)
        clickTarget.click();
    }
  }
  render() {
    const cardOnClickAttr = this.setCardAttributes();
    const TagType = this.setCardTagType();
    return (h(Host, { class: this.getHostCssClassMap() }, h(TagType, Object.assign({ class: CardCssClass.Card }, cardOnClickAttr), h("div", { class: CardCssClass.Wrapper }, this.hasPrependSlotContent ? (h("div", { class: CardCssClass.Prepend }, h("slot", { name: CardSlot.Prepend }))) : null, h("div", { class: CardCssClass.Content }, this.hasHeaderContent
      ? this.getHeaderContent()
      : null, h("div", { class: CardCssClass.Body }, h("slot", null)))), this.hasFooterSlotContent ? (h("div", { class: CardCssClass.Footer }, h("slot", { name: "footer" }))) : null)));
  }
  get el() { return getElement(this); }
};
Card.style = cardCss;

const popoverCss = ".sc-iress-popover-h{--iress-background-color:var(--iress-popover-background-color,\n          var(--iress-a-layout-background-color,\n              var(--iress-g-background-color,\n                  var(--iress-default-background-color\n      ))));--iress-border-width:var(--iress-popover-border-width,\n          var(--iress-g-border-width,\n              var(--iress-default-border-width\n      )));--iress-border-color:var(--iress-popover-border-color,\n          var(--iress-g-border-color,\n              var(--iress-default-border-color\n      )));--iress-max-width:var(--iress-popover-max-width, calc(18 * var(--iress-g-spacing-rem)));--iress-max-height:var(--iress-popover-max-height, calc(25 * var(--iress-g-spacing-rem)));--iress-popper-border-radius:var(--iress-popover-border-radius, var(--iress-g-border-radius, 0));--iress-box-shadow-size:var(--iress-popover-box-shadow-size, 0 0);--iress-box-shadow-color:var(--iress-popover-box-shadow-color, transparent);--iress-text-color:var(--iress-g-text-color, var(--iress-default-text-color))}.iress-popover--input.sc-iress-popover-h{--iress-max-width:auto}.sc-iress-popover-h{--focus-spacer:var(--iress-g-focus-width, var(--iress-default-focus-size));display:inline-block}.iress-popover--input.sc-iress-popover-h{display:block}.sc-iress-popover-h .iress-popover__activator.sc-iress-popover{display:block}.sc-iress-popover-h .iress-popover__content.sc-iress-popover{background-color:var(--iress-background-color);border:var(--iress-border-width) solid var(--iress-border-color);border-radius:var(--iress-popper-border-radius);max-width:var(--iress-max-width);max-height:var(--iress-max-height);box-shadow:var(--iress-box-shadow-size) var(---iress-box-shadow-color);z-index:1020;display:block;overflow-y:auto;overflow-x:hidden;color:var(--iress-text-color)}.sc-iress-popover-h .iress-popover__content.sc-iress-popover:focus{outline:none}.sc-iress-popover-h .iress-popover__content[hidden].sc-iress-popover{display:none}.sc-iress-popover-h .sc-iress-popover-s>.iress-card,.sc-iress-popover-h .sc-iress-popover-s>[data-wrapper-children]>.iress-card{--iress-border-width:0}.sc-iress-popover-h .sc-iress-popover-s>.iress-tab-container,.sc-iress-popover-h .sc-iress-popover-s>[data-wrapper-children]>.iress-tab-container{margin:var(--focus-spacer) var(--focus-spacer) 0}.sc-iress-popover-h .sc-iress-popover-s>.iress-menu,.sc-iress-popover-h .sc-iress-popover-s>[data-wrapper-children]>.iress-menu{width:100%}.iress-popover--input.sc-iress-popover-h .iress-popover__content.sc-iress-popover{min-width:calc(12 * var(--iress-g-spacing-rem))}.iress-filter.sc-iress-popover-h .iress-popover__content.sc-iress-popover:not([hidden]),.iress-filter .sc-iress-popover-h .iress-popover__content.sc-iress-popover:not([hidden]){display:flex;flex-direction:column;overflow:hidden}.sc-iress-popover-h.iress-filter .sc-iress-popover-s>.iress-filter__menu,.iress-filter .sc-iress-popover-h .sc-iress-popover-s>.iress-filter__menu{overflow:auto}";

let popoverCount = 0;
const Popover = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.iressPopoverActivated = createEvent(this, "iressPopoverActivated", 7);
    this.iressPopoverDeactivated = createEvent(this, "iressPopoverDeactivated", 7);
    this.activatorElement = null;
    this.activatorContainer = null;
    this.popoverContent = null;
    this.contentMargin = 5;
    this.minLength = 1;
    this.ariaMenu = null;
    this.popperEl = null;
    this.active = false;
    /**
     * Sets the display mode of popover. Overlay or inline.
     */
    this.displayMode = DisplayMode.Overlay;
    /**
     * When set to true, popover toggling can only be done through the toggle method
     */
    this.disabledAutoToggle = false;
    this.setFocusItems = () => {
      this.focusItems = this.popoverContent.querySelectorAll('button:not([tabindex="-1"]), a[href], input:not([type="hidden"]), select, textarea, [tabindex="0"]:not(.iress-popover__content)');
    };
    this.handleActivatorButtonClick = () => {
      this.disabledAutoToggle === false && this.setActive(!this.active);
    };
    this.handleInputChange = ({ target, }) => {
      if (this.disabledAutoToggle === false) {
        target.value.length >= this.minLength
          ? this.setActive(true, false)
          : this.setActive(false, false);
      }
    };
    this.isSingleSelectListboxOrMenu = () => {
      var _a, _b, _c;
      return (((_a = this.ariaMenu) === null || _a === void 0 ? void 0 : _a.getAttribute('role')) === MenuType.Listbox &&
        !((_b = this.ariaMenu) === null || _b === void 0 ? void 0 : _b.hasAttribute('multi-select'))) ||
        ((_c = this.ariaMenu) === null || _c === void 0 ? void 0 : _c.getAttribute('role')) === MenuType.Menu;
    };
    this.menuItemClicked = (eventPath) => {
      // Checks to see whether the clicked element is a menu item
      const menuItems = eventPath.filter((item) => {
        var _a, _b;
        if (((_a = item.classList) === null || _a === void 0 ? void 0 : _a.contains(MenuItemCssClass.Inner)) ||
          ((_b = item.classList) === null || _b === void 0 ? void 0 : _b.contains(MenuItemCssClass.Button))) {
          return true;
        }
        return false;
      });
      return menuItems.length > 0;
    };
    this.shouldClose = (e) => {
      const eventPath = e.composedPath();
      // Check to see whether the click came from inside the popover
      const popoverContentClicked = e.target === this.popoverContent || eventPath.includes(this.el);
      // Check if the click is from the activatorElement
      const isActivatorElement = eventPath.includes(this.activatorElement) ||
        e.target === this.popoverContent;
      // Check if the click is from a menu item
      const isMenuItem = this.menuItemClicked(eventPath);
      if (popoverContentClicked) {
        if (!isActivatorElement &&
          isMenuItem &&
          this.isSingleSelectListboxOrMenu())
          // The target is a menu item or listbox so popover should close
          return true;
        // All other internal clicks should leave the popover open
        return false;
      }
      // Click came from the outside so we can close popover
      return true;
    };
    this.clickOutside = (e) => {
      if (this.active !== true)
        return;
      if (e.target !== document.documentElement) {
        const shouldClose = this.shouldClose(e);
        if (shouldClose === false)
          return;
        if (shouldClose === true)
          return this.setActive(false, true);
      }
      this.setActive(false, false);
    };
    this.escKeyHandler = () => {
      var _a, _b;
      if (this.hasInputActivator === true && this.active === true) {
        this.activatorElement.value = '';
        if ((_a = this.ariaMenu) === null || _a === void 0 ? void 0 : _a.hasAttribute('aria-activedescendant'))
          (_b = this.ariaMenu) === null || _b === void 0 ? void 0 : _b.removeAttribute('aria-activedescendant');
      }
      this.activatorElement.focus();
      this.setActive(false);
    };
    this.tabKeyHandler = (e, currentFocusIndex) => {
      if (this.active !== true)
        return;
      this.setFocusItems();
      if (e.shiftKey && (this.ariaMenu !== null || currentFocusIndex === 0)) {
        e.preventDefault();
        return this.setActive(false);
      }
      if (!e.shiftKey &&
        (this.ariaMenu !== null ||
          currentFocusIndex === this.focusItems.length - 1))
        this.setActive(false, false);
    };
    this.focusOnAriaMenu = () => {
      // add tab index if not already set
      if (this.ariaMenu.getAttribute('tabindex') === null) {
        this.ariaMenu.setAttribute('tabindex', '-1');
      }
      this.ariaMenu.focus();
    };
    this.arrowDownKeyHandler = (e) => {
      // Prevent default to stop scrolling
      e.preventDefault();
      if (this.hasInputActivator !== true ||
        this.getCurrentFocusIndex() !== -1)
        return;
      if (this.active !== true) {
        if (this.activatorElement.value !== '' &&
          this.ariaMenu.querySelector(`.iress-menu-item`) !== null)
          this.setActive(true, true);
      }
      else {
        this.focusOnAriaMenu();
      }
    };
    this.arrowUpKeyHandler = () => {
      if (this.type !== PopoverType.Listbox)
        return;
      this.setActive(false, true);
    };
    this.keyDownHandler = (e) => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        return this.escKeyHandler();
      }
      if (e.key === 'Tab') {
        return this.tabKeyHandler(e, this.getCurrentFocusIndex());
      }
      if (e.key === 'ArrowDown') {
        return this.arrowDownKeyHandler(e);
      }
      if (e.key === 'ArrowUp') {
        return this.arrowUpKeyHandler();
      }
    };
    this.setFocus = () => 
    // Timeout is required to ensure popover gains focus correctly
    promiseTimeout(() => {
      this.ariaMenu !== null
        ? this.focusOnAriaMenu()
        : this.popoverContent.focus();
    }, 20);
    this.setContentWidth = () => {
      if (this.hasInputActivator !== true)
        return;
      this.popoverContent.style.minWidth = `${this.el.clientWidth}px`;
    };
    this.getAlign = () => {
      var _a;
      if (this.align !== undefined)
        return this.align;
      if (((_a = this.activatorElement) === null || _a === void 0 ? void 0 : _a.tagName) === 'INPUT')
        return document.dir === 'rtl'
          ? PopperAlign.BottomEnd
          : PopperAlign.BottomStart;
      if (this.inCardSlot)
        return document.dir === 'rtl'
          ? PopperAlign.BottomStart
          : PopperAlign.BottomEnd;
      return PopperAlign.BottomCenter;
    };
    this.getPopperConfig = () => ({
      placement: this.getAlign(),
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, this.contentMargin],
          },
        },
      ],
    });
    this.shouldUsePopper = () => this.activatorElement !== null &&
      this.popoverContent !== null &&
      this.active === true &&
      this.displayMode === DisplayMode.Overlay;
  }
  /**
   * shows or hides the popover
   */
  async show(showMenu = true) {
    if ((showMenu && this.active) || (!showMenu && !this.active))
      return;
    showMenu
      ? await this.setActive(true, false)
      : await this.setActive(false, true);
  }
  /**
   * manually updates the popper instance
   */
  async updatePopper() {
    var _a;
    await ((_a = this.popperEl) === null || _a === void 0 ? void 0 : _a.update());
  }
  connectedCallback() {
    const activatorInput = this.el.querySelector(`[slot="${PopoverSlot.Activator}"] input`);
    if (activatorInput !== null)
      this.type = PopoverType.Listbox;
  }
  componentWillLoad() {
    this.suffix = getSuffix(this.el, 'iress-popover');
    this.popoverId = `iress-popover${this.suffix}-${popoverCount++}`;
  }
  componentDidLoad() {
    this.primeContent();
    this.primeActivator();
    this.inCardSlot = this.el.closest(`.${CardCssClass.TopRight}`) !== null;
    const combobox = this.el.closest(`.${ComboboxCssClass.Base}`);
    if (combobox !== null) {
      const minLength = combobox.getAttribute('min-length');
      if (minLength !== null && minLength !== '1')
        this.minLength = parseInt(minLength, 10);
    }
    if (this.type === PopoverType.Menu ||
      this.type === PopoverType.Listbox) {
      this.ariaMenu = this.el.querySelector(`#${this.popoverId} .${MenuCssClass.Base}`);
      if (this.ariaMenu === null) {
        idsLogger('IressPopover: expects IressMenu in the default slot');
      }
      else if (this.hasInputActivator) {
        this.ariaMenu.setAttribute('fluid', '');
      }
    }
  }
  disconnectedCallback() {
    var _a, _b;
    document.removeEventListener('click', this.clickOutside);
    this.el.removeEventListener('keydown', this.keyDownHandler);
    (_a = this.activatorElement) === null || _a === void 0 ? void 0 : _a.removeEventListener('click', this.handleActivatorButtonClick);
    (_b = this.activatorElement) === null || _b === void 0 ? void 0 : _b.removeEventListener('iressChange', this.handleInputChange);
  }
  primeContent() {
    this.popoverContent = this.el.querySelector(`#${this.popoverId}`);
    if (this.popoverContent) {
      document.addEventListener('click', this.clickOutside);
      this.el.addEventListener('keydown', this.keyDownHandler);
      this.setFocusItems();
    }
  }
  getActivatorElement() {
    let slotContent = this.el.querySelector('[slot="activator"]');
    if (slotContent === null) {
      idsLogger('IressPopover: No activator element detected');
    }
    else {
      if (slotContent.tagName === 'BUTTON' ||
        slotContent.tagName === 'INPUT')
        return slotContent;
      slotContent = this.el.querySelector(`[slot="activator"]:not(.${ComboboxCssClass.TagListInput}) button, [slot="activator"] input`);
      if (slotContent === null) {
        idsLogger('IressPopover: Either a button or an input is expected in the activator slot');
      }
    }
    return slotContent;
  }
  setUpAriaMenu() {
    this.ariaMenu = this.popoverContent.querySelector(`.${MenuCssClass.Base}`);
    if (this.ariaMenu !== null) {
      this.ariaMenu.setAttribute('type', MenuType.Listbox);
      if (this.ariaMenu.hasAttribute('id') === false) {
        this.ariaMenu.setAttribute('id', `${this.popoverId}-menu`);
      }
      this.activatorElement.setAttribute('aria-controls', `${this.ariaMenu.getAttribute('id')} ${this.popoverId}`);
    }
    else {
      idsLogger('IressPopover: expects IressMenu in the default slot');
    }
  }
  primeActivatorButton() {
    if (this.type !== undefined)
      this.activatorElement.setAttribute('aria-haspopup', this.type);
    this.activatorElement.setAttribute('aria-controls', this.popoverId);
    this.activatorElement.addEventListener('click', this.handleActivatorButtonClick);
    if (this.type === PopoverType.Listbox) {
      this.setUpAriaMenu();
    }
  }
  primeActivatorInput() {
    this.hasInputActivator = true;
    this.type = PopoverType.Listbox;
    this.activatorElement.setAttribute('role', 'combobox');
    if (this.displayMode === DisplayMode.Overlay)
      this.activatorElement.setAttribute('aria-haspopup', PopoverType.Listbox);
    this.activatorElement.setAttribute('aria-autocomplete', 'list');
    this.setUpAriaMenu();
    this.activatorElement.addEventListener('input', this.handleInputChange);
  }
  setActivatorContainer() {
    var _a, _b;
    if ((_a = this.el
      .closest(`.${ComboboxCssClass.Base}`)) === null || _a === void 0 ? void 0 : _a.hasAttribute('multiple')) {
      this.activatorContainer = (_b = this.el
        .closest(`.${ComboboxCssClass.Base}`)) === null || _b === void 0 ? void 0 : _b.querySelector(`.${ComboboxCssClass.TagListInput}`);
    }
    else {
      this.activatorContainer = this.el.querySelector(`.${PopoverCssClass.Activator}`);
    }
  }
  primeActivator() {
    if (this.activatorElement === null) {
      this.activatorElement = this.getActivatorElement();
      this.setActivatorContainer();
      if (this.activatorElement) {
        if (this.activatorElement.tagName === 'BUTTON') {
          this.primeActivatorButton();
        }
        if (this.activatorElement.tagName === 'INPUT') {
          this.primeActivatorInput();
        }
        this.activatorElement.setAttribute('aria-expanded', this.active);
      }
    }
  }
  getCurrentFocusIndex() {
    let focusIndex = -1;
    this.focusItems.forEach((item, i) => {
      if (item === getActiveElement())
        focusIndex = i;
    });
    return focusIndex;
  }
  async setActive(newActive, focus = true) {
    var _a, _b;
    this.setFocusItems();
    (_a = this.activatorElement) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-expanded', newActive);
    this.active = newActive;
    if (newActive === true) {
      if (this.ariaMenu !== null)
        this.ariaMenu.setAttribute('tabindex', '0');
      if (focus === true)
        await this.setFocus();
      this.setContentWidth();
      this.iressPopoverActivated.emit();
    }
    else {
      if (this.ariaMenu !== null) {
        this.ariaMenu.setAttribute('aria-activedescendant', '');
        this.ariaMenu.removeAttribute('tabindex');
      }
      if (focus === true)
        (_b = this.activatorElement) === null || _b === void 0 ? void 0 : _b.focus();
      this.iressPopoverDeactivated.emit();
    }
    this.popoverContent.scrollTop = 0;
  }
  render() {
    const contentProps = {};
    let contentWidthProps = {};
    if (this.active !== true)
      contentProps['hidden'] = true;
    if (this.shouldUsePopper()) {
      this.popperEl = createPopper(this.activatorContainer, this.popoverContent, this.getPopperConfig());
    }
    if (this.width !== undefined) {
      contentWidthProps = {
        style: { maxWidth: `${this.width}`, width: '100%' },
      };
    }
    return (h(Host, { class: {
        [PopoverCssClass.Base]: true,
        [PopoverCssClass.InputActivator]: this.hasInputActivator === true,
        [PopoverCssClass.Inline]: this.displayMode === DisplayMode.Inline,
      } }, h("div", { class: PopoverCssClass.Activator }, h("slot", { name: PopoverSlot.Activator })), h("div", Object.assign({ class: PopoverCssClass.Content, id: this.popoverId }, contentProps, contentWidthProps, { tabindex: "-1", "data-testid": nativeTestid(this.el, 'content') }), h("slot", null))));
  }
  get el() { return getElement(this); }
};
Popover.style = popoverCss;

const TagListInput = ({ tags, tagLimit, hostEl, name, required, optional, watermark, clearable, multiInputLabel, hiddenLabel, loading, hasPrependSlot, hasAppendSlot, selectedOptionsTagText, handleInputChange, handleInputKeyPress, handleInputBlur, placeholder, suffix = '', error = false, }) => {
  const Input = `iress-input${suffix}`;
  const Inline = `iress-inline${suffix}`;
  const Tag = `iress-tag${suffix}`;
  const Label = `iress-label${suffix}`;
  const Spinner = `iress-spinner${suffix}`;
  const renderTags = () => {
    if (tags.length <= tagLimit)
      return tags.map((tag) => (h(Tag, { "data-testid": nativeTestid(hostEl, 'tag') }, tag)));
    return (h(Tag, { "data-testid": nativeTestid(hostEl, 'tag') },
      tags.length,
      " ",
      selectedOptionsTagText));
  };
  return (h("div", { class: {
      [ComboboxCssClass.TagListInput]: true,
      [InputCssClass.HiddenLabel]: hiddenLabel,
    }, slot: PopoverSlot.Activator },
    multiInputLabel && (h(Label, { class: ComboboxCssClass.TagListInputLabel, for: name, labelText: multiInputLabel, required: required, optional: optional })),
    h("div", { class: {
        [ComboboxCssClass.TagListInputWrapper]: true,
        [GlobalCssClass.FormElementInvalid]: error === true,
        [InputCssClass.Watermark]: watermark === true,
      } },
      hasPrependSlot === true ? (h("div", { class: InputCssClass.AddOn },
        h("slot", { name: ComboboxSlot.Prepend }))) : null,
      h("div", { class: ComboboxCssClass.TagListInputWrapperInner },
        h(Inline, { gutter: InlineGutter.Xs, verticalAlign: InlineVerticalAlign.Top },
          renderTags(),
          h(Input, { class: ComboboxCssClass.Input, autocomplete: "off", "data-testid": nativeTestid(hostEl, 'input'), name: name, clearable: clearable, type: TextFieldType.Search, placeholder: placeholder, onIressInput: (e) => handleInputChange(e), onIressKeyDown: (e) => handleInputKeyPress(e), onIressBlur: (e) => handleInputBlur(e) },
            h(Spinner, { slot: InputSlot.Internal, active: loading === true, class: {
                [GlobalCssClass.Hidden]: loading === false,
              } })))),
      hasAppendSlot === true ? (h("div", { class: InputCssClass.AddOn },
        h("slot", { name: ComboboxSlot.Append }))) : null)));
};

const getInvalidSelectedOptions = (selectedOptions, options, name, asyncSearchFn = false) => {
  if (Array.isArray(selectedOptions)) {
    const invalidOptions = [];
    selectedOptions.forEach((opt) => {
      if (validateOption(opt, options, name, asyncSearchFn) === false)
        invalidOptions.push(opt);
    });
    return invalidOptions;
  }
  if (validateOption(selectedOptions, options, name, asyncSearchFn) === false)
    return [selectedOptions];
  return [];
};
const isValidLabelValue = (selectedOption, // eslint-disable-line
name) => {
  if (selectedOption.value === undefined ||
    selectedOption.label === undefined) {
    idsLogger(`IressCombobox: ${name}: selectedOptions must be a valid MenuItemMeta objects`);
    return false;
  }
  return true;
};
const validateOption = (selectedOption, options, name, asyncSearchFn) => {
  if (!isValidLabelValue(selectedOption, name))
    return false;
  if (asyncSearchFn)
    return true;
  const selectedOptions = options.filter((option) => option.value === selectedOption.value &&
    option.label === selectedOption.label);
  if (selectedOptions.length < 1) {
    idsLogger(`IressCombobox: ${name}: No match for selected option ${selectedOption.label}`);
    return false;
  }
  return true;
};
const updateSelectedOptionsArray = (selected, selectedOption) => {
  const index = selected.findIndex((opt) => opt.value === selectedOption.value);
  index > -1 ? selected.splice(index, 1) : selected.push(selectedOption);
  return selected;
};
const validationObject = {
  valid: true,
  valueMissing: false,
  badInput: false,
};
const isUnselected = (selected) => selected === null || selected.length < 1;
const getValidityObject = (required, query, selected, multiple) => {
  if (required === false)
    return validationObject;
  const unselected = isUnselected(selected);
  if (multiple === true && unselected === false)
    return validationObject;
  if (unselected === true && query === '')
    return Object.assign(Object.assign({}, validationObject), { valid: false, valueMissing: true });
  if (unselected === true && query !== '')
    return Object.assign(Object.assign({}, validationObject), { valid: false, badInput: true });
  return validationObject;
};

const comboboxCss = ".sc-iress-combobox-h{--iress-font-family:var(--iress-input-font-family, var(--iress-a-form-font-family, var(--iress-g-font-family, inherit)));--iress-font-size:var(--iress-input-font-size, inherit);--iress-font-weight:var(--iress-input-font-weight, var(--iress-g-font-weight, normal));--iress-background-color:var(--iress-input-background-color, var(--iress-a-form-background-color, var(--iress-g-background-color, var(--iress-default-background-color))));--iress-border-width:var(--iress-input-border-width, var(--iress-a-form-border-width, var(--iress-g-border-width, var(--iress-default-border-width))));--iress-addon-border-width:var(\n        --iress-input-addon-border-width,\n        var(--iress-input-border-width, var(--iress-a-form-border-width, var(--iress-g-border-width, var(--iress-default-border-width))))\n    );--iress-border-color:var(--iress-input-border-color, var(--iress-g-form-border-color, var(--iress-default-form-border-color)));--iress-border-radius:var(--iress-input-border-radius, var(--iress-a-form-border-radius, var(--iress-g-border-radius, var(--iress-default-border-radius))));--iress-text-color:var(--iress-input-text-color, var(--iress-g-text-color, inherit));--iress-focus-border-color:var(--iress-input-focus-border-color, var(--iress-focus-color));--iress-focus-box-shadow:0 0 0 var(--iress-g-focus-width, 2px) var(--iress-focus-color);--iress-focus-background-color:var(--iress-input-focus-background-color, var(--iress-background-color));--iress-focus-text-color:var(--iress-input-focus-text-color, var(--iress-text-color));--iress-watermark-text-color:var(--iress-input-watermark-text-color, var(--iress-default-text-color--placeholder));--iress-placeholder-text-color:var(--iress-input-placeholder-text-color, var(--iress-default-text-color--placeholder));--iress-padding-x:var(--iress-input-padding-x, var(--iress-g-spacing-sm));--iress-padding-y:var(--iress-input-padding-y, var(--iress-g-spacing-sm));--iress-transition-hover-duration:var(--iress-input-transition-hover-duration, 0s);--iress-transition-hover-type:var(--iress-input-transition-hover-type, none);--iress-transition-hover:all var(--iress-transition-hover-duration) var(--iress-transition-hover-type);--iress-label-padding-bottom:var(--iress-input-label-padding-bottom, var(--iress-g-spacing-sm));--iress-min-height:var(--iress-input-min-height, var(--iress-default-min-height))}.sc-iress-combobox-h{--iress-popover-menu-max-height:var(--iress-combobox-popover-max-height,\n          calc(15.25 * var(--iress-g-rem)));--iress-taglist-input-border-color:var(--iress-input-border-color,\n          var(--iress-g-form-border-color,\n              var(--iress-default-form-border-color\n  )));--iress-taglist-input-border-width:var(--iress-input-addon-border-width,\n          var(--iress-input-border-width,\n              var(--iress-a-form-border-width,\n                  var(--iress-g-border-width,\n                      var(--iress-default-border-width\n      )))));--iress-taglist-input-line-height:var(--iress-label-line-height,\n          var(--iress-a-form-line-height,\n              var(--iress-g-line-height,\n                  1.5\n  )));--iress-label-padding-bottom:var(--iress-input-label-padding-bottom, var(--iress-g-spacing-sm));--iress-transition-duration:var(--iress-g-animation-duration,var(--iress-default-animation-duration));--iress-transition-type:var(--iress-g-animation-type, var(--iress-default-animation-type));--iress-transition:all var(--iress-transition-duration) var(--iress-transition-type);--iress-text-color:var(--iress-input-text-color, var(--iress-g-text-color, inherit))}.iress-field--invalid.sc-iress-combobox-h,.iress-field--invalid .sc-iress-combobox-h{--iress-taglist-input-border-color:var(--iress-input-invalid-border-color,\n          var(--iress-a-danger-border-color,\n              var(--iress-g-danger-color,\n                  var(--iress-default-danger-color\n      ))))}.sc-iress-combobox-h{display:block}.sc-iress-combobox-h .iress-combobox__popover.sc-iress-combobox{display:block}.sc-iress-combobox-h .iress-combobox__popover.iress-popover.sc-iress-combobox{--iress-max-height:var(--iress-popover-menu-max-height)}.sc-iress-combobox-h .iress-inline.sc-iress-combobox::before{content:none}.sc-iress-combobox-h .iress-inline__inner.sc-iress-combobox{align-items:baseline}.sc-iress-combobox-h .iress-combobox__tag-list-input.sc-iress-combobox{--iress-background-color:var(--iress-input-background-color,\n          var(--iress-a-form-background-color,\n              var(--iress-g-background-color,\n                  var(--iress-default-background-color\n  ))))}.sc-iress-combobox-h .iress-combobox__tag-list-input.sc-iress-combobox .iress-combobox__tag-list-input__label.sc-iress-combobox{padding-block-end:var(--iress-label-padding-bottom)}.sc-iress-combobox-h .iress-combobox__tag-list-input.sc-iress-combobox .iress-input__addon.sc-iress-combobox{background-color:var(--iress-background-color);color:var(--iress-text-color);line-height:1;font-weight:300;display:inline-flex;align-items:center;flex-shrink:0}.sc-iress-combobox-h .iress-combobox__tag-list-input__wrapper.sc-iress-combobox .iress-input__addon.sc-iress-combobox:first-of-type{border-inline-end:var(--iress-taglist-input-border-width) solid var(--iress-taglist-input-border-color);margin-inline-end:var(--iress-padding-x);border-start-start-radius:var(--iress-border-radius);border-end-start-radius:var(--iress-border-radius)}.sc-iress-combobox-h .iress-combobox__tag-list-input__wrapper.sc-iress-combobox .iress-input__addon.sc-iress-combobox:last-of-type{border-inline-start:var(--iress-taglist-input-border-width) solid var(--iress-taglist-input-border-color);border-start-end-radius:var(--iress-border-radius);border-end-end-radius:var(--iress-border-radius)}.sc-iress-combobox-h .iress-combobox__tag-list-input__wrapper.iress-input--watermark.sc-iress-combobox .iress-input__addon.sc-iress-combobox{border:0;margin:0;color:var(--iress-watermark-text-color)}.sc-iress-combobox-h .iress-combobox__tag-list-input .iress-input__addon.sc-iress-combobox-s>*,.sc-iress-combobox-h .iress-combobox__tag-list-input .iress-input__addon span.sc-iress-combobox-s>*,.sc-iress-combobox-h .iress-combobox__tag-list-input.sc-iress-combobox .iress-input__addon.sc-iress-combobox .iress-spinner.sc-iress-combobox{padding-block-start:0;padding-block-end:0;padding-inline-start:calc(0.75 * var(--iress-g-spacing-rem, var(--iress-default-spacing-sm)));padding-inline-end:calc(0.75 * var(--iress-g-spacing-rem, var(--iress-default-spacing-sm)))}.sc-iress-combobox-h .iress-combobox__tag-list-input.sc-iress-combobox .iress-input__addon.sc-iress-combobox:empty{display:none}.sc-iress-combobox-h .iress-input--hiddenlabel.sc-iress-combobox .iress-combobox__tag-list-input__label.iress-label.sc-iress-combobox{border:0;clip:rect(0, 0, 0, 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.sc-iress-combobox-h .iress-combobox__tag-list-input__wrapper.sc-iress-combobox{border-radius:var(--iress-border-radius);background-color:var(--iress-background-color);border-width:var(--iress-border-width);border-style:solid;border-color:var(--iress-taglist-input-border-color);color:var(--iress-text-color);transition:var(--iress-transition);min-height:var(--iress-min-height);display:flex}.sc-iress-combobox-h .iress-combobox__tag-list-input__wrapper.sc-iress-combobox:focus{box-shadow:none}.sc-iress-combobox-h .iress-combobox__tag-list-input__wrapper.sc-iress-combobox:focus-within{box-shadow:var(--iress-focus-box-shadow);border-color:var(--iress-focus-border-color)}.sc-iress-combobox-h .iress-combobox__tag-list-input__wrapper-inner.sc-iress-combobox:first-child{padding-inline-start:calc(var(--iress-padding-x) / 2);padding-inline-end:calc(var(--iress-padding-x) / 2)}.sc-iress-combobox-h .iress-combobox__tag-list-input__wrapper-inner.sc-iress-combobox{padding-block-start:calc(var(--iress-padding-y) / 1.33);padding-block-end:calc(var(--iress-padding-y) / 2);flex-grow:1}.sc-iress-combobox-h .iress-combobox__tag-list-input__wrapper.sc-iress-combobox .iress-inline.sc-iress-combobox{margin-block-start:0}.sc-iress-combobox-h .iress-combobox__tag-list-input__wrapper.sc-iress-combobox .iress-input.sc-iress-combobox{--iress-border-width:0;--iress-focus-box-shadow:none;--iress-padding-y:var(--iress-g-spacing-xs);--iress-padding-x:0;--iress-min-height:auto;flex-grow:1}.sc-iress-combobox-h .iress-combobox__tag-list-input__wrapper.sc-iress-combobox .iress-input.sc-iress-combobox:focus{box-shadow:none}.sc-iress-combobox-h .iress-combobox__tag-list-input__wrapper-inner.sc-iress-combobox:first-child .iress-input.sc-iress-combobox,.sc-iress-combobox-h .iress-tag.sc-iress-combobox+.iress-input.sc-iress-combobox{--iress-padding-x:var(--iress-g-spacing-xs)}.sc-iress-combobox-h .iress-combobox__watermark.sc-iress-combobox{border-inline-start:none}.iress-combobox--focus.sc-iress-combobox-h .iress-combobox__tag-list-input__wrapper.sc-iress-combobox{box-shadow:var(--iress-focus-box-shadow);border-color:var(--iress-focus-border-color)}";

let comboboxIds = 0;
const Combobox = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.iressInputChange = createEvent(this, "iressInputChange", 7);
    this.iressSelectedChange = createEvent(this, "iressSelectedChange", 7);
    this.iressErrorChange = createEvent(this, "iressErrorChange", 7);
    this.iressInvalidSelectedOption = createEvent(this, "iressInvalidSelectedOption", 7);
    this.iressBlur = createEvent(this, "iressBlur", 7);
    this.optionsData = [];
    // This is set for determining for the first user change
    this.firstUpdate = false;
    this.firstValidation = true;
    this.asyncSearchFn = null;
    this.query = '';
    this.results = null;
    this.selected = null;
    this.error = false;
    this.loading = false;
    /**
     * Error message displayed in field when there is text in search input but no selected item
     */
    this.badInputText = 'Please select an option from the list';
    /**
     * When true, the input displays a clear button to clear the selected values
     */
    this.clearable = false;
    /**
     * Time in milliseconds to wait for before performing result search
     */
    this.debounceThreshold = 500;
    /**
     * Display mode of menu (either overlay or inline)
     */
    this.displayMode = DisplayMode.Overlay;
    /**
     * Visually hides the label (if set), label will still be read out by screenreaders
     */
    this.hiddenLabel = false;
    /**
     * Allows the ability to select multiple options
     */
    this.multiple = false;
    /**
     * The number of select options before the view switches to a single aggregate tag
     */
    this.multiOptionTagLimit = 4;
    /**
     * Text to be displayed when no results are found
     */
    this.noResultsText = 'No results found';
    /**
     * If true, the (optional) text is shown in the label. Will be ignored if required is set to true
     */
    this.optional = false;
    /**
     * If true, the user must enter/select a option before submitting a form
     */
    this.required = false;
    /**
     * Maximum number of results displayed on larger screensizes ( > 768)
     */
    this.resultLimitDesktop = 12;
    /**
     * Maximum number of results displayed on mobile screensizes ( < 768)
     */
    this.resultLimitMobile = 6;
    /**
     * Text displayed next to tag count in tag when tag limit is exceeded
     */
    this.selectedOptionsTagText = 'options selected';
    /**
     * Validity object of Checkbox group, mirrors validity object in HTML form elements
     */
    this.validity = getValidityObject(this.required, this.query, this.selected, this.multiple);
    /**
     * Error message displayed in field when there is no text in search input and no selected item
     */
    this.valueMissingText = 'Please fill in this field.';
    /**
     * When set to true add ons will render with a different style. Will be ignored if prepend or append slots are not being used.
     */
    this.watermark = false;
    this.setOptionsData = () => {
      if (this.options === undefined)
        return;
      if (typeof this.options === 'function') {
        this.asyncSearchFn = this.options;
        return;
      }
      this.optionsData =
        typeof this.options !== 'string'
          ? this.options
          : JSON.parse(this.options);
    };
    this.getValidSelectedOptions = (selectedOption) => {
      const invalidOptions = getInvalidSelectedOptions(selectedOption, this.optionsData, this.name, this.asyncSearchFn !== null);
      if (invalidOptions.length > 0) {
        this.iressInvalidSelectedOption.emit(invalidOptions);
        if (this.multiple === false)
          return null;
        invalidOptions.forEach((invOpt) => {
          const index = selectedOption.indexOf(invOpt, 0);
          selectedOption.splice(index, 1);
        });
      }
      if (Array.isArray(selectedOption))
        return this.multiple === true
          ? selectedOption.map((opt) => ({
            label: opt.label,
            value: opt.value,
          }))
          : {
            label: selectedOption[0].label,
            value: selectedOption[0].value,
          };
      return {
        label: selectedOption.label,
        value: selectedOption.value,
      };
    };
    this.setSelectedOption = async () => {
      if (this.selectedOption === undefined) {
        if (this.multiple)
          this.selected = [];
        return;
      }
      const selectedOption = typeof this.selectedOption === 'string'
        ? JSON.parse(this.selectedOption)
        : this.selectedOption;
      this.selected = this.getValidSelectedOptions(selectedOption);
      await this.validate();
    };
    this.setupInternalElements = () => {
      var _a, _b;
      this.inputEl = this.el.querySelector(`.${ComboboxCssClass.Input}`);
      this.popoverEl = this.el.querySelector(`.${ComboboxCssClass.Popover}`);
      this.nativeInputEl = this.el.querySelector(`.${ComboboxCssClass.Input} .${InputCssClass.NativeInput}`);
      this.menuEl = this.el.querySelector(`.${ComboboxCssClass.Menu}`);
      this.tagListInput = this.el.querySelector(`.${ComboboxCssClass.TagListInput}`);
      (_a = this.tagListInput) === null || _a === void 0 ? void 0 : _a.addEventListener('iressTagDelete', this.handleTagDeleteClick);
      (_b = this.tagListInput) === null || _b === void 0 ? void 0 : _b.addEventListener('iressBlur', this.handleTagBlur);
      this.inputEl.addEventListener('iressErrorChange', (e) => {
        e.stopPropagation();
      });
    };
    this.handleUpdateMultiSelected = (selectedOption) => {
      const newSelected = [...this.selected];
      this.selected = updateSelectedOptionsArray(newSelected, selectedOption);
      this.results = null;
    };
    this.updateSelected = async (selectedOption) => {
      if (JSON.stringify(this.selected) === JSON.stringify(selectedOption) &&
        this.multiple === false)
        return;
      if (Array.isArray(this.selected) || this.multiple === true) {
        this.handleUpdateMultiSelected(selectedOption);
      }
      else {
        this.selected = selectedOption;
        if (selectedOption !== null) {
          this.emitInputChangeEvent(selectedOption.label);
          this.results = null;
        }
      }
      await this.validate();
    };
    this.showMenu = async (show = true) => {
      await this.popoverEl.show(show);
    };
    this.doAsyncSearch = async () => {
      var _a;
      this.loading = true;
      (_a = this.nativeInputEl) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-describedby', `${this.comboboxId}-spinner`);
      const asyncResults = await this.asyncSearchFn(this.query);
      this.optionsData = asyncResults;
      return asyncResults
        .slice(0, this.resultLimitDesktop)
        .map((result) => formatResult(result, this.query));
    };
    this.updateResults = async () => {
      var _a;
      this.results =
        this.asyncSearchFn !== null
          ? await this.doAsyncSearch()
          : doFuzzySearch(this.query, this.optionsData, this.resultLimitDesktop);
      this.loading = false;
      await this.showMenu();
      await this.popoverEl.updatePopper();
      (_a = this.nativeInputEl) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-describedby', `${this.comboboxId}-count`);
    };
    this.getSelectedValues = (labels = false) => {
      if (this.selected === null)
        return '';
      const param = labels ? 'label' : 'value';
      if (Array.isArray(this.selected)) {
        return this.selected.map((item) => item[param]).join(',');
      }
      return this.selected[param] || '';
    };
    this.getStatus = (value) => ({
      value: value === undefined ? this.getSelectedValues() : value,
      label: this.getSelectedValues(true),
      element: this.el,
      component: this.el,
      name: this.name,
      type: FormElementType.Combobox,
      required: this.required,
      error: !this.validity.valid,
    });
    this.emitBlurEvent = () => {
      this.iressBlur.emit(this.getStatus());
      this.setFirstUpdate();
    };
    this.emitInputChangeEvent = (value) => {
      this.iressInputChange.emit(this.getStatus(value));
    };
    this.handleTagDeleteClick = async (e) => {
      const selectedOptions = [...this.selected];
      const filteredSelectedOptions = selectedOptions.filter((opt) => opt.label === e.detail);
      this.selected =
        filteredSelectedOptions.length > 0
          ? updateSelectedOptionsArray(selectedOptions, filteredSelectedOptions[0])
          : [];
      await this.validate();
      this.nativeInputEl.focus();
    };
    this.handleTagBlur = (e) => {
      e.stopPropagation();
      setTimeout(() => {
        if (!hasFocus(this.el) && e.detail.target.tagName === 'BUTTON') {
          this.emitBlurEvent();
        }
      }, 1);
    };
    this.handleInputKeyPress = async (e) => {
      if (e.detail.key === 'Backspace' &&
        this.query === '' &&
        this.multiple === true &&
        this.selected.length > 0) {
        const selectedItems = [...this.selected];
        selectedItems.pop();
        this.selected = selectedItems;
        await this.validate();
      }
      if (e.detail.key === 'Escape') {
        if (this.multiple === false)
          await this.updateSelected(null);
        this.query = '';
        this.emitInputChangeEvent('');
      }
    };
    this.inputChangeUpdate = async () => {
      if (this.query.length > 0) {
        await this.updateResults();
      }
      else {
        this.multiple === false
          ? await this.handleInputClear()
          : await this.showMenu(false);
      }
      if (this.selected !== null &&
        !Array.isArray(this.selected) &&
        this.selected.label !== this.query) {
        await this.updateSelected(null);
      }
      this.emitInputChangeEvent(this.query);
      await this.validate();
    };
    this.handleInputChange = async (e) => {
      var _a;
      // This has to be before the `await` as otherwise the event will no longer be being dispatched.
      const eventPath = e.detail.composedPath();
      // Hide menu to force popover to reposition when results change
      await this.showMenu(false);
      const node = hasShadowDom(e.detail.target)
        ? eventPath[0]
        : e.detail.target; // eslint-disable-line
      this.query = node.value;
      if (this.query === '') {
        this.results = null;
        (_a = this.nativeInputEl) === null || _a === void 0 ? void 0 : _a.removeAttribute('aria-describedby');
      }
      if (this.firstUpdate === false) {
        this.setFirstUpdate();
      }
      if (this.debounceThreshold === 0) {
        await this.inputChangeUpdate();
      }
      else {
        debounceFunction(this.inputChangeUpdate, this.debounceThreshold);
      }
    };
    this.handleInputBlur = async (e) => {
      e.stopPropagation();
      const activeDesc = this.menuEl.getAttribute('aria-activedescendent');
      const keyBoardFocus = activeDesc === null || activeDesc === '';
      setTimeout(() => {
        const mouseFocus = hasFocus(this.el) && !this.clearable;
        if (keyBoardFocus && !mouseFocus)
          this.emitBlurEvent();
      }, 1);
    };
    this.handleInputClear = async () => {
      var _a;
      if (this.query !== '')
        this.emitInputChangeEvent('');
      this.query = '';
      this.results = null;
      await this.updateSelected(null);
      this.inputEl.setAttribute('value', '');
      (_a = this.nativeInputEl) === null || _a === void 0 ? void 0 : _a.removeAttribute('aria-describedby');
      await this.showMenu(false);
    };
    this.handleMenuSelect = async (e) => {
      var _a, _b;
      const newSelectedItem = this.optionsData
        .filter((option) => e.detail === option.value)
        .map((opt) => ({ label: opt.label, value: opt.value }));
      if ((newSelectedItem === null || newSelectedItem === void 0 ? void 0 : newSelectedItem.length) > 0) {
        await this.updateSelected(newSelectedItem[0]);
        if (this.multiple === true) {
          this.inputEl.value = '';
          this.query = '';
          this.emitInputChangeEvent('');
        }
        (_a = this.nativeInputEl) === null || _a === void 0 ? void 0 : _a.removeAttribute('aria-describedby');
        (_b = this.nativeInputEl) === null || _b === void 0 ? void 0 : _b.focus();
      }
    };
  }
  selectedStateChange() {
    this.firstUpdate === true
      ? this.iressSelectedChange.emit(this.getStatus())
      : this.setFirstUpdate();
  }
  async optionsChange() {
    this.setOptionsData();
    if (this.selected === null)
      await this.setSelectedOption();
  }
  async selectedOptionChange(newSel, oldSel) {
    const newSelected = typeof newSel === 'string' ? JSON.parse(newSel) : newSel;
    const oldSelected = typeof oldSel === 'string' ? JSON.parse(oldSel) : oldSel;
    if (JSON.stringify(newSelected) !== JSON.stringify(oldSelected))
      await this.setSelectedOption();
  }
  /**
   * Checks the validity of the combobox
   */
  async checkValidity() {
    const valObj = { valid: this.validity.valid };
    if (this.validity.badInput === true)
      valObj.msg = this.badInputText;
    if (this.validity.valueMissing === true)
      valObj.msg = this.valueMissingText;
    return valObj;
  }
  /**
   * Resets the selected items and the query string
   */
  async reset() {
    this.selected = this.multiple === true ? [] : null;
    this.query = '';
    if (this.nativeInputEl !== null) {
      this.nativeInputEl.value = '';
      this.emitInputChangeEvent('');
    }
  }
  /**
   * Validates the input.
   */
  async validate() {
    const newValidity = getValidityObject(this.required, this.query, this.selected, this.multiple);
    if (JSON.stringify(this.validity) !== JSON.stringify(newValidity)) {
      this.error = newValidity.valid;
      this.validity = newValidity;
      this.iressErrorChange.emit(this.validity);
    }
    else if (this.firstValidation === true) {
      this.iressErrorChange.emit(this.validity);
      this.firstValidation = false;
    }
  }
  /**
   * Gets the input HTML element of the search input.
   */
  getNativeElement() {
    return Promise.resolve(this.nativeInputEl);
  }
  async componentWillLoad() {
    var _a;
    this.suffix = getSuffix(this.el, 'iress-combobox');
    this.comboboxId = `iress-combobox${this.suffix}-${comboboxIds++}`;
    this.name = (_a = this.name) !== null && _a !== void 0 ? _a : this.comboboxId;
    this.setOptionsData();
    await this.setSelectedOption();
    this.hasAppendSlotContent = hasSlotContent(ComboboxSlot.Append, this.el);
  }
  async componentDidLoad() {
    this.setupInternalElements();
    this.fieldEl = this.el.closest(`.${FieldCssClass.Base}`);
    if (this.multiple === true && this.fieldEl !== null)
      await this.registerTagListInput();
  }
  setFirstUpdate() {
    this.firstUpdate = true;
  }
  async registerTagListInput() {
    if (typeof this.fieldEl.registerInputElement === 'function')
      await this.fieldEl.registerInputElement(this.getStatus());
  }
  render() {
    var _a;
    const Popover = `iress-popover${this.suffix}`;
    const Input = `iress-input${this.suffix}`;
    const Spinner = `iress-spinner${this.suffix}`;
    const Text = `iress-text${this.suffix}`;
    const tags = Array.isArray(this.selected)
      ? this.selected.map((opt) => opt.label)
      : [];
    const hasPrependSlot = this.el.querySelector('[slot="prepend"]') !== null;
    const hasAppendSlot = this.el.querySelector('[slot="append"]') !== null;
    const asyncMulti = this.multiple && this.asyncSearchFn !== null;
    const commonProps = {
      required: this.required,
      watermark: this.watermark,
      optional: this.optional,
      clearable: this.clearable && !asyncMulti,
      multiInputLabel: this.multiInputLabel,
      hiddenLabel: this.hiddenLabel,
      placeholder: this.placeholder,
      loading: this.loading,
      name: `${this.name}-search`,
    };
    return (h(Host, { class: {
        [ComboboxCssClass.Base]: true,
        [ComboboxCssClass.Multiple]: this.multiple,
        [GlobalCssClass.FormElement]: true,
        [GlobalCssClass.FormElementInvalid]: this.error === true,
      } }, h(Popover, { type: PopoverType.Listbox, class: ComboboxCssClass.Popover, displayMode: this.displayMode, "data-testid": nativeTestid(this.el, 'popover'), disabledAutoToggle: true }, this.multiple ? (h(TagListInput, Object.assign({}, commonProps, { tags: tags, suffix: this.suffix, hostEl: this.el, selectedOptionsTagText: this.selectedOptionsTagText, hasPrependSlot: hasPrependSlot, hasAppendSlot: hasAppendSlot, tagLimit: this.multiOptionTagLimit, handleInputChange: this.handleInputChange, handleInputKeyPress: this.handleInputKeyPress, handleInputBlur: this.handleInputBlur }))) : (h(Input, Object.assign({ autocomplete: "off", "data-testid": nativeTestid(this.el, 'input') }, commonProps, { slot: PopoverSlot.Activator, type: TextFieldType.Search, class: {
        [ComboboxCssClass.Input]: true,
        [GlobalCssClass.FormElementInvalid]: this.error === true,
        [InputCssClass.Loading]: this.loading === true,
      }, width: this.width, value: ((_a = this.selected) === null || _a === void 0 ? void 0 : _a.label) ||
        this.query, onIressInput: this.handleInputChange, onIressClear: this.handleInputClear, onIressBlur: this.handleInputBlur, onIressKeyDown: this.handleInputKeyPress }), h("slot", { name: ComboboxSlot.Prepend, slot: InputSlot.Prepend }), h(Spinner, { slot: InputSlot.Internal, active: this.loading, class: ComboboxCssClass.Watermark, screenreaderText: "loading", id: `${this.comboboxId}-spinner` }), this.hasAppendSlotContent && (h("span", { slot: InputSlot.Append, class: {
        [GlobalCssClass.Hidden]: !this.hasAppendSlotContent,
      } }, h("slot", { name: ComboboxSlot.Append }))))), h(ResultsMenu, { results: this.results, noResultsText: this.noResultsText, resultLimitMobile: this.resultLimitMobile, dataTestId: nativeTestid(this.el, 'menu'), suffix: this.suffix, onChange: this.handleMenuSelect, tags: tags })), h("input", { "data-testid": nativeTestid(this.el, 'hidden-input'), type: "hidden", name: this.name, value: this.getSelectedValues(), class: ComboboxCssClass.HiddenInput }), h(Text, { class: GlobalCssClass.SROnly, id: `${this.comboboxId}-count`, "data-testid": nativeTestid(this.el, 'results-sr-text') }, this.results && this.results.length > 0
      ? `${this.results.length} ${this.results.length === 1 ? 'result' : 'results'}`
      : this.noResultsText)));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "selected": ["selectedStateChange"],
    "options": ["optionsChange"],
    "selectedOption": ["selectedOptionChange"]
  }; }
};
Combobox.style = comboboxCss;

const isValidFormInputElement = (ele) => (ele.tagName === 'SELECT' && !ele.disabled) ||
  (ele.name &&
    !ele.disabled &&
    ele.type !== 'file' &&
    ele.type !== 'reset' &&
    ele.type !== 'submit' &&
    ele.type !== 'button');
const getValidationAttribute = (errorKey) => {
  switch (errorKey) {
    case FieldErrorType.TooShort:
      return 'minlength';
    case FieldErrorType.TooLong:
      return 'maxlength';
    case FieldErrorType.RangeOverflow:
      return 'max';
    case FieldErrorType.RangeUnderflow:
      return 'min';
    default:
      return null;
  }
};
const getLabelText = (labelEle, fieldIndex) => {
  if (!labelEle)
    return `Field #${fieldIndex + 1}`;
  const labelInner = labelEle.querySelector(`.${LabelCssClass.LabelText}`);
  let labelText = labelInner && labelInner.textContent !== ''
    ? labelInner.textContent
    : labelEle.textContent;
  labelText = labelText.replace('*Required', '');
  labelText = labelText.replace('*', '');
  return labelText;
};
const getLabelElements = (ele) => {
  var _a, _b;
  const isIressComponent = (ele === null || ele === void 0 ? void 0 : ele.tagName.indexOf('IRESS-')) === 0;
  const isGrpComponent = ele === null || ele === void 0 ? void 0 : ele.tagName.includes('-GROUP');
  const isCheckbox = (ele === null || ele === void 0 ? void 0 : ele.tagName) === 'INPUT' &&
    ((_a = ele) === null || _a === void 0 ? void 0 : _a.type) === 'checkbox';
  const fieldWrapper = ele.closest(`.${FieldCssClass.Wrapper}`);
  const isFieldset = (fieldWrapper === null || fieldWrapper === void 0 ? void 0 : fieldWrapper.tagName) === 'FIELDSET';
  if ((fieldWrapper && isIressComponent && isGrpComponent) || isFieldset) {
    return [fieldWrapper.querySelector('legend')];
  }
  if (fieldWrapper && (isIressComponent || isCheckbox)) {
    return [fieldWrapper.querySelector('label')];
  }
  const associatedLabel = (_b = ele
    .closest('form')) === null || _b === void 0 ? void 0 : _b.querySelectorAll(`label[for="${ele.id}"]`);
  return associatedLabel || [];
};
const getValidationMessage = (errorMessageTemplates, 
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
ele, fieldIndex) => {
  let msg = '';
  // Need to use reverse() as date inputs with invalid dates don't have a value, so will fail valueMissing as well as badInput.
  // This means the error will always be valueMissing, as this comes last in the Object.keys array, so will overwrite the badInput error
  Object.keys(errorMessageTemplates)
    .reverse()
    .forEach((errorKey) => {
    if (ele.validity[errorKey]) {
      const labels = getLabelElements(ele);
      const labelEle = labels.length === 2 ? labels[1] : labels[0];
      let labelText = getLabelText(labelEle, fieldIndex);
      const valAttr = getValidationAttribute(errorKey);
      const valAttrValue = valAttr !== null ? ele.getAttribute(valAttr) : '';
      const msgTemplate = errorMessageTemplates[errorKey];
      const fieldValue = ele.value;
      if (msgTemplate) {
        if (msgTemplate.indexOf('{{fieldName}}') > 0) {
          labelText = labelText.toLowerCase();
        }
        const replaceArr = [
          { name: '{{fieldName}}', value: labelText },
          { name: '{{attrValue}}', value: valAttrValue },
          { name: '{{fieldValue}}', value: fieldValue },
        ];
        msg = stringReplacer(msgTemplate, replaceArr);
      }
    }
  });
  return msg;
};
const updateValidElements = (ele, validElements, includeHidden) => {
  if (isValidFormInputElement(ele) !== true)
    return validElements;
  if (ele.tagName === 'SELECT') {
    validElements.push(ele);
    return validElements;
  }
  let customEle;
  switch (ele.type) {
    case 'checkbox':
      customEle = ele.closest(`.${CheckboxGroupCssClass.Base}`);
      if (customEle === null) {
        validElements.push(ele);
      }
      break;
    case 'radio':
      customEle = ele.closest(`.${RadioGroupCssClass.Base}`);
      break;
    case 'hidden':
      if (includeHidden === true)
        validElements.push(ele);
      break;
    default:
      validElements.push(ele);
  }
  if ((customEle === null || customEle === void 0 ? void 0 : customEle.tagName) !== undefined &&
    validElements.indexOf(customEle) === -1)
    validElements.push(customEle);
  return validElements;
};
const getNormalisedFormElements = (formElements, includeHidden = true) => {
  let validElements = [];
  const len = (formElements === null || formElements === void 0 ? void 0 : formElements.length) || 0;
  for (let i = 0; i < len; i++) {
    const ele = formElements[i];
    validElements = updateValidElements(ele, validElements, includeHidden);
  }
  return validElements;
};
const serializeForm = (form) => {
  const data = {};
  if (form !== null) {
    const formElements = getNormalisedFormElements(form.elements);
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    formElements.forEach((ele) => {
      if ((isValidFormInputElement(ele) &&
        ele.type !== 'checkbox' &&
        ele.type !== 'radio') ||
        ele.checked) {
        data[`${ele.name}`] = ele.value;
      }
    });
  }
  return data;
};
const getErrorSummary = (form, errorMessageTemplates) => {
  const formElements = getNormalisedFormElements(form.elements, false);
  return formElements
    .filter((ele) => {
    var _a;
    const combobox = ele.closest(`.${ComboboxCssClass.Base}`);
    combobox === null || combobox === void 0 ? void 0 : combobox.validate();
    const valid = combobox !== null
      ? combobox.validity.valid
      : (_a = ele) === null || _a === void 0 ? void 0 : _a.validity.valid;
    if (combobox !== null && combobox.validity.valid === false)
      return combobox;
    return isValidFormInputElement(ele) && !valid;
  })
    .map((ele, i) => {
    const combobox = ele.closest(`.${ComboboxCssClass.Base}`);
    const element = combobox ||
      ele;
    const message = getValidationMessage(errorMessageTemplates, element, i);
    return {
      targetId: ele.id || element.name,
      message,
    };
  });
  /* eslint-enable @typescript-eslint/no-explicit-any */
};
const getErrorMessageTemplates = (host) => ({
  [FieldErrorType.BadInput]: host.badInput,
  [FieldErrorType.PatternMismatch]: host.patternMismatch,
  [FieldErrorType.RangeOverflow]: host.rangeOverflow,
  [FieldErrorType.RangeUnderflow]: host.rangeUnderflow,
  [FieldErrorType.StepMismatch]: host.stepMismatch,
  [FieldErrorType.TooLong]: host.tooLong,
  [FieldErrorType.TooShort]: host.tooShort,
  [FieldErrorType.TypeMismatch]: host.typeMismatch,
  [FieldErrorType.ValueMissing]: host.valueMissing,
});

const logAttrRemoval = (attr, el, url) => {
  idsLogger(`${attr} removed from ${el} element.${url ? ` See ${url} for more details` : ``}`, LoggerLevels.Warn);
};
const getAllowedAttrs = (attrs, attrsHelper) => {
  if (attrs) {
    const { tag, attributes } = attrsHelper;
    const { disallowed, specUrl } = attributes;
    if (!disallowed)
      return parseStringifiedObject(attrs);
    const parsedAttrs = parseStringifiedObject(attrs);
    return Object.keys(parsedAttrs)
      .filter((key) => {
      if (disallowed.includes(camelToKebab(key))) {
        logAttrRemoval(key, tag, specUrl);
        return false;
      }
      return true;
    })
      .reduce((obj, key) => {
      return Object.assign(Object.assign({}, obj), { [camelToKebab(key)]: parsedAttrs[key] });
    }, {});
  }
  return null;
};

const formatResult = ({ label, value, meta, prepend, append }, query) => ({
  label: fuzzysort.highlight(fuzzysort.single(query, label)) || label,
  value,
  meta,
  prepend,
  append,
});
const doFuzzySearch = (query, optionsData, resultLimit) => {
  const fsResults = fuzzysort.go(query, optionsData, {
    key: 'label',
    limit: resultLimit,
    threshold: -5000,
  });
  return fsResults.map((result) => formatResult(result.obj, query));
};
const parseWebComponentProp = (prop) => typeof prop !== 'string' ? prop : JSON.parse(prop);
const promiseTimeout = (callback, delay) => {
  const promise = new Promise((resolve) => {
    setTimeout(() => {
      callback();
      resolve();
    }, delay);
  });
  return promise;
};
const getSuffix = (el, tag) => el.tagName.toLowerCase().replace(tag, '');
const sanitizeHTML = (str) => {
  const temp = document.createElement('div');
  temp.textContent = str;
  return temp.innerHTML;
};
const idsLogger = (msg, level = LoggerLevels.Log) => {
  // eslint-disable-next-line
  console[level]('%c IDS ', 'background: #21F5A8; color: #3A1C46; font-weight:bold;', msg);
};
const logHeadingLevelWarning = (component, msg = '') => {
  idsLogger(`${component}: Both headingLevel and headingText must be provided to show a heading. ${msg}`, LoggerLevels.Warn);
};
const validateHeadingProps = (headingText, headingLevel, component) => {
  const valid = headingText !== undefined && headingLevel !== undefined;
  if (!valid && (headingText !== undefined || headingLevel !== undefined)) {
    logHeadingLevelWarning(component);
  }
  return valid;
};
// Used for testing purposes.
const focusOn = (ele) => {
  ele && ele.focus();
};
const focusableElements = (el) => {
  const allowed = 'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
  const focusableContent = el && el.querySelectorAll(allowed);
  return focusableContent;
};
const nativeTestid = (el, id) => {
  const dataAttr = el.getAttribute('data-testid');
  return dataAttr ? `${dataAttr}__${id ? id : 'native'}` : null;
};
const nativeId = (el, suffix) => {
  let hostId = el.getAttribute('id');
  if (hostId && suffix) {
    hostId += `__${suffix}`;
  }
  return hostId ? hostId : null;
};
const hasShadowDom = (el) => {
  return !!el && !!el.shadowRoot && !!el.attachShadow;
};
const getActiveElement = () => {
  const activeEle = document.activeElement;
  if (!hasShadowDom(activeEle))
    return activeEle;
  return activeEle.shadowRoot.activeElement;
};
const focusOnElement = (evt) => {
  const source = evt.currentTarget;
  const targetId = source && source.hasAttribute('href')
    ? source.getAttribute('href').split('#')[1]
    : source.getAttribute('for');
  const target = targetId
    ? querySelectorDeep(`#${targetId}`) ||
      source.closest('form').querySelector(`input[name="${targetId}"]`)
    : null;
  evt.preventDefault();
  if (target) {
    if (!isValidFormInputElement(target) ||
      target.tagName.indexOf('IRESS-') > -1) {
      target.setAttribute('tabIndex', '-1');
      target.focus();
      target.removeAttribute('tabIndex');
    }
    else {
      target.focus();
    }
  }
};
const stringReplacer = (str, replaceArr = []) => {
  let replacedStr = str;
  replaceArr.forEach((replaceObj) => {
    replacedStr = replacedStr.split(replaceObj.name).join(replaceObj.value);
  });
  return replacedStr;
};
const hasFocus = (el) => el ? el.contains(getActiveElement()) : false;
const getResponsiveValuesFromProp = (propValue) => {
  if (typeof propValue === 'string' &&
    (propValue.indexOf('[') !== -1 || propValue.indexOf('{') !== -1)) {
    // String array or object
    return JSON.parse(propValue);
  }
  // Single Value String, Array or Object
  return propValue;
};
const normaliseSizingArray = (responsiveValues) => {
  return {
    xs: responsiveValues.length > 1 ? responsiveValues[0] : null,
    sm: responsiveValues[1] ? responsiveValues[1] : null,
    md: responsiveValues[2] ? responsiveValues[2] : null,
    lg: responsiveValues[3] ? responsiveValues[3] : null,
    xl: responsiveValues[4] ? responsiveValues[4] : null,
  };
};
const cssMapProperty = (baseSelector, value, size, fallback) => {
  if (!value && !fallback)
    return {};
  if (!value && fallback)
    return {
      [`${baseSelector}-${size}--${fallback}`]: true,
    };
  if (size) {
    if (typeof value === 'boolean') {
      return {
        [`${baseSelector}--${size}`]: value,
      };
    }
    return {
      [`${baseSelector}-${size}--${value}`]: !!value,
    };
  }
  return {
    [`${baseSelector}--${value}`]: !!value,
  };
};
const getResponsiveLayoutClasses = (responsiveValues, cssClassEnum, type, fallback) => {
  if (responsiveValues) {
    const baseSelector = cssClassEnum[type];
    // Strings
    if (typeof responsiveValues === 'string') {
      return cssMapProperty(baseSelector, responsiveValues);
    }
    // Arrays
    let sizes = responsiveValues;
    if (Array.isArray(responsiveValues) && responsiveValues.length > 0) {
      idsLogger('Using an array for a responsive property is deprecated. Please use object based syntax instead', LoggerLevels.Warn);
      if (responsiveValues.length === 1) {
        return cssMapProperty(baseSelector, responsiveValues[0]);
      }
      sizes = normaliseSizingArray(responsiveValues);
    }
    // Objects (arrays will be converted to objects by this point)
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, cssMapProperty(baseSelector, sizes.xs, 'xs', fallback)), cssMapProperty(baseSelector, sizes.sm, 'sm')), cssMapProperty(baseSelector, sizes.md, 'md')), cssMapProperty(baseSelector, sizes.lg, 'lg')), cssMapProperty(baseSelector, sizes.xl, 'xl'));
  }
};
const hasSlotContent = (slotName, el, tagName) => {
  const children = Array.from(el.children);
  for (const child of children) {
    const slotAttr = child.getAttribute('slot');
    if (slotAttr !== undefined && slotAttr === slotName) {
      if (tagName)
        return child.tagName.includes(tagName);
      return true;
    }
  }
  return false;
};
const capitalizeFirstLetter = (str) => str[0].toUpperCase() + str.slice(1);
const parseStringifiedObject = (obj) => {
  if (typeof obj === 'string' &&
    (obj.indexOf('{') !== -1 || obj.indexOf('[') !== -1)) {
    return JSON.parse(obj);
  }
  return obj;
};
const camelToText = (txt) => txt
  .replace(/([a-z\d])([A-Z])/g, '$1' + ' ' + '$2')
  .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + ' ' + '$2');
const isCamelCase = (str) => /[A-Z]/.test(str);
const camelToKebab = (string) => string.replace(/([A-Z])/g, (g) => `-${g[0].toLowerCase()}`);
const isNodeElement = (obj) => typeof obj === 'object' &&
  (obj instanceof Node || obj instanceof HTMLElement);
let debounceTimerId;
const debounceFunction = function (func, delay) {
  clearTimeout(debounceTimerId);
  debounceTimerId = setTimeout(func, delay);
};
const checkCSSLengthValue = (val) => {
  if (/^\d+$/.test(val)) {
    return `${val}px`;
  }
  return val;
};
const isCustomFormElement = (ele) => {
  const customFormElements = ['IRESS-CHECKBOX-GROUP', 'IRESS-RADIO-GROUP'];
  return customFormElements.includes(ele.tagName);
};
const normaliseHideValues = (values) => {
  var _a, _b, _c, _d;
  if (typeof values === 'string') {
    values = JSON.parse(values);
  }
  const allValues = { xs: values.xs };
  // If value is undefined, use previous value
  allValues['sm'] = (_a = values.sm) !== null && _a !== void 0 ? _a : allValues.xs;
  allValues['md'] = (_b = values.md) !== null && _b !== void 0 ? _b : allValues['sm'];
  allValues['lg'] = (_c = values.lg) !== null && _c !== void 0 ? _c : allValues['md'];
  allValues['xl'] = (_d = values.xl) !== null && _d !== void 0 ? _d : allValues['lg'];
  return allValues;
};
const normaliseArrayProp = (propValue) => {
  if (typeof propValue === 'string' && propValue[0] === '[') {
    try {
      return JSON.parse(propValue);
    }
    catch (error) {
      return propValue;
    }
  }
  return propValue;
};

export { Menu as $, focusOn as A, ButtonCssClass as B, CheckboxGroupCssClass as C, getResponsiveValuesFromProp as D, idsLogger as E, stringReplacer as F, checkCSSLengthValue as G, querySelectorDeep as H, InlineCssClass as I, isCamelCase as J, camelToText as K, isNodeElement as L, MenuType as M, sanitizeHTML as N, ButtonSlot as O, PopoverSlot as P, createPopper as Q, focusOnElement as R, Button as S, TextVariant as T, Card as U, Checkbox as V, CheckboxGroup as W, Combobox as X, Field as Y, Inline as Z, Input as _, InlineGutter as a, MenuItem as a0, Popover as a1, Radio as a2, RadioGroup as a3, TextElement as a4, TextCssClass as a5, Label as a6, createCommonjsModule as a7, getDefaultExportFromCjs as a8, ButtonType as a9, InlineVerticalAlign as b, capitalizeFirstLetter as c, nativeTestid as d, InputMode as e, InputCssClass as f, getSuffix as g, InputSlot as h, formatResult as i, doFuzzySearch as j, debounceFunction as k, ButtonMode as l, focusableElements as m, normaliseArrayProp as n, PopoverType as o, parseWebComponentProp as p, getErrorSummary as q, hasSlotContent as r, serializeForm as s, ComboboxCssClass as t, updateSelectedOptionsArray as u, validateHeadingProps as v, getErrorMessageTemplates as w, normaliseHideValues as x, getResponsiveLayoutClasses as y, getActiveElement as z };
